export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  /** The `DateTime` scalar type represents a date and time. `DateTime` expects timestamps to be formatted in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  DateTime: { input: any; output: any; }
  /** A custom date time type for localized datetime */
  DateTimeScalarType: { input: any; output: any; }
  Long: { input: any; output: any; }
};

export type Activity = {
  __typename?: 'Activity';
  activityType: ActivityCategory;
  additionalFields?: Maybe<Array<Maybe<KeyValue>>>;
  consumer?: Maybe<IdNameType>;
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  date?: Maybe<Scalars['DateTimeScalarType']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastModificationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  metadata?: Maybe<Array<Maybe<KeyValuePair>>>;
  producer?: Maybe<IdNameType>;
  source?: Maybe<ActivitySource>;
  structureId?: Maybe<Scalars['String']['output']>;
};

export type ActivityActivityActorTypeEnumFilter = {
  field: ActivityActorTypeFilterField;
  filterValue1: ActivityActorType;
  filterValue2?: InputMaybe<ActivityActorType>;
  operator: NumberFilterOperator;
};

export type ActivityActivityCategoryEnumFilter = {
  field: ActivityCategoryFilterField;
  filterValue1: ActivityCategory;
  filterValue2?: InputMaybe<ActivityCategory>;
  operator: NumberFilterOperator;
};

export type ActivityActivitySourceTypeEnumFilter = {
  field: ActivitySourceTypeFilterField;
  filterValue1: ActivitySourceType;
  filterValue2?: InputMaybe<ActivitySourceType>;
  operator: NumberFilterOperator;
};

export enum ActivityActorType {
  Contact = 'CONTACT',
  EmailAddress = 'EMAIL_ADDRESS',
  External = 'EXTERNAL',
  PostalAddress = 'POSTAL_ADDRESS',
  Service = 'SERVICE',
  System = 'SYSTEM',
  TenantUser = 'TENANT_USER',
  ThirdParty = 'THIRD_PARTY'
}

export enum ActivityActorTypeFilterField {
  ConsumerType = 'CONSUMER_TYPE',
  ProducerType = 'PRODUCER_TYPE'
}

export enum ActivityCategory {
  ChorusB_2GCompleted = 'CHORUS_B_2_G_COMPLETED',
  ChorusB_2GSent = 'CHORUS_B_2_G_SENT',
  ChorusB_2GStatusChanged = 'CHORUS_B_2_G_STATUS_CHANGED',
  DocumentArchived = 'DOCUMENT_ARCHIVED',
  DocumentAttachmentsAdded = 'DOCUMENT_ATTACHMENTS_ADDED',
  DocumentCanceled = 'DOCUMENT_CANCELED',
  DocumentConverted = 'DOCUMENT_CONVERTED',
  DocumentCreated = 'DOCUMENT_CREATED',
  DocumentMetadataEdited = 'DOCUMENT_METADATA_EDITED',
  DocumentRead = 'DOCUMENT_READ',
  DocumentReadableReady = 'DOCUMENT_READABLE_READY',
  DocumentRecipientAdded = 'DOCUMENT_RECIPIENT_ADDED',
  DocumentRemoved = 'DOCUMENT_REMOVED',
  DocumentSigned = 'DOCUMENT_SIGNED',
  DocumentSigningSkipped = 'DOCUMENT_SIGNING_SKIPPED',
  DocumentStatusChanged = 'DOCUMENT_STATUS_CHANGED',
  DocumentValidated = 'DOCUMENT_VALIDATED',
  DocumentWaitingArchive = 'DOCUMENT_WAITING_ARCHIVE',
  Error = 'ERROR',
  ExternalProcess = 'EXTERNAL_PROCESS',
  JobActionCancelled = 'JOB_ACTION_CANCELLED',
  JobActionRelaunched = 'JOB_ACTION_RELAUNCHED',
  JobCompleted = 'JOB_COMPLETED',
  JobCreated = 'JOB_CREATED',
  JobLaunched = 'JOB_LAUNCHED',
  JobMessageCanceled = 'JOB_MESSAGE_CANCELED',
  JobMessageRelaunched = 'JOB_MESSAGE_RELAUNCHED',
  JobPreProcessed = 'JOB_PRE_PROCESSED',
  JobProcessing = 'JOB_PROCESSING',
  NotificationSent = 'NOTIFICATION_SENT',
  NumeriaPostalSent = 'NUMERIA_POSTAL_SENT',
  NumeriaPostalStatusChanged = 'NUMERIA_POSTAL_STATUS_CHANGED',
  PdpReceived = 'PDP_RECEIVED',
  PdpSent = 'PDP_SENT',
  PdpStatusChanged = 'PDP_STATUS_CHANGED',
  PeppolReceived = 'PEPPOL_RECEIVED',
  PeppolSent = 'PEPPOL_SENT',
  PeppolStatusChanged = 'PEPPOL_STATUS_CHANGED',
  PpfSent = 'PPF_SENT',
  PpfStatusChanged = 'PPF_STATUS_CHANGED',
  Routing = 'ROUTING',
  Unknown = 'UNKNOWN'
}

export enum ActivityCategoryFilterField {
  ActivityType = 'ACTIVITY_TYPE'
}

export type ActivityDateFilter = {
  field: ActivityDateFilterField;
  filterValue1?: InputMaybe<Scalars['DateTime']['input']>;
  filterValue2?: InputMaybe<Scalars['DateTime']['input']>;
  operator: NumberFilterOperator;
};

export enum ActivityDateFilterField {
  Date = 'DATE'
}

export type ActivityQueryParams = {
  activityTypeFilters?: InputMaybe<Array<InputMaybe<ActivityActivityCategoryEnumFilter>>>;
  actorTypeFilters?: InputMaybe<Array<InputMaybe<ActivityActivityActorTypeEnumFilter>>>;
  dateFilters?: InputMaybe<Array<InputMaybe<ActivityDateFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<ActivitySortField>;
  sourceTypeFilters?: InputMaybe<Array<InputMaybe<ActivityActivitySourceTypeEnumFilter>>>;
  stringFilters?: InputMaybe<Array<InputMaybe<ActivityStringFilter>>>;
};

export enum ActivitySortField {
  ActivityType = 'ACTIVITY_TYPE',
  Consumer = 'CONSUMER',
  ContactSourceName = 'CONTACT_SOURCE_NAME',
  Date = 'DATE',
  Detail = 'DETAIL',
  DocumentSourceName = 'DOCUMENT_SOURCE_NAME',
  JobMessageSourceName = 'JOB_MESSAGE_SOURCE_NAME',
  JobSourceName = 'JOB_SOURCE_NAME',
  Producer = 'PRODUCER',
  TenantSourceName = 'TENANT_SOURCE_NAME',
  TenantUserSourceName = 'TENANT_USER_SOURCE_NAME',
  ThirdPartySourceName = 'THIRD_PARTY_SOURCE_NAME'
}

export type ActivitySource = {
  __typename?: 'ActivitySource';
  contact?: Maybe<IdName>;
  document?: Maybe<IdName>;
  job?: Maybe<IdName>;
  jobMessage?: Maybe<IdName>;
  tenant?: Maybe<IdName>;
  tenantUser?: Maybe<IdName>;
  thirdParty?: Maybe<IdName>;
};

export enum ActivitySourceType {
  Contact = 'CONTACT',
  Document = 'DOCUMENT',
  Job = 'JOB',
  JobMessage = 'JOB_MESSAGE',
  Tenant = 'TENANT',
  TenantUser = 'TENANT_USER',
  ThirdParty = 'THIRD_PARTY'
}

export enum ActivitySourceTypeFilterField {
  SourceType = 'SOURCE_TYPE'
}

export type ActivityStringFilter = {
  field: ActivityStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum ActivityStringFilterField {
  ConsumerId = 'CONSUMER_ID',
  ConsumerName = 'CONSUMER_NAME',
  ContactSourceId = 'CONTACT_SOURCE_ID',
  ContactSourceName = 'CONTACT_SOURCE_NAME',
  DocumentSourceId = 'DOCUMENT_SOURCE_ID',
  DocumentSourceName = 'DOCUMENT_SOURCE_NAME',
  JobMessageSourceId = 'JOB_MESSAGE_SOURCE_ID',
  JobMessageSourceName = 'JOB_MESSAGE_SOURCE_NAME',
  JobSourceId = 'JOB_SOURCE_ID',
  JobSourceName = 'JOB_SOURCE_NAME',
  ProducerId = 'PRODUCER_ID',
  ProducerName = 'PRODUCER_NAME',
  StructureId = 'STRUCTURE_ID',
  TenantSourceId = 'TENANT_SOURCE_ID',
  TenantSourceName = 'TENANT_SOURCE_NAME',
  TenantUserSourceId = 'TENANT_USER_SOURCE_ID',
  TenantUserSourceName = 'TENANT_USER_SOURCE_NAME',
  ThirdPartySourceId = 'THIRD_PARTY_SOURCE_ID',
  ThirdPartySourceName = 'THIRD_PARTY_SOURCE_NAME'
}

export type ActivityTypeConnection = {
  __typename?: 'ActivityTypeConnection';
  edges?: Maybe<Array<Maybe<Activity>>>;
  pageInfo?: Maybe<PageInfo>;
};

export enum ApiAuthenticationType {
  ApiKey = 'API_KEY',
  OAuth_2 = 'O_AUTH_2'
}

export type ApiDomainUser = {
  __typename?: 'ApiDomainUser';
  authenticationType: ApiAuthenticationType;
  authorizedIPs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  creationUserLabel?: Maybe<Scalars['String']['output']>;
  culture?: Maybe<Scalars['String']['output']>;
  domainId: Scalars['String']['output'];
  domainName: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  keyPreview: Scalars['String']['output'];
  lastConnectionDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationUserId?: Maybe<Scalars['String']['output']>;
  lastModificationUserLabel?: Maybe<Scalars['String']['output']>;
  linkedOrganizations?: Maybe<Array<Maybe<LinkedOrganization>>>;
  name: Scalars['String']['output'];
  profile?: Maybe<UserProfile>;
};

export type ApiDomainUserBoolFilter = {
  field: ApiDomainUserBoolFilterField;
  filterValue1: Scalars['Boolean']['input'];
  operator: BoolFilterOperator;
};

export enum ApiDomainUserBoolFilterField {
  IsEnabled = 'IS_ENABLED'
}

export type ApiDomainUserDateFilter = {
  field: ApiDomainUserDateFilterField;
  filterValue1?: InputMaybe<Scalars['DateTime']['input']>;
  filterValue2?: InputMaybe<Scalars['DateTime']['input']>;
  operator: NumberFilterOperator;
};

export enum ApiDomainUserDateFilterField {
  CreationDate = 'CREATION_DATE',
  LastConnectionDate = 'LAST_CONNECTION_DATE'
}

export type ApiDomainUserInput = {
  authenticationType?: InputMaybe<ApiAuthenticationType>;
  authorizedIPs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  culture?: InputMaybe<Scalars['String']['input']>;
  domainId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  linkedOrganizations?: InputMaybe<Array<InputMaybe<LinkedOrganizationInput>>>;
  name: Scalars['String']['input'];
  profile?: InputMaybe<UserProfile>;
};

export type ApiDomainUserQueryParams = {
  boolFilters?: InputMaybe<Array<InputMaybe<ApiDomainUserBoolFilter>>>;
  dateFilters?: InputMaybe<Array<InputMaybe<ApiDomainUserDateFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<ApiDomainUserSortField>;
  stringFilters?: InputMaybe<Array<InputMaybe<ApiDomainUserStringFilter>>>;
};

export enum ApiDomainUserSortField {
  CreationDate = 'CREATION_DATE',
  CreationUserLabel = 'CREATION_USER_LABEL',
  DomainId = 'DOMAIN_ID',
  IsEnabled = 'IS_ENABLED',
  LastConnectionDate = 'LAST_CONNECTION_DATE',
  Name = 'NAME'
}

export type ApiDomainUserStringFilter = {
  field: ApiDomainUserStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum ApiDomainUserStringFilterField {
  CreationUserId = 'CREATION_USER_ID',
  CreationUserLabel = 'CREATION_USER_LABEL',
  DomainId = 'DOMAIN_ID',
  Name = 'NAME'
}

export type ApiDomainUserTypeConnection = {
  __typename?: 'ApiDomainUserTypeConnection';
  edges?: Maybe<Array<Maybe<ApiDomainUser>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type ApiEnvironmentUser = {
  __typename?: 'ApiEnvironmentUser';
  authenticationType: ApiAuthenticationType;
  authorizedIPs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  creationUserLabel?: Maybe<Scalars['String']['output']>;
  culture?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  keyPreview: Scalars['String']['output'];
  lastConnectionDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationUserId?: Maybe<Scalars['String']['output']>;
  lastModificationUserLabel?: Maybe<Scalars['String']['output']>;
  linkedOrganizations?: Maybe<Array<Maybe<LinkedOrganization>>>;
  name: Scalars['String']['output'];
};

export type ApiEnvironmentUserBoolFilter = {
  field: ApiEnvironmentUserBoolFilterField;
  filterValue1: Scalars['Boolean']['input'];
  operator: BoolFilterOperator;
};

export enum ApiEnvironmentUserBoolFilterField {
  IsEnabled = 'IS_ENABLED'
}

export type ApiEnvironmentUserDateFilter = {
  field: ApiEnvironmentUserDateFilterField;
  filterValue1?: InputMaybe<Scalars['DateTime']['input']>;
  filterValue2?: InputMaybe<Scalars['DateTime']['input']>;
  operator: NumberFilterOperator;
};

export enum ApiEnvironmentUserDateFilterField {
  CreationDate = 'CREATION_DATE',
  LastConnectionDate = 'LAST_CONNECTION_DATE'
}

export type ApiEnvironmentUserInput = {
  authenticationType?: InputMaybe<ApiAuthenticationType>;
  authorizedIPs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  culture?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  linkedOrganizations?: InputMaybe<Array<InputMaybe<LinkedOrganizationInput>>>;
  name: Scalars['String']['input'];
};

export type ApiEnvironmentUserQueryParams = {
  boolFilters?: InputMaybe<Array<InputMaybe<ApiEnvironmentUserBoolFilter>>>;
  dateFilters?: InputMaybe<Array<InputMaybe<ApiEnvironmentUserDateFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<ApiEnvironmentUserSortField>;
  stringFilters?: InputMaybe<Array<InputMaybe<ApiEnvironmentUserStringFilter>>>;
};

export enum ApiEnvironmentUserSortField {
  CreationDate = 'CREATION_DATE',
  CreationUserLabel = 'CREATION_USER_LABEL',
  IsEnabled = 'IS_ENABLED',
  LastConnectionDate = 'LAST_CONNECTION_DATE',
  Name = 'NAME'
}

export type ApiEnvironmentUserStringFilter = {
  field: ApiEnvironmentUserStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum ApiEnvironmentUserStringFilterField {
  CreationUserId = 'CREATION_USER_ID',
  CreationUserLabel = 'CREATION_USER_LABEL',
  Name = 'NAME'
}

export type ApiEnvironmentUserTypeConnection = {
  __typename?: 'ApiEnvironmentUserTypeConnection';
  edges?: Maybe<Array<Maybe<ApiEnvironmentUser>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type ApiRoutingConfiguration = {
  __typename?: 'ApiRoutingConfiguration';
  action: Scalars['String']['output'];
  isAsync: Scalars['Boolean']['output'];
  parameters?: Maybe<Array<Maybe<KeyValuePair>>>;
  type: Scalars['String']['output'];
};

export type ApiRoutingConfigurationInput = {
  action: Scalars['String']['input'];
  isAsync: Scalars['Boolean']['input'];
  parameters?: InputMaybe<Array<InputMaybe<KeyValuePairInput>>>;
  type: Scalars['String']['input'];
};

export type ApiTenantUser = {
  __typename?: 'ApiTenantUser';
  authenticationType: ApiAuthenticationType;
  authorizedIPs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  creationUserLabel?: Maybe<Scalars['String']['output']>;
  culture?: Maybe<Scalars['String']['output']>;
  domainId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  keyPreview: Scalars['String']['output'];
  lastConnectionDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationUserId?: Maybe<Scalars['String']['output']>;
  lastModificationUserLabel?: Maybe<Scalars['String']['output']>;
  linkedOrganizations?: Maybe<Array<Maybe<LinkedOrganization>>>;
  name: Scalars['String']['output'];
  profile?: Maybe<UserProfile>;
  structureId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
};

export type ApiTenantUserBoolFilter = {
  field: ApiTenantUserBoolFilterField;
  filterValue1: Scalars['Boolean']['input'];
  operator: BoolFilterOperator;
};

export enum ApiTenantUserBoolFilterField {
  IsEnabled = 'IS_ENABLED'
}

export type ApiTenantUserDateFilter = {
  field: ApiTenantUserDateFilterField;
  filterValue1?: InputMaybe<Scalars['DateTime']['input']>;
  filterValue2?: InputMaybe<Scalars['DateTime']['input']>;
  operator: NumberFilterOperator;
};

export enum ApiTenantUserDateFilterField {
  CreationDate = 'CREATION_DATE',
  LastConnectionDate = 'LAST_CONNECTION_DATE'
}

export type ApiTenantUserInput = {
  authenticationType?: InputMaybe<ApiAuthenticationType>;
  authorizedIPs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  culture?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  linkedOrganizations?: InputMaybe<Array<InputMaybe<LinkedOrganizationInput>>>;
  name: Scalars['String']['input'];
  profile?: InputMaybe<UserProfile>;
  structureId?: InputMaybe<Scalars['String']['input']>;
};

export type ApiTenantUserQueryParams = {
  boolFilters?: InputMaybe<Array<InputMaybe<ApiTenantUserBoolFilter>>>;
  dateFilters?: InputMaybe<Array<InputMaybe<ApiTenantUserDateFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<ApiTenantUserSortField>;
  stringFilters?: InputMaybe<Array<InputMaybe<ApiTenantUserStringFilter>>>;
};

export enum ApiTenantUserSortField {
  CreationDate = 'CREATION_DATE',
  CreationUserLabel = 'CREATION_USER_LABEL',
  IsEnabled = 'IS_ENABLED',
  LastConnectionDate = 'LAST_CONNECTION_DATE',
  Name = 'NAME',
  TenantId = 'TENANT_ID'
}

export type ApiTenantUserStringFilter = {
  field: ApiTenantUserStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum ApiTenantUserStringFilterField {
  CreationUserId = 'CREATION_USER_ID',
  CreationUserLabel = 'CREATION_USER_LABEL',
  Name = 'NAME',
  StructureId = 'STRUCTURE_ID',
  TenantId = 'TENANT_ID'
}

export type ApiTenantUserTypeConnection = {
  __typename?: 'ApiTenantUserTypeConnection';
  edges?: Maybe<Array<Maybe<ApiTenantUser>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type ArchiveConfiguration = {
  __typename?: 'ArchiveConfiguration';
  archiveMetadata: Scalars['Boolean']['output'];
  billingMode: ArchiveConfigurationBillingMode;
  durationInMonth: Scalars['Int']['output'];
  provider: ArchiverProvider;
};

export enum ArchiveConfigurationBillingMode {
  Files = 'FILES',
  Giga = 'GIGA'
}

export type ArchiveConfigurationInput = {
  archiveMetadata: Scalars['Boolean']['input'];
  billingMode: ArchiveConfigurationBillingMode;
  durationInMonth: Scalars['Int']['input'];
  provider: ArchiverProvider;
};

export enum ArchiverProvider {
  Docoon = 'DOCOON',
  None = 'NONE',
  Xelians = 'XELIANS'
}

export enum ArrayElementFilterOperator {
  Between = 'BETWEEN',
  Contain = 'CONTAIN',
  Defined = 'DEFINED',
  EndWith = 'END_WITH',
  Equal = 'EQUAL',
  EqualOrUndefined = 'EQUAL_OR_UNDEFINED',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  InArray = 'IN_ARRAY',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  LowerThan = 'LOWER_THAN',
  LowerThanOrEqual = 'LOWER_THAN_OR_EQUAL',
  NotContain = 'NOT_CONTAIN',
  NotEndWith = 'NOT_END_WITH',
  NotEqual = 'NOT_EQUAL',
  NotStartWith = 'NOT_START_WITH',
  StartWith = 'START_WITH',
  Undefined = 'UNDEFINED'
}

export type AttachmentInput = {
  existingDocumentId?: InputMaybe<Scalars['String']['input']>;
  newDocument?: InputMaybe<DocumentInput>;
};

export type AuthorizedStatus = {
  __typename?: 'AuthorizedStatus';
  availableTransitions?: Maybe<Array<Maybe<AuthorizedStatusTarget>>>;
  currentStatus?: Maybe<AuthorizedStatusCode>;
};

export type AuthorizedStatusCode = {
  __typename?: 'AuthorizedStatusCode';
  code: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type AuthorizedStatusCodeInput = {
  code: Scalars['Int']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorizedStatusTarget = {
  __typename?: 'AuthorizedStatusTarget';
  parameters?: Maybe<Array<Maybe<WorkflowParameter>>>;
  target?: Maybe<AuthorizedStatusCode>;
};

export type AuthorizedStatusTargetInput = {
  parameters?: InputMaybe<Array<InputMaybe<DocumentTransitionStatusParametersInput>>>;
  target?: InputMaybe<AuthorizedStatusCodeInput>;
};

export enum BoolFilterOperator {
  Defined = 'DEFINED',
  Equal = 'EQUAL',
  EqualOrUndefined = 'EQUAL_OR_UNDEFINED',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  NotEqual = 'NOT_EQUAL',
  Undefined = 'UNDEFINED'
}

export type BusinessConfiguration = {
  __typename?: 'BusinessConfiguration';
  ancestorDomainIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  code: Scalars['String']['output'];
  configValues?: Maybe<Array<Maybe<KeyValuePair>>>;
  creationDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  domainId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  lastModificationDate: Scalars['DateTime']['output'];
  legalEntityId?: Maybe<Scalars['String']['output']>;
  nature?: Maybe<Nature>;
  natureId?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  ownerType: InheritedConfigurationOwnerType;
  serviceId?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  structureId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
};

export type BusinessConfigurationBoolFilter = {
  field: BusinessConfigurationBoolFilterField;
  filterValue1: Scalars['Boolean']['input'];
  operator: BoolFilterOperator;
};

export enum BusinessConfigurationBoolFilterField {
  IsEnabled = 'IS_ENABLED'
}

export type BusinessConfigurationInheritedConfigurationOwnerTypeEnumFilter = {
  field: BusinessConfigurationOwnerTypeFilterField;
  filterValue1: InheritedConfigurationOwnerType;
  filterValue2?: InputMaybe<InheritedConfigurationOwnerType>;
  operator: NumberFilterOperator;
};

export type BusinessConfigurationInput = {
  ancestorDomainIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code: Scalars['String']['input'];
  configValues?: InputMaybe<Array<InputMaybe<KeyValuePairInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  natureId?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  ownerType: InheritedConfigurationOwnerType;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
};

export enum BusinessConfigurationOwnerTypeFilterField {
  OwnerType = 'OWNER_TYPE'
}

export type BusinessConfigurationQueryParams = {
  boolFilters?: InputMaybe<Array<InputMaybe<BusinessConfigurationBoolFilter>>>;
  ownerTypeFilters?: InputMaybe<Array<InputMaybe<BusinessConfigurationInheritedConfigurationOwnerTypeEnumFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<BusinessConfigurationSortField>;
  stringFilters?: InputMaybe<Array<InputMaybe<BusinessConfigurationStringFilter>>>;
};

export enum BusinessConfigurationSortField {
  CreationDate = 'CREATION_DATE',
  LastModificationDate = 'LAST_MODIFICATION_DATE',
  OwnerId = 'OWNER_ID',
  OwnerType = 'OWNER_TYPE',
  ShortDescription = 'SHORT_DESCRIPTION'
}

export type BusinessConfigurationStringFilter = {
  field: BusinessConfigurationStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum BusinessConfigurationStringFilterField {
  Code = 'CODE',
  OwnerId = 'OWNER_ID',
  ShortDescription = 'SHORT_DESCRIPTION'
}

export type BusinessConfigurationTypeConnection = {
  __typename?: 'BusinessConfigurationTypeConnection';
  edges?: Maybe<Array<Maybe<BusinessConfiguration>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type BusinessSchemaMutation = {
  __typename?: 'BusinessSchemaMutation';
  addApiDomainUser?: Maybe<ApiDomainUser>;
  addApiEnvironmentUser?: Maybe<ApiEnvironmentUser>;
  addApiTenantUser?: Maybe<ApiTenantUser>;
  addBusinessConfiguration?: Maybe<BusinessConfiguration>;
  addContact?: Maybe<Contact>;
  addContactFunction?: Maybe<ContactFunction>;
  addDashboardRight?: Maybe<DashboardRight>;
  addDataFileAction?: Maybe<JobCreationResult>;
  addDocumentJob?: Maybe<JobCreationResult>;
  addDocumentProbativeJob?: Maybe<JobCreationResult>;
  addDocumentType?: Maybe<DocumentType>;
  addDocumentTypeMetadata?: Maybe<DocumentType>;
  addDomainUser?: Maybe<DomainUser>;
  addEmailJob?: Maybe<JobResult>;
  addEnvironmentUser?: Maybe<EnvironmentUser>;
  addFaxJob?: Maybe<JobResult>;
  addHostedDocumentFile?: Maybe<FileContent>;
  addHostedListFile?: Maybe<FileContent>;
  addIncomingEmailHistory?: Maybe<IncomingEmailHistory>;
  addNote?: Maybe<Note>;
  addPostalJob?: Maybe<JobCreationResult>;
  addPowerBiAuthToken?: Maybe<PowerBiAuthToken>;
  addPushJob?: Maybe<JobResult>;
  addRoutingConfiguration?: Maybe<RoutingConfiguration>;
  addService?: Maybe<Service>;
  addSmsJob?: Maybe<JobResult>;
  addTemplateContent?: Maybe<TemplateContent>;
  addTemplateStructure?: Maybe<TemplateStructure>;
  addTemporaryDocumentFile?: Maybe<Scalars['String']['output']>;
  addTenantUser?: Maybe<TenantUser>;
  addThirdParty?: Maybe<ThirdParty>;
  addThirdPartyType?: Maybe<ThirdPartyType>;
  addVoiceJob?: Maybe<JobResult>;
  deleteBusinessConfiguration?: Maybe<Scalars['Boolean']['output']>;
  deleteContact?: Maybe<Scalars['Boolean']['output']>;
  deleteContactFunction?: Maybe<Scalars['Boolean']['output']>;
  deleteDashboardRight?: Maybe<Scalars['Boolean']['output']>;
  deleteDocumentType?: Maybe<Scalars['Boolean']['output']>;
  deleteDocumentTypeMetadata?: Maybe<Scalars['Boolean']['output']>;
  deleteHostedDocumentFile?: Maybe<Scalars['Boolean']['output']>;
  deleteHostedInboundFile?: Maybe<Scalars['Boolean']['output']>;
  deleteHostedListFile?: Maybe<Scalars['Boolean']['output']>;
  deleteHostedReportFile?: Maybe<Scalars['Boolean']['output']>;
  deleteIncomingEmailHistory?: Maybe<Scalars['Boolean']['output']>;
  deleteNote?: Maybe<Scalars['Boolean']['output']>;
  deleteRoutingConfiguration?: Maybe<Scalars['Boolean']['output']>;
  deleteService?: Maybe<Scalars['Boolean']['output']>;
  deleteTemplateContent?: Maybe<Scalars['Boolean']['output']>;
  deleteTemplateStructure?: Maybe<Scalars['Boolean']['output']>;
  deleteThirdParty?: Maybe<Scalars['Boolean']['output']>;
  deleteThirdPartyType?: Maybe<Scalars['Boolean']['output']>;
  editApiDomainUser?: Maybe<ApiDomainUser>;
  editApiDomainUserRight?: Maybe<Array<DomainRightValue>>;
  editApiEnvironmentUser?: Maybe<ApiEnvironmentUser>;
  editApiEnvironmentUserRight?: Maybe<Array<EnvironmentRightValue>>;
  editApiTenantUser?: Maybe<ApiTenantUser>;
  editApiTenantUserRight?: Maybe<Array<TenantRightValue>>;
  editBusinessConfiguration?: Maybe<BusinessConfiguration>;
  editContact?: Maybe<Contact>;
  editContactFunction?: Maybe<ContactFunction>;
  editDocumentType?: Maybe<DocumentType>;
  editDocumentTypeMetadata?: Maybe<DocumentType>;
  editDomainUser?: Maybe<DomainUser>;
  editDomainUserRight?: Maybe<Array<DomainRightValue>>;
  editEnvironmentUser?: Maybe<EnvironmentUser>;
  editEnvironmentUserRight?: Maybe<Array<EnvironmentRightValue>>;
  editErrorQueueMessage?: Maybe<ErrorQueueMessage>;
  editIncomingEmailHistory?: Maybe<IncomingEmailHistory>;
  editNote?: Maybe<Note>;
  editRoutingConfiguration?: Maybe<RoutingConfiguration>;
  editService?: Maybe<Service>;
  editTemplateContent?: Maybe<TemplateContent>;
  editTemplateStructure?: Maybe<TemplateStructure>;
  editTenantUser?: Maybe<TenantUser>;
  editTenantUserRight?: Maybe<Array<TenantRightValue>>;
  editThirdParty?: Maybe<ThirdParty>;
  editThirdPartyType?: Maybe<ThirdPartyType>;
  getAuthorizedTransitions?: Maybe<AuthorizedStatus>;
  readDocument?: Maybe<Scalars['Boolean']['output']>;
  relaunchJobMessage?: Maybe<Scalars['Boolean']['output']>;
  renewApiDomainUser?: Maybe<ApiDomainUser>;
  renewApiEnvironmentUser?: Maybe<ApiEnvironmentUser>;
  renewApiTenantUser?: Maybe<ApiTenantUser>;
  resendInviteDomainUser?: Maybe<Scalars['Boolean']['output']>;
  resendInviteEnvironmentUser?: Maybe<Scalars['Boolean']['output']>;
  resendInviteTenantUser?: Maybe<Scalars['Boolean']['output']>;
  runActionOnDocument?: Maybe<Scalars['BigInt']['output']>;
  runActionOnJob?: Maybe<Scalars['BigInt']['output']>;
  runActionOnJobMessage?: Maybe<Scalars['BigInt']['output']>;
  togglePurgeFreezeDocument?: Maybe<Scalars['BigInt']['output']>;
  transitionDocumentStatus?: Maybe<TransitionStatusResponse>;
  validateDomainUser?: Maybe<DomainUser>;
  validateEnvironmentUser?: Maybe<EnvironmentUser>;
  validateTenantUser?: Maybe<TenantUser>;
};


export type BusinessSchemaMutationAddApiDomainUserArgs = {
  item: ApiDomainUserInput;
};


export type BusinessSchemaMutationAddApiEnvironmentUserArgs = {
  item: ApiEnvironmentUserInput;
};


export type BusinessSchemaMutationAddApiTenantUserArgs = {
  item: ApiTenantUserInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddBusinessConfigurationArgs = {
  item: BusinessConfigurationInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddContactArgs = {
  item: ContactInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddContactFunctionArgs = {
  item: ContactFunctionInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddDashboardRightArgs = {
  item: DashboardRightInput;
};


export type BusinessSchemaMutationAddDataFileActionArgs = {
  item: DataFileActionInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddDocumentJobArgs = {
  item: DocumentJobInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddDocumentProbativeJobArgs = {
  item: DocumentProbativeJobInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddDocumentTypeArgs = {
  item: DocumentTypeInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddDocumentTypeMetadataArgs = {
  documentTypeId: Scalars['String']['input'];
  item: MetadataConfigInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddDomainUserArgs = {
  item: DomainUserInput;
};


export type BusinessSchemaMutationAddEmailJobArgs = {
  item: EmailJob;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddEnvironmentUserArgs = {
  item: EnvironmentUserInput;
};


export type BusinessSchemaMutationAddFaxJobArgs = {
  item: FaxJob;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddHostedDocumentFileArgs = {
  item: FileContentInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddHostedListFileArgs = {
  item: FileContentInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddIncomingEmailHistoryArgs = {
  item: IncomingEmailHistoryInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddNoteArgs = {
  item: NoteInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddPostalJobArgs = {
  item: PostalJobInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddPowerBiAuthTokenArgs = {
  id: Scalars['String']['input'];
};


export type BusinessSchemaMutationAddPushJobArgs = {
  item: PushJob;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddRoutingConfigurationArgs = {
  item: RoutingConfigurationInput;
};


export type BusinessSchemaMutationAddServiceArgs = {
  item: ServiceInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddSmsJobArgs = {
  item: SmsJob;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddTemplateContentArgs = {
  item: TemplateContentInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddTemplateStructureArgs = {
  item: TemplateStructureInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddTemporaryDocumentFileArgs = {
  item: TemporaryDocumentFileInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddTenantUserArgs = {
  item: TenantUserInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddThirdPartyArgs = {
  item: ThirdPartyInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddThirdPartyTypeArgs = {
  item: ThirdPartyTypeInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationAddVoiceJobArgs = {
  item: VoiceJob;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationDeleteBusinessConfigurationArgs = {
  id: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationDeleteContactArgs = {
  id: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationDeleteContactFunctionArgs = {
  id: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationDeleteDashboardRightArgs = {
  id: Scalars['String']['input'];
};


export type BusinessSchemaMutationDeleteDocumentTypeArgs = {
  id: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationDeleteDocumentTypeMetadataArgs = {
  code: Scalars['String']['input'];
  documentTypeId: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationDeleteHostedDocumentFileArgs = {
  id: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationDeleteHostedInboundFileArgs = {
  id: Scalars['String']['input'];
  inboundFolder: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationDeleteHostedListFileArgs = {
  id: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationDeleteHostedReportFileArgs = {
  id: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationDeleteIncomingEmailHistoryArgs = {
  id: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationDeleteNoteArgs = {
  id: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationDeleteRoutingConfigurationArgs = {
  id: Scalars['String']['input'];
};


export type BusinessSchemaMutationDeleteServiceArgs = {
  id: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationDeleteTemplateContentArgs = {
  id: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationDeleteTemplateStructureArgs = {
  id: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationDeleteThirdPartyArgs = {
  id: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationDeleteThirdPartyTypeArgs = {
  id: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationEditApiDomainUserArgs = {
  id: Scalars['String']['input'];
  item: ApiDomainUserInput;
};


export type BusinessSchemaMutationEditApiDomainUserRightArgs = {
  apiUserId: Scalars['String']['input'];
  item?: InputMaybe<Array<DomainRightValueInput>>;
};


export type BusinessSchemaMutationEditApiEnvironmentUserArgs = {
  id: Scalars['String']['input'];
  item: ApiEnvironmentUserInput;
};


export type BusinessSchemaMutationEditApiEnvironmentUserRightArgs = {
  apiUserId: Scalars['String']['input'];
  item?: InputMaybe<Array<EnvironmentRightValueInput>>;
};


export type BusinessSchemaMutationEditApiTenantUserArgs = {
  id: Scalars['String']['input'];
  item: ApiTenantUserInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationEditApiTenantUserRightArgs = {
  apiUserId: Scalars['String']['input'];
  item?: InputMaybe<Array<TenantRightValueInput>>;
};


export type BusinessSchemaMutationEditBusinessConfigurationArgs = {
  id: Scalars['String']['input'];
  item: BusinessConfigurationInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationEditContactArgs = {
  id: Scalars['String']['input'];
  item: ContactInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationEditContactFunctionArgs = {
  id: Scalars['String']['input'];
  item: ContactFunctionInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationEditDocumentTypeArgs = {
  id: Scalars['String']['input'];
  item: DocumentTypeInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationEditDocumentTypeMetadataArgs = {
  code: Scalars['String']['input'];
  documentTypeId: Scalars['String']['input'];
  item: MetadataConfigInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationEditDomainUserArgs = {
  id: Scalars['String']['input'];
  item: DomainUserInput;
};


export type BusinessSchemaMutationEditDomainUserRightArgs = {
  domainUserId: Scalars['String']['input'];
  item?: InputMaybe<Array<DomainRightValueInput>>;
};


export type BusinessSchemaMutationEditEnvironmentUserArgs = {
  id: Scalars['String']['input'];
  item: EnvironmentUserInput;
};


export type BusinessSchemaMutationEditEnvironmentUserRightArgs = {
  environmentUserId: Scalars['String']['input'];
  item?: InputMaybe<Array<EnvironmentRightValueInput>>;
};


export type BusinessSchemaMutationEditErrorQueueMessageArgs = {
  id: Scalars['String']['input'];
  item: ErrorQueueMessageInput;
};


export type BusinessSchemaMutationEditIncomingEmailHistoryArgs = {
  id: Scalars['String']['input'];
  item: IncomingEmailHistoryInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationEditNoteArgs = {
  id: Scalars['String']['input'];
  item: NoteInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationEditRoutingConfigurationArgs = {
  id: Scalars['String']['input'];
  item: RoutingConfigurationInput;
};


export type BusinessSchemaMutationEditServiceArgs = {
  id: Scalars['String']['input'];
  item: ServiceInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationEditTemplateContentArgs = {
  id: Scalars['String']['input'];
  item: TemplateContentInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationEditTemplateStructureArgs = {
  id: Scalars['String']['input'];
  item: TemplateStructureInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationEditTenantUserArgs = {
  id: Scalars['String']['input'];
  item: TenantUserInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationEditTenantUserRightArgs = {
  item?: InputMaybe<Array<TenantRightValueInput>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantUserId: Scalars['String']['input'];
};


export type BusinessSchemaMutationEditThirdPartyArgs = {
  id: Scalars['String']['input'];
  item: ThirdPartyInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationEditThirdPartyTypeArgs = {
  id: Scalars['String']['input'];
  item: ThirdPartyTypeInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationGetAuthorizedTransitionsArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  documentId: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationReadDocumentArgs = {
  documentId: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
  jobMessageId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type BusinessSchemaMutationRelaunchJobMessageArgs = {
  item: RelaunchJobMessageOptionsInput;
};


export type BusinessSchemaMutationRenewApiDomainUserArgs = {
  id: Scalars['String']['input'];
};


export type BusinessSchemaMutationRenewApiEnvironmentUserArgs = {
  id: Scalars['String']['input'];
};


export type BusinessSchemaMutationRenewApiTenantUserArgs = {
  id: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationResendInviteDomainUserArgs = {
  id: Scalars['String']['input'];
};


export type BusinessSchemaMutationResendInviteEnvironmentUserArgs = {
  id: Scalars['String']['input'];
};


export type BusinessSchemaMutationResendInviteTenantUserArgs = {
  id: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationRunActionOnDocumentArgs = {
  documentId: Scalars['String']['input'];
  options: DocumentActionOptions;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationRunActionOnJobArgs = {
  jobId: Scalars['String']['input'];
  options: JobActionOptions;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationRunActionOnJobMessageArgs = {
  jobMessageId: Scalars['String']['input'];
  options: JobMessageActionOptions;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationTogglePurgeFreezeDocumentArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  documentId: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationTransitionDocumentStatusArgs = {
  item: TransitionDocumentStatusInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaMutationValidateDomainUserArgs = {
  key: Scalars['String']['input'];
};


export type BusinessSchemaMutationValidateEnvironmentUserArgs = {
  key: Scalars['String']['input'];
};


export type BusinessSchemaMutationValidateTenantUserArgs = {
  key: Scalars['String']['input'];
};

export type BusinessSchemaQuery = {
  __typename?: 'BusinessSchemaQuery';
  activityItems?: Maybe<Array<Maybe<Activity>>>;
  activityList?: Maybe<ActivityTypeConnection>;
  apiDomainUserItems?: Maybe<Array<Maybe<ApiDomainUser>>>;
  apiDomainUserList?: Maybe<ApiDomainUserTypeConnection>;
  apiDomainUserRightList?: Maybe<DomainRightValueTypeConnection>;
  apiEnvironmentUserItems?: Maybe<Array<Maybe<ApiEnvironmentUser>>>;
  apiEnvironmentUserList?: Maybe<ApiEnvironmentUserTypeConnection>;
  apiEnvironmentUserRightList?: Maybe<EnvironmentRightValueTypeConnection>;
  apiTenantUserItems?: Maybe<Array<Maybe<ApiTenantUser>>>;
  apiTenantUserList?: Maybe<ApiTenantUserTypeConnection>;
  apiTenantUserRightList?: Maybe<TenantRightValueTypeConnection>;
  businessConfigurationItems?: Maybe<Array<Maybe<BusinessConfiguration>>>;
  businessConfigurationList?: Maybe<BusinessConfigurationTypeConnection>;
  chorusB2GProvidersList?: Maybe<Array<Maybe<ChorusProviderIdName>>>;
  chorusB2GStructureInformation?: Maybe<ChorusProviderIdName>;
  clickedLinkDocumentItems?: Maybe<ClickedLinkDocument>;
  contactFunctionItems?: Maybe<Array<Maybe<ContactFunction>>>;
  contactFunctionList?: Maybe<ContactFunctionTypeConnection>;
  contactFunctionSystemList?: Maybe<ContactFunctionTypeConnection>;
  contactItems?: Maybe<Array<Maybe<Contact>>>;
  contactList?: Maybe<ContactTypeConnection>;
  dashboardItems?: Maybe<Array<Maybe<Dashboard>>>;
  dashboardList?: Maybe<DashboardTypeConnection>;
  dashboardRightItems?: Maybe<Array<Maybe<DashboardRight>>>;
  dashboardRightList?: Maybe<DashboardRightTypeConnection>;
  documentCountList?: Maybe<DocumentCount>;
  documentCountStatisticsList?: Maybe<Array<Maybe<DocumentCountStatistics>>>;
  documentItems?: Maybe<Array<Maybe<Document>>>;
  documentJobItems?: Maybe<Array<Maybe<DocumentJob>>>;
  documentJobList?: Maybe<DocumentJobTypeConnection>;
  documentList?: Maybe<DocumentTypeConnection>;
  documentProbativeJobItems?: Maybe<Array<Maybe<DocumentProbativeJob>>>;
  documentProbativeJobList?: Maybe<DocumentProbativeJobTypeConnection>;
  documentSizeStatistics?: Maybe<DocumentSizeStatistics>;
  documentSubTypeItems?: Maybe<Array<Maybe<DocumentSubType>>>;
  documentSubTypeList?: Maybe<DocumentSubTypeTypeConnection>;
  documentTypeItems?: Maybe<Array<Maybe<DocumentType>>>;
  documentTypeList?: Maybe<DocumentTypeTypeConnection>;
  domainUserItems?: Maybe<Array<Maybe<DomainUser>>>;
  domainUserList?: Maybe<DomainUserTypeConnection>;
  domainUserRightList?: Maybe<DomainRightValueTypeConnection>;
  environmentUserItems?: Maybe<Array<Maybe<EnvironmentUser>>>;
  environmentUserList?: Maybe<EnvironmentUserTypeConnection>;
  environmentUserRightList?: Maybe<EnvironmentRightValueTypeConnection>;
  errorQueueMessageItems?: Maybe<Array<Maybe<ErrorQueueMessage>>>;
  errorQueueMessageList?: Maybe<ErrorQueueMessageTypeConnection>;
  hostedDocumentFileItems?: Maybe<Array<Maybe<FileContent>>>;
  hostedDocumentFileList?: Maybe<FileHeaderTypeConnection>;
  hostedInboundFileItems?: Maybe<Array<Maybe<FileContent>>>;
  hostedInboundFileList?: Maybe<FileHeaderTypeConnection>;
  hostedListFileItems?: Maybe<Array<Maybe<FileContent>>>;
  hostedListFileList?: Maybe<FileHeaderTypeConnection>;
  hostedReportFileItems?: Maybe<Array<Maybe<FileContent>>>;
  hostedReportFileList?: Maybe<FileHeaderTypeConnection>;
  incomingEmailHistoryItems?: Maybe<Array<Maybe<IncomingEmailHistory>>>;
  incomingEmailHistoryList?: Maybe<IncomingEmailHistoryTypeConnection>;
  jobItems?: Maybe<Array<Maybe<JobUnionType>>>;
  jobList?: Maybe<JobTypeConnection>;
  jobMessageItems?: Maybe<Array<Maybe<JobMessage>>>;
  jobMessageList?: Maybe<JobMessageTypeConnection>;
  natureItems?: Maybe<Array<Maybe<Nature>>>;
  natureList?: Maybe<NatureTypeConnection>;
  noteItems?: Maybe<Array<Maybe<Note>>>;
  noteList?: Maybe<NoteTypeConnection>;
  postalJobItems?: Maybe<Array<Maybe<PostalJob>>>;
  postalJobList?: Maybe<PostalJobTypeConnection>;
  processingJobCountStatistics?: Maybe<JobCountStatistics>;
  rightInitialValueList?: Maybe<RightInitialValueTypeConnection>;
  routingConfigurationItems?: Maybe<Array<Maybe<RoutingConfiguration>>>;
  routingConfigurationList?: Maybe<RoutingConfigurationTypeConnection>;
  schema?: Maybe<Scalars['String']['output']>;
  serviceItems?: Maybe<Array<Maybe<Service>>>;
  serviceList?: Maybe<ServiceTypeConnection>;
  statusActionList?: Maybe<StatusActionTypeConnection>;
  templateContentItems?: Maybe<Array<Maybe<TemplateContent>>>;
  templateContentList?: Maybe<TemplateContentTypeConnection>;
  templateStructureItems?: Maybe<Array<Maybe<TemplateStructure>>>;
  templateStructureList?: Maybe<TemplateStructureTypeConnection>;
  templateVariableList?: Maybe<Array<Maybe<TemplateVariable>>>;
  tenantUserItems?: Maybe<Array<Maybe<TenantUser>>>;
  tenantUserList?: Maybe<TenantUserTypeConnection>;
  tenantUserRightList?: Maybe<TenantRightValueTypeConnection>;
  thirdPartyItems?: Maybe<Array<Maybe<ThirdParty>>>;
  thirdPartyList?: Maybe<ThirdPartyTypeConnection>;
  thirdPartyTypeItems?: Maybe<Array<Maybe<ThirdPartyType>>>;
  thirdPartyTypeList?: Maybe<ThirdPartyTypeTypeConnection>;
  thirdPartyTypeSystemList?: Maybe<ThirdPartyTypeTypeConnection>;
};


export type BusinessSchemaQueryActivityItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryActivityListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  params?: InputMaybe<ActivityQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryApiDomainUserItemsArgs = {
  idList: Array<Scalars['String']['input']>;
};


export type BusinessSchemaQueryApiDomainUserListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<ApiDomainUserQueryParams>;
};


export type BusinessSchemaQueryApiDomainUserRightListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  apiUserId: Scalars['String']['input'];
  params?: InputMaybe<RightValueQueryParams>;
};


export type BusinessSchemaQueryApiEnvironmentUserItemsArgs = {
  idList: Array<Scalars['String']['input']>;
};


export type BusinessSchemaQueryApiEnvironmentUserListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<ApiEnvironmentUserQueryParams>;
};


export type BusinessSchemaQueryApiEnvironmentUserRightListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  apiUserId: Scalars['String']['input'];
  params?: InputMaybe<RightValueQueryParams>;
};


export type BusinessSchemaQueryApiTenantUserItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryApiTenantUserListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<ApiTenantUserQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryApiTenantUserRightListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  apiUserId: Scalars['String']['input'];
  params?: InputMaybe<RightValueQueryParams>;
};


export type BusinessSchemaQueryBusinessConfigurationItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryBusinessConfigurationListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<BusinessConfigurationQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryChorusB2GProvidersListArgs = {
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
  serverType: ChorusServerType;
};


export type BusinessSchemaQueryChorusB2GStructureInformationArgs = {
  siret: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type BusinessSchemaQueryClickedLinkDocumentItemsArgs = {
  id: Scalars['String']['input'];
};


export type BusinessSchemaQueryContactFunctionItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryContactFunctionListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<ContactFunctionQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryContactFunctionSystemListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  params?: InputMaybe<ContactFunctionQueryParams>;
};


export type BusinessSchemaQueryContactItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryContactListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<ContactQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryDashboardItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
};


export type BusinessSchemaQueryDashboardListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  params?: InputMaybe<DashboardQueryParams>;
};


export type BusinessSchemaQueryDashboardRightItemsArgs = {
  idList: Array<Scalars['String']['input']>;
};


export type BusinessSchemaQueryDashboardRightListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<DashboardRightQueryParams>;
};


export type BusinessSchemaQueryDocumentCountListArgs = {
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryDocumentCountStatisticsListArgs = {
  params?: InputMaybe<DocumentCountStatisticsQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryDocumentItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryDocumentJobItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryDocumentJobListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<DocumentJobQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryDocumentListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  params?: InputMaybe<DocumentQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryDocumentProbativeJobItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryDocumentProbativeJobListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<DocumentProbativeJobQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryDocumentSizeStatisticsArgs = {
  params?: InputMaybe<DocumentSizeStatisticsQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryDocumentSubTypeItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
};


export type BusinessSchemaQueryDocumentSubTypeListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  params?: InputMaybe<DocumentSubTypeQueryParams>;
};


export type BusinessSchemaQueryDocumentTypeItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryDocumentTypeListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<DocumentTypeQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryDomainUserItemsArgs = {
  idList: Array<Scalars['String']['input']>;
};


export type BusinessSchemaQueryDomainUserListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<DomainUserQueryParams>;
};


export type BusinessSchemaQueryDomainUserRightListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  domainUserId: Scalars['String']['input'];
  params?: InputMaybe<RightValueQueryParams>;
};


export type BusinessSchemaQueryEnvironmentUserItemsArgs = {
  idList: Array<Scalars['String']['input']>;
};


export type BusinessSchemaQueryEnvironmentUserListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<EnvironmentUserQueryParams>;
};


export type BusinessSchemaQueryEnvironmentUserRightListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  environmentUserId: Scalars['String']['input'];
  params?: InputMaybe<RightValueQueryParams>;
};


export type BusinessSchemaQueryErrorQueueMessageItemsArgs = {
  idList: Array<Scalars['String']['input']>;
};


export type BusinessSchemaQueryErrorQueueMessageListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<ErrorQueueMessageQueryParams>;
};


export type BusinessSchemaQueryHostedDocumentFileItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryHostedDocumentFileListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryHostedInboundFileItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  inboundFolder: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryHostedInboundFileListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  inboundFolder: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryHostedListFileItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryHostedListFileListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryHostedReportFileItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryHostedReportFileListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryIncomingEmailHistoryItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryIncomingEmailHistoryListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<IncomingEmailHistoryQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryJobItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryJobListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<JobQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryJobMessageItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryJobMessageListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<JobMessageQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryNatureItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
};


export type BusinessSchemaQueryNatureListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  params?: InputMaybe<NatureQueryParams>;
};


export type BusinessSchemaQueryNoteItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryNoteListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<NoteQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryPostalJobItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryPostalJobListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<PostalJobQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryProcessingJobCountStatisticsArgs = {
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryRightInitialValueListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<RightInitialValueQueryParams>;
  profile: UserProfile;
};


export type BusinessSchemaQueryRoutingConfigurationItemsArgs = {
  idList: Array<Scalars['String']['input']>;
};


export type BusinessSchemaQueryRoutingConfigurationListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<RoutingConfigurationQueryParams>;
};


export type BusinessSchemaQueryServiceItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryServiceListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<ServiceQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryStatusActionListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<StatusActionQueryParams>;
};


export type BusinessSchemaQueryTemplateContentItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryTemplateContentListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  params?: InputMaybe<TemplateContentQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryTemplateStructureItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryTemplateStructureListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  params?: InputMaybe<TemplateStructureQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryTemplateVariableListArgs = {
  ancestorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentTypeId?: InputMaybe<Scalars['String']['input']>;
  domainId?: InputMaybe<Scalars['String']['input']>;
  natureId?: InputMaybe<Scalars['String']['input']>;
  notificationType: TemplateContentNotificationType;
  serviceId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryTenantUserItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryTenantUserListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<TenantUserQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryTenantUserRightListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<RightValueQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantUserId: Scalars['String']['input'];
};


export type BusinessSchemaQueryThirdPartyItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryThirdPartyListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<ThirdPartyQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryThirdPartyTypeItemsArgs = {
  idList: Array<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryThirdPartyTypeListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<ThirdPartyTypeQueryParams>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type BusinessSchemaQueryThirdPartyTypeSystemListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  params?: InputMaybe<ThirdPartyTypeQueryParams>;
};

export type ChorusB2GAddress = {
  __typename?: 'ChorusB2GAddress';
  name: Scalars['String']['output'];
};

export type ChorusB2GAdhocRecipientInput = {
  name: Scalars['String']['input'];
};

export type ChorusB2GConfig = {
  __typename?: 'ChorusB2GConfig';
  isTestMode?: Maybe<Scalars['Boolean']['output']>;
  login?: Maybe<Scalars['String']['output']>;
  passwordExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerLegalId?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  recalculate?: Maybe<Scalars['Boolean']['output']>;
  serverType?: Maybe<ChorusServerType>;
};

export enum ChorusB2GErrorType {
  AntivirusFlagged = 'ANTIVIRUS_FLAGGED',
  EncodingNotSupported = 'ENCODING_NOT_SUPPORTED',
  ErrorLoadingFile = 'ERROR_LOADING_FILE',
  FileExtensionRejected = 'FILE_EXTENSION_REJECTED',
  FluxHtmlNotFound = 'FLUX_HTML_NOT_FOUND',
  FluxMonitoringNotAuthorized = 'FLUX_MONITORING_NOT_AUTHORIZED',
  FluxNotFound = 'FLUX_NOT_FOUND',
  FluxNotFromPortalOrApi = 'FLUX_NOT_FROM_PORTAL_OR_API',
  FluxProcessingTimeout = 'FLUX_PROCESSING_TIMEOUT',
  FluxRejected = 'FLUX_REJECTED',
  FluxReportNotFound = 'FLUX_REPORT_NOT_FOUND',
  FluxSearchMissingDate = 'FLUX_SEARCH_MISSING_DATE',
  FluxSearchMissingDepositMode = 'FLUX_SEARCH_MISSING_DEPOSIT_MODE',
  FluxSearchMissingFormat = 'FLUX_SEARCH_MISSING_FORMAT',
  FluxSearchMissingProcessingMode = 'FLUX_SEARCH_MISSING_PROCESSING_MODE',
  FluxSearchMissingState = 'FLUX_SEARCH_MISSING_STATE',
  FluxSearchMissingSyntax = 'FLUX_SEARCH_MISSING_SYNTAX',
  FluxSearchMissingType = 'FLUX_SEARCH_MISSING_TYPE',
  InvalidAttachmentType = 'INVALID_ATTACHMENT_TYPE',
  InvalidDataFormatForEdi = 'INVALID_DATA_FORMAT_FOR_EDI',
  InvalidExemptionReason = 'INVALID_EXEMPTION_REASON',
  InvalidServiceCode = 'INVALID_SERVICE_CODE',
  InvalidSiret = 'INVALID_SIRET',
  InvalidStructure = 'INVALID_STRUCTURE',
  InvoiceAlreadyExists = 'INVOICE_ALREADY_EXISTS',
  MaxFileSizeExceeded = 'MAX_FILE_SIZE_EXCEEDED',
  MissingAttachmentType = 'MISSING_ATTACHMENT_TYPE',
  MissingChorusProviderId = 'MISSING_CHORUS_PROVIDER_ID',
  MissingCurrency = 'MISSING_CURRENCY',
  MissingDiscountReason = 'MISSING_DISCOUNT_REASON',
  MissingExemptionReason = 'MISSING_EXEMPTION_REASON',
  MissingFileContent = 'MISSING_FILE_CONTENT',
  MissingFileName = 'MISSING_FILE_NAME',
  MissingFluxSyntaxe = 'MISSING_FLUX_SYNTAXE',
  MissingGrandTotalAmount = 'MISSING_GRAND_TOTAL_AMOUNT',
  MissingInvoiceDate = 'MISSING_INVOICE_DATE',
  MissingInvoiceNumber = 'MISSING_INVOICE_NUMBER',
  MissingOriginalInvoiceNumber = 'MISSING_ORIGINAL_INVOICE_NUMBER',
  MissingPurchaseOrderNumber = 'MISSING_PURCHASE_ORDER_NUMBER',
  MissingServiceCode = 'MISSING_SERVICE_CODE',
  MissingServiceCodeOrPurchaseOrderNumber = 'MISSING_SERVICE_CODE_OR_PURCHASE_ORDER_NUMBER',
  MissingSiret = 'MISSING_SIRET',
  MissingTaxDueDateType = 'MISSING_TAX_DUE_DATE_TYPE',
  MissingTaxTotalAmount = 'MISSING_TAX_TOTAL_AMOUNT',
  MissingValiderInformations = 'MISSING_VALIDER_INFORMATIONS',
  MissingVatInformations = 'MISSING_VAT_INFORMATIONS',
  ReceiverIsOnlyMoa = 'RECEIVER_IS_ONLY_MOA',
  SearchInvalidDateRange = 'SEARCH_INVALID_DATE_RANGE',
  SearchNoResults = 'SEARCH_NO_RESULTS',
  SearchParameterError = 'SEARCH_PARAMETER_ERROR',
  UnknownError = 'UNKNOWN_ERROR',
  UserNotActiveOrNotSupplier = 'USER_NOT_ACTIVE_OR_NOT_SUPPLIER',
  UserNotAuthorized = 'USER_NOT_AUTHORIZED'
}

export type ChorusB2GValidationError = {
  __typename?: 'ChorusB2GValidationError';
  errorString: Scalars['String']['output'];
  errorType: ChorusB2GErrorType;
};

export type ChorusProviderIdName = {
  __typename?: 'ChorusProviderIdName';
  headQuarterAddress?: Maybe<Scalars['String']['output']>;
  isMOA?: Maybe<Scalars['String']['output']>;
  isOnlyMOA?: Maybe<Scalars['String']['output']>;
  legalIdType?: Maybe<Scalars['String']['output']>;
  noPaymentStatus?: Maybe<Scalars['String']['output']>;
  passwordExpirationDate?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerLegalId?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  providerType?: Maybe<Scalars['String']['output']>;
  purchaseOrderIsRequired?: Maybe<Scalars['String']['output']>;
  purchaseOrderOrServiceIsRequired?: Maybe<Scalars['String']['output']>;
  serviceIsRequired?: Maybe<Scalars['String']['output']>;
  structureName?: Maybe<Scalars['String']['output']>;
};

export enum ChorusServerType {
  Prod = 'PROD',
  Qualif = 'QUALIF'
}

export type ClickedLinkDocument = {
  __typename?: 'ClickedLinkDocument';
  content: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  documentName: Scalars['String']['output'];
  expirationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  id: Scalars['String']['output'];
  isCountExpired: Scalars['Boolean']['output'];
  jobId: Scalars['String']['output'];
  jobMessageId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  civility: Scalars['String']['output'];
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  creationUserLabel?: Maybe<Scalars['String']['output']>;
  culture: Scalars['String']['output'];
  documentTransmissionMode: DocumentTransmissionMode;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  functionIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  isFavorite: Scalars['Boolean']['output'];
  isPrincipal: Scalars['Boolean']['output'];
  lastModificationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationUserId?: Maybe<Scalars['String']['output']>;
  lastModificationUserLabel?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  sendingMode?: Maybe<ContactSendingMode>;
  structureId?: Maybe<Scalars['String']['output']>;
  thirdPartyId?: Maybe<Scalars['String']['output']>;
  thirdPartyName?: Maybe<Scalars['String']['output']>;
  timeZone: Scalars['String']['output'];
};

export type ContactBoolFilter = {
  field: ContactBoolFilterField;
  filterValue1: Scalars['Boolean']['input'];
  operator: BoolFilterOperator;
};

export enum ContactBoolFilterField {
  IsEnabled = 'IS_ENABLED',
  IsFavorite = 'IS_FAVORITE',
  IsPrincipal = 'IS_PRINCIPAL'
}

export type ContactFunction = {
  __typename?: 'ContactFunction';
  code: Scalars['String']['output'];
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  creationUserLabel?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  lastModificationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationUserId?: Maybe<Scalars['String']['output']>;
  lastModificationUserLabel?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  ownerType: ContactFunctionOwnerType;
};

export type ContactFunctionBoolFilter = {
  field: ContactFunctionBoolFilterField;
  filterValue1: Scalars['Boolean']['input'];
  operator: BoolFilterOperator;
};

export enum ContactFunctionBoolFilterField {
  IsEnabled = 'IS_ENABLED'
}

export type ContactFunctionInput = {
  code: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<I18nFieldInput>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  ownerType: ContactFunctionOwnerType;
};

export enum ContactFunctionOwnerType {
  System = 'SYSTEM',
  Tenant = 'TENANT'
}

export type ContactFunctionQueryParams = {
  boolFilters?: InputMaybe<Array<InputMaybe<ContactFunctionBoolFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<ContactFunctionSortField>;
  stringFilters?: InputMaybe<Array<InputMaybe<ContactFunctionStringFilter>>>;
};

export enum ContactFunctionSortField {
  Code = 'CODE',
  IsEnabled = 'IS_ENABLED',
  Name = 'NAME',
  OwnerType = 'OWNER_TYPE'
}

export type ContactFunctionStringFilter = {
  field: ContactFunctionStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum ContactFunctionStringFilterField {
  Code = 'CODE',
  Name = 'NAME',
  OwnerId = 'OWNER_ID',
  TenantId = 'TENANT_ID'
}

export type ContactFunctionTypeConnection = {
  __typename?: 'ContactFunctionTypeConnection';
  edges?: Maybe<Array<Maybe<ContactFunction>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type ContactInput = {
  civility: Scalars['String']['input'];
  culture?: InputMaybe<Scalars['String']['input']>;
  documentTransmissionMode?: InputMaybe<DocumentTransmissionMode>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  functionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  isPrincipal?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  sendingMode?: InputMaybe<ContactSendingMode>;
  structureId?: InputMaybe<Scalars['String']['input']>;
  thirdPartyId: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type ContactQueryParams = {
  boolFilters?: InputMaybe<Array<InputMaybe<ContactBoolFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<ContactSortField>;
  stringFilters?: InputMaybe<Array<InputMaybe<ContactStringFilter>>>;
};

export type ContactRecipientInput = {
  contactId: Scalars['String']['input'];
};

export enum ContactSendingMode {
  Grouped = 'GROUPED',
  Separated = 'SEPARATED'
}

export enum ContactSortField {
  Civility = 'CIVILITY',
  Culture = 'CULTURE',
  DocumentTransmissionMode = 'DOCUMENT_TRANSMISSION_MODE',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  IsEnabled = 'IS_ENABLED',
  IsFavorite = 'IS_FAVORITE',
  IsPrincipal = 'IS_PRINCIPAL',
  LastName = 'LAST_NAME',
  Phone = 'PHONE',
  ThirdPartyId = 'THIRD_PARTY_ID',
  ThirdPartyName = 'THIRD_PARTY_NAME',
  TimeZone = 'TIME_ZONE',
  UserId = 'USER_ID'
}

export type ContactStringFilter = {
  field: ContactStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum ContactStringFilterField {
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  StructureId = 'STRUCTURE_ID',
  TenantId = 'TENANT_ID',
  ThirdPartyId = 'THIRD_PARTY_ID',
  ThirdPartyName = 'THIRD_PARTY_NAME',
  UserId = 'USER_ID'
}

export type ContactTypeConnection = {
  __typename?: 'ContactTypeConnection';
  edges?: Maybe<Array<Maybe<Contact>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type Dashboard = {
  __typename?: 'Dashboard';
  dashboardType: Scalars['String']['output'];
  dashboardVisibility: DashboardVisibilityType;
  datasetId: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reportId: Scalars['String']['output'];
};

export type DashboardDashboardVisibilityTypeEnumFilter = {
  field: DashboardVisibilityFilterField;
  filterValue1: DashboardVisibilityType;
  filterValue2?: InputMaybe<DashboardVisibilityType>;
  operator: NumberFilterOperator;
};

export type DashboardQueryParams = {
  dashboardVisibilityFilters?: InputMaybe<Array<InputMaybe<DashboardDashboardVisibilityTypeEnumFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<DashboardSortField>;
  stringFilters?: InputMaybe<Array<InputMaybe<DashboardStringFilter>>>;
};

export type DashboardRight = {
  __typename?: 'DashboardRight';
  dashboardType: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type DashboardRightInput = {
  dashboardType: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type DashboardRightQueryParams = {
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<DashboardRightSortField>;
  stringFilters?: InputMaybe<Array<InputMaybe<DashboardRightStringFilter>>>;
};

export enum DashboardRightSortField {
  Id = 'ID',
  UserId = 'USER_ID'
}

export type DashboardRightStringFilter = {
  field: DashboardRightStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum DashboardRightStringFilterField {
  UserId = 'USER_ID'
}

export type DashboardRightTypeConnection = {
  __typename?: 'DashboardRightTypeConnection';
  edges?: Maybe<Array<Maybe<DashboardRight>>>;
  pageInfo?: Maybe<PageInfo>;
};

export enum DashboardSortField {
  Name = 'NAME'
}

export type DashboardStringFilter = {
  field: DashboardStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum DashboardStringFilterField {
  DashboardType = 'DASHBOARD_TYPE',
  Name = 'NAME'
}

export type DashboardTypeConnection = {
  __typename?: 'DashboardTypeConnection';
  edges?: Maybe<Array<Maybe<Dashboard>>>;
  pageInfo?: Maybe<PageInfo>;
};

export enum DashboardVisibilityFilterField {
  DashboardVisibility = 'DASHBOARD_VISIBILITY'
}

export enum DashboardVisibilityType {
  Internal = 'INTERNAL',
  PublicCustom = 'PUBLIC_CUSTOM',
  PublicStandard = 'PUBLIC_STANDARD'
}

export enum DataFileActionEnum {
  Create = 'CREATE',
  None = 'NONE',
  Validate = 'VALIDATE'
}

export type DataFileActionInput = {
  action: DataFileActionEnum;
  data: Scalars['String']['input'];
  dataFileType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  isAsync?: InputMaybe<Scalars['Boolean']['input']>;
  parameters?: InputMaybe<Array<InputMaybe<KeyValuePairInput>>>;
  trackingId?: InputMaybe<Scalars['String']['input']>;
};

export type DataFileActionJob = {
  __typename?: 'DataFileActionJob';
  apiRoutingConfig?: Maybe<ApiRoutingConfiguration>;
  canceledCount: Scalars['Int']['output'];
  completedDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  dataFilePath?: Maybe<Scalars['String']['output']>;
  documentFileFormat: DocumentFileFormat;
  documentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  failedCount: Scalars['Int']['output'];
  id?: Maybe<Scalars['String']['output']>;
  incomingTransmissionMode: DataFileJobIncomingTransmissionMode;
  jobType?: Maybe<JobBaseType>;
  note?: Maybe<Scalars['String']['output']>;
  parameters: Scalars['String']['output'];
  processingDuration?: Maybe<Scalars['Long']['output']>;
  recipientCount: Scalars['Int']['output'];
  routingQueueName: Scalars['String']['output'];
  sender?: Maybe<Scalars['String']['output']>;
  sentCount: Scalars['Int']['output'];
  serviceId?: Maybe<Scalars['String']['output']>;
  smtpRoutingConfig?: Maybe<SmtpRoutingConfiguration>;
  status: JobBaseStatus;
  tenantId: Scalars['String']['output'];
  trackingId: Scalars['String']['output'];
  validationResult?: Maybe<DataFileValidationResult>;
};

export enum DataFileJobIncomingTransmissionMode {
  Api = 'API',
  Ftp = 'FTP',
  Smtp = 'SMTP'
}

export type DataFileValidationResult = {
  __typename?: 'DataFileValidationResult';
  count: Scalars['Int']['output'];
  errorCode?: Maybe<Scalars['Int']['output']>;
  errorMsg?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  msg?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
  validationDetails?: Maybe<ResponseDetail>;
};

export type Document = {
  __typename?: 'Document';
  archiveConfig?: Maybe<ArchiveConfiguration>;
  archiveDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  archiveId?: Maybe<Scalars['String']['output']>;
  archiver?: Maybe<ArchiverProvider>;
  attachmentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  comments?: Maybe<Array<Maybe<DocumentComment>>>;
  convertedId?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  creationUserLabel?: Maybe<Scalars['String']['output']>;
  documentSubTypeCode?: Maybe<Scalars['String']['output']>;
  documentTypeCode?: Maybe<Scalars['String']['output']>;
  domainId?: Maybe<Scalars['String']['output']>;
  fileContent?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  fileUrl?: Maybe<Scalars['String']['output']>;
  gedFields?: Maybe<Array<Maybe<GedField>>>;
  hash: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  isPurgeFrozen?: Maybe<Scalars['Boolean']['output']>;
  jobIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  jobMessageStatusCounts?: Maybe<Array<Maybe<JobMessageStatusCount>>>;
  lastModificationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationUserId?: Maybe<Scalars['String']['output']>;
  lastModificationUserLabel?: Maybe<Scalars['String']['output']>;
  originalDocumentHash: Scalars['String']['output'];
  previewBlobStorageFilePath?: Maybe<Scalars['String']['output']>;
  primaryJobMessageId?: Maybe<Scalars['String']['output']>;
  purgeFreezeDate?: Maybe<Scalars['DateTime']['output']>;
  readDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  readableViewBlobStorageFilePath?: Maybe<Scalars['String']['output']>;
  readableViewId?: Maybe<Scalars['String']['output']>;
  sentDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  signRequired: Scalars['Boolean']['output'];
  signType?: Maybe<DocumentTypeSignType>;
  signedDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  signedDocumentHash: Scalars['String']['output'];
  size?: Maybe<Scalars['Long']['output']>;
  standardFileData?: Maybe<Array<Maybe<KeyValue>>>;
  status: DocumentStatus;
  structureId?: Maybe<Scalars['String']['output']>;
  subStatus?: Maybe<DocumentSubStatus>;
  tenantId: Scalars['String']['output'];
};

export type DocumentActionOptions = {
  action: DocumentActionType;
  attachments?: InputMaybe<Array<InputMaybe<AttachmentInput>>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  emailAdhocRecipients?: InputMaybe<Array<InputMaybe<EmailAdhocRecipientInput>>>;
  metadata?: InputMaybe<Array<InputMaybe<GedFieldInput>>>;
};

export enum DocumentActionType {
  AddRecipients = 'ADD_RECIPIENTS',
  Cancel = 'CANCEL',
  CancelDocumentLink = 'CANCEL_DOCUMENT_LINK',
  Complete = 'COMPLETE',
  EditMetadata = 'EDIT_METADATA',
  Resend = 'RESEND'
}

export enum DocumentArrayElementFilterField {
  Metadata = 'METADATA'
}

export type DocumentBoolFilter = {
  field: DocumentBooleanFilterField;
  filterValue1: Scalars['Boolean']['input'];
  operator: BoolFilterOperator;
};

export enum DocumentBooleanFilterField {
  IsRead = 'IS_READ',
  IsSent = 'IS_SENT',
  IsSigned = 'IS_SIGNED'
}

export type DocumentComment = {
  __typename?: 'DocumentComment';
  content?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  documentStatus?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type DocumentCount = {
  __typename?: 'DocumentCount';
  documentTypeCounts?: Maybe<Array<Maybe<DocumentTypeCounts>>>;
  serviceCounts?: Maybe<Array<Maybe<DocumentTypeCounts>>>;
  statusCounts?: Maybe<Array<Maybe<StatusCounts>>>;
  subStatusCounts?: Maybe<Array<Maybe<SubStatusCounts>>>;
  totalCount: Scalars['Long']['output'];
};

export type DocumentCountStatistics = {
  __typename?: 'DocumentCountStatistics';
  count: Scalars['Long']['output'];
  documentTypeCode: Scalars['String']['output'];
  month?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export enum DocumentCountStatisticsCycleFilterField {
  Cycle = 'CYCLE'
}

export type DocumentCountStatisticsDateFilter = {
  field: DocumentCountStatisticsDateFilterField;
  filterValue1?: InputMaybe<Scalars['DateTime']['input']>;
  filterValue2?: InputMaybe<Scalars['DateTime']['input']>;
  operator: NumberFilterOperator;
};

export enum DocumentCountStatisticsDateFilterField {
  FirstJobDate = 'FIRST_JOB_DATE'
}

export type DocumentCountStatisticsNatureCycleEnumFilter = {
  field: DocumentCountStatisticsCycleFilterField;
  filterValue1: NatureCycle;
  filterValue2?: InputMaybe<NatureCycle>;
  operator: NumberFilterOperator;
};

export type DocumentCountStatisticsQueryParams = {
  cycleFilters?: InputMaybe<Array<InputMaybe<DocumentCountStatisticsNatureCycleEnumFilter>>>;
  dateFilters?: InputMaybe<Array<InputMaybe<DocumentCountStatisticsDateFilter>>>;
};

export type DocumentDateFilter = {
  field: DocumentDateFilterField;
  filterValue1?: InputMaybe<Scalars['DateTime']['input']>;
  filterValue2?: InputMaybe<Scalars['DateTime']['input']>;
  operator: NumberFilterOperator;
};

export enum DocumentDateFilterField {
  CreationDate = 'CREATION_DATE',
  ReadDate = 'READ_DATE',
  SentDate = 'SENT_DATE',
  SignDate = 'SIGN_DATE'
}

export type DocumentDocumentArrayElementFilterFieldArrayElementFilter = {
  field: DocumentArrayElementFilterField;
  filterArrayElementName?: InputMaybe<Scalars['String']['input']>;
  filterBoolValue1?: InputMaybe<Scalars['Boolean']['input']>;
  filterBoolValue2?: InputMaybe<Scalars['Boolean']['input']>;
  filterDateValue1?: InputMaybe<Scalars['DateTime']['input']>;
  filterDateValue2?: InputMaybe<Scalars['DateTime']['input']>;
  filterDoubleValue1?: InputMaybe<Scalars['Float']['input']>;
  filterDoubleValue2?: InputMaybe<Scalars['Float']['input']>;
  filterIntValue1?: InputMaybe<Scalars['Int']['input']>;
  filterIntValue2?: InputMaybe<Scalars['Int']['input']>;
  filterStringValue1?: InputMaybe<Scalars['String']['input']>;
  filterStringValue2?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: ArrayElementFilterOperator;
};

export type DocumentDocumentStatusEnumFilter = {
  field: DocumentStatusFilterField;
  filterValue1: DocumentStatus;
  filterValue2?: InputMaybe<DocumentStatus>;
  operator: NumberFilterOperator;
};

export type DocumentDocumentSubStatusEnumFilter = {
  field: DocumentSubStatusFilterField;
  filterValue1: DocumentSubStatus;
  filterValue2?: InputMaybe<DocumentSubStatus>;
  operator: NumberFilterOperator;
};

export type DocumentDocumentTypeSignTypeEnumFilter = {
  field: DocumentSignTypeFilterField;
  filterValue1: DocumentTypeSignType;
  filterValue2?: InputMaybe<DocumentTypeSignType>;
  operator: NumberFilterOperator;
};

export enum DocumentFileFormat {
  Cii = 'CII',
  Custom = 'CUSTOM',
  FacturX = 'FACTUR_X',
  Ubl = 'UBL'
}

export enum DocumentFlowCategory {
  Flux_1 = 'FLUX_1',
  Flux_2 = 'FLUX_2',
  Flux_6 = 'FLUX_6',
  Flux_8 = 'FLUX_8',
  Flux_9 = 'FLUX_9',
  Flux_10 = 'FLUX_10',
  Flux_11Annuaire = 'FLUX_11_ANNUAIRE',
  Flux_13Annuaire = 'FLUX_13_ANNUAIRE',
  Flux_14Annuaire = 'FLUX_14_ANNUAIRE',
  Other = 'OTHER',
  Pending = 'PENDING',
  PpfReferentiels = 'PPF_REFERENTIELS',
  Unknown = 'UNKNOWN'
}

export enum DocumentFlowStatus {
  Accepted = 'ACCEPTED',
  AcceptedCdar = 'ACCEPTED_CDAR',
  AdministrationAcceptedFlux_10 = 'ADMINISTRATION_ACCEPTED_FLUX_10',
  AdministrationInHand = 'ADMINISTRATION_IN_HAND',
  AdministrationRefusedFlux_10 = 'ADMINISTRATION_REFUSED_FLUX_10',
  AdministrationRejectedFlow = 'ADMINISTRATION_REJECTED_FLOW',
  Admissible = 'ADMISSIBLE',
  AffactureeConfidentielFlow_2 = 'AFFACTUREE_CONFIDENTIEL_FLOW_2',
  AffactureeFlow_2 = 'AFFACTUREE_FLOW_2',
  AnnuleeFlow_2 = 'ANNULEE_FLOW_2',
  ApprovedFlow_2 = 'APPROVED_FLOW_2',
  Canceled = 'CANCELED',
  ChangementCompteFlow_2 = 'CHANGEMENT_COMPTE_FLOW_2',
  CompletedFlow_2 = 'COMPLETED_FLOW_2',
  DemandePaiementDirectFlow_2 = 'DEMANDE_PAIEMENT_DIRECT_FLOW_2',
  ErreurRoutageFlow_2 = 'ERREUR_ROUTAGE_FLOW_2',
  Inadmissible = 'INADMISSIBLE',
  InDisputeFlow_2 = 'IN_DISPUTE_FLOW_2',
  InHandFlow_2 = 'IN_HAND_FLOW_2',
  MadeAvailable = 'MADE_AVAILABLE',
  MadeAvailableFlow_2 = 'MADE_AVAILABLE_FLOW_2',
  NonAffactureeFlow_2 = 'NON_AFFACTUREE_FLOW_2',
  PartiallyApprovedFlow_2 = 'PARTIALLY_APPROVED_FLOW_2',
  PaymentReceivedFlow_2 = 'PAYMENT_RECEIVED_FLOW_2',
  PaymentSentFlow_2 = 'PAYMENT_SENT_FLOW_2',
  Pending = 'PENDING',
  PlatformIssuedFlow_2 = 'PLATFORM_ISSUED_FLOW_2',
  PlatformReceivedFlow_2 = 'PLATFORM_RECEIVED_FLOW_2',
  RefusedFlow_2 = 'REFUSED_FLOW_2',
  RefusedFlux_10In = 'REFUSED_FLUX_10_IN',
  RejectedCdar = 'REJECTED_CDAR',
  RejectedFlow_1 = 'REJECTED_FLOW_1',
  RejectedFlow_2 = 'REJECTED_FLOW_2',
  RejectedFlux_6 = 'REJECTED_FLUX_6',
  RejectedFlux_10 = 'REJECTED_FLUX_10',
  SubmittedFlow_1 = 'SUBMITTED_FLOW_1',
  SubmittedFlow_2 = 'SUBMITTED_FLOW_2',
  SubmittedFlux_10 = 'SUBMITTED_FLUX_10',
  SuspendedFlow_2 = 'SUSPENDED_FLOW_2',
  ViseeFlow_2 = 'VISEE_FLOW_2'
}

export type DocumentIdOrNewInput = {
  existingDocumentId?: InputMaybe<Scalars['String']['input']>;
  newDocument?: InputMaybe<DocumentInput>;
};

export type DocumentInfo = {
  __typename?: 'DocumentInfo';
  hash: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type DocumentInput = {
  base64?: InputMaybe<Scalars['String']['input']>;
  documentSubTypeCode?: InputMaybe<Scalars['String']['input']>;
  documentTypeCode?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  gedFields?: InputMaybe<Array<InputMaybe<GedFieldInput>>>;
  gedXml?: InputMaybe<Scalars['String']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  tempFileId?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentJob = {
  __typename?: 'DocumentJob';
  attachmentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  completedDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  documentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  domainId?: Maybe<Scalars['String']['output']>;
  failedCount: Scalars['Int']['output'];
  id?: Maybe<Scalars['String']['output']>;
  jobType?: Maybe<JobBaseType>;
  note?: Maybe<Scalars['String']['output']>;
  readCount: Scalars['Int']['output'];
  recipientCount: Scalars['Int']['output'];
  sentCount: Scalars['Int']['output'];
  serviceId?: Maybe<Scalars['String']['output']>;
  status: JobBaseStatus;
  structureId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  trackingId: Scalars['String']['output'];
  validationType: DocumentJobValidationType;
};

export type DocumentJobDateFilter = {
  field: JobDateFilterField;
  filterValue1?: InputMaybe<Scalars['DateTime']['input']>;
  filterValue2?: InputMaybe<Scalars['DateTime']['input']>;
  operator: NumberFilterOperator;
};

export type DocumentJobInput = {
  adhocRecipientsFiles?: InputMaybe<Array<InputMaybe<FileIdOrBase64Input>>>;
  attachments?: InputMaybe<Array<InputMaybe<AttachmentInput>>>;
  chorusB2GAdhocRecipient?: InputMaybe<ChorusB2GAdhocRecipientInput>;
  contactRecipients?: InputMaybe<Array<InputMaybe<ContactRecipientInput>>>;
  document: DocumentIdOrNewInput;
  emailAdhocRecipients?: InputMaybe<Array<InputMaybe<EmailAdhocRecipientInput>>>;
  note?: InputMaybe<Scalars['String']['input']>;
  postalAdhocRecipients?: InputMaybe<Array<InputMaybe<PostalAdhocRecipientInput>>>;
  postalParameter?: InputMaybe<PostalParameterInput>;
  serviceId?: InputMaybe<Scalars['String']['input']>;
  structureId?: InputMaybe<Scalars['String']['input']>;
  thirdPartyRecipients?: InputMaybe<Array<InputMaybe<ThirdPartyRecipientInput>>>;
  trackingId?: InputMaybe<Scalars['String']['input']>;
  validationType: DocumentJobValidationType;
};

export type DocumentJobJobBaseStatusEnumFilter = {
  field: JobStatusFilterField;
  filterValue1: JobBaseStatus;
  filterValue2?: InputMaybe<JobBaseStatus>;
  operator: NumberFilterOperator;
};

export type DocumentJobMessageTypeEnumFilter = {
  field: DocumentTransmissionTypeFilterField;
  filterValue1: JobMessageType;
  filterValue2?: InputMaybe<JobMessageType>;
  operator: NumberFilterOperator;
};

export type DocumentJobQueryParams = {
  dateFilters?: InputMaybe<Array<InputMaybe<DocumentJobDateFilter>>>;
  jobTypeFilters?: InputMaybe<Array<InputMaybe<JobBaseJobBaseTypeEnumFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<JobSortField>;
  statusFilters?: InputMaybe<Array<InputMaybe<DocumentJobJobBaseStatusEnumFilter>>>;
  stringFilters?: InputMaybe<Array<InputMaybe<DocumentJobStringFilter>>>;
};

export type DocumentJobStringFilter = {
  field: JobStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export type DocumentJobTypeConnection = {
  __typename?: 'DocumentJobTypeConnection';
  edges?: Maybe<Array<Maybe<DocumentJob>>>;
  pageInfo?: Maybe<PageInfo>;
};

export enum DocumentJobValidationType {
  ForNewThirdparty = 'FOR_NEW_THIRDPARTY',
  None = 'NONE',
  WithValidation = 'WITH_VALIDATION'
}

export type DocumentProbativeJob = {
  __typename?: 'DocumentProbativeJob';
  attachmentsId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  completedDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  documentsId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  failedCount: Scalars['Int']['output'];
  id?: Maybe<Scalars['String']['output']>;
  jobType?: Maybe<JobBaseType>;
  joinedMessage: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  recipientCount: Scalars['Int']['output'];
  registeredPostalOptions?: Maybe<RegisteredPostalOptions>;
  sentCount: Scalars['Int']['output'];
  serviceId?: Maybe<Scalars['String']['output']>;
  status: JobBaseStatus;
  subject: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  trackingId: Scalars['String']['output'];
  validationType: DocumentJobValidationType;
};

export type DocumentProbativeJobDateFilter = {
  field: JobDateFilterField;
  filterValue1?: InputMaybe<Scalars['DateTime']['input']>;
  filterValue2?: InputMaybe<Scalars['DateTime']['input']>;
  operator: NumberFilterOperator;
};

export type DocumentProbativeJobInput = {
  adhocRecipientsFiles?: InputMaybe<Array<InputMaybe<FileIdOrBase64Input>>>;
  attachments?: InputMaybe<Array<InputMaybe<AttachmentInput>>>;
  contactRecipients?: InputMaybe<Array<InputMaybe<ContactRecipientInput>>>;
  document: DocumentIdOrNewInput;
  emailAdhocRecipients?: InputMaybe<Array<InputMaybe<EmailAdhocRecipientInput>>>;
  joinedMessage?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  probativeType: DocumentProbativeJobType;
  registeredPostalOptions?: InputMaybe<RegisteredPostalOptionsInput>;
  serviceId?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  thirdPartyRecipients?: InputMaybe<Array<InputMaybe<ThirdPartyRecipientInput>>>;
  trackingId?: InputMaybe<Scalars['String']['input']>;
  validationType: DocumentJobValidationType;
};

export type DocumentProbativeJobJobBaseStatusEnumFilter = {
  field: JobStatusFilterField;
  filterValue1: JobBaseStatus;
  filterValue2?: InputMaybe<JobBaseStatus>;
  operator: NumberFilterOperator;
};

export type DocumentProbativeJobQueryParams = {
  dateFilters?: InputMaybe<Array<InputMaybe<DocumentProbativeJobDateFilter>>>;
  jobTypeFilters?: InputMaybe<Array<InputMaybe<JobBaseJobBaseTypeEnumFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<JobSortField>;
  statusFilters?: InputMaybe<Array<InputMaybe<DocumentProbativeJobJobBaseStatusEnumFilter>>>;
  stringFilters?: InputMaybe<Array<InputMaybe<DocumentProbativeJobStringFilter>>>;
};

export type DocumentProbativeJobStringFilter = {
  field: JobStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum DocumentProbativeJobType {
  Certified = 'CERTIFIED',
  EidasRegistered = 'EIDAS_REGISTERED',
  Registered = 'REGISTERED',
  Simple = 'SIMPLE'
}

export type DocumentProbativeJobTypeConnection = {
  __typename?: 'DocumentProbativeJobTypeConnection';
  edges?: Maybe<Array<Maybe<DocumentProbativeJob>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type DocumentQueryParams = {
  arrayElementFilters?: InputMaybe<Array<InputMaybe<DocumentDocumentArrayElementFilterFieldArrayElementFilter>>>;
  boolFilters?: InputMaybe<Array<InputMaybe<DocumentBoolFilter>>>;
  dateFilters?: InputMaybe<Array<InputMaybe<DocumentDateFilter>>>;
  signTypeFilters?: InputMaybe<Array<InputMaybe<DocumentDocumentTypeSignTypeEnumFilter>>>;
  sortArrayElementName?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<DocumentSortField>;
  statusFilters?: InputMaybe<Array<InputMaybe<DocumentDocumentStatusEnumFilter>>>;
  stringFilters?: InputMaybe<Array<InputMaybe<DocumentStringFilter>>>;
  subStatusFilters?: InputMaybe<Array<InputMaybe<DocumentDocumentSubStatusEnumFilter>>>;
  transmissionModeFilters?: InputMaybe<Array<InputMaybe<DocumentJobMessageTypeEnumFilter>>>;
};

export enum DocumentSignTypeFilterField {
  SignType = 'SIGN_TYPE'
}

export type DocumentSizeStatistics = {
  __typename?: 'DocumentSizeStatistics';
  size: Scalars['Long']['output'];
};

export type DocumentSizeStatisticsDateFilter = {
  field: DocumentSizeStatisticsDateFilterField;
  filterValue1?: InputMaybe<Scalars['DateTime']['input']>;
  filterValue2?: InputMaybe<Scalars['DateTime']['input']>;
  operator: NumberFilterOperator;
};

export enum DocumentSizeStatisticsDateFilterField {
  FirstJobDate = 'FIRST_JOB_DATE'
}

export type DocumentSizeStatisticsQueryParams = {
  dateFilters?: InputMaybe<Array<InputMaybe<DocumentSizeStatisticsDateFilter>>>;
};

export enum DocumentSortField {
  CreationDate = 'CREATION_DATE',
  FileName = 'FILE_NAME',
  Id = 'ID',
  Metadata = 'METADATA',
  ReadDate = 'READ_DATE',
  SentDate = 'SENT_DATE',
  SignDate = 'SIGN_DATE',
  SignType = 'SIGN_TYPE'
}

export enum DocumentStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Error = 'ERROR',
  Processing = 'PROCESSING'
}

export enum DocumentStatusFilterField {
  Status = 'STATUS'
}

export type DocumentStringFilter = {
  field: DocumentStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum DocumentStringFilterField {
  DocumentSubTypeCode = 'DOCUMENT_SUB_TYPE_CODE',
  DocumentTypeCode = 'DOCUMENT_TYPE_CODE',
  FileName = 'FILE_NAME',
  StructureId = 'STRUCTURE_ID',
  TenantId = 'TENANT_ID'
}

export enum DocumentSubStatus {
  AntivirusScanFailed = 'ANTIVIRUS_SCAN_FAILED',
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  CheckShematronError = 'CHECK_SHEMATRON_ERROR',
  Completed = 'COMPLETED',
  DataIsNullOrEmpty = 'DATA_IS_NULL_OR_EMPTY',
  Dispute = 'DISPUTE',
  Draft = 'DRAFT',
  Error = 'ERROR',
  FacturXFormatNotMatch = 'FACTUR_X_FORMAT_NOT_MATCH',
  FacturXImporterFailed = 'FACTUR_X_IMPORTER_FAILED',
  GeneralDocoonException = 'GENERAL_DOCOON_EXCEPTION',
  InvalidFacturX = 'INVALID_FACTUR_X',
  InvalidInvoice = 'INVALID_INVOICE',
  InvalidParserConfig = 'INVALID_PARSER_CONFIG',
  InvalidProvidedFormat = 'INVALID_PROVIDED_FORMAT',
  InvalidXmlFormat = 'INVALID_XML_FORMAT',
  InvoiceGenerationFailed = 'INVOICE_GENERATION_FAILED',
  InHand = 'IN_HAND',
  InValidInputParameters = 'IN_VALID_INPUT_PARAMETERS',
  MadeAvailable = 'MADE_AVAILABLE',
  MetadataGenerationFailed = 'METADATA_GENERATION_FAILED',
  NonCompliantFactureX_3B = 'NON_COMPLIANT_FACTURE_X_3_B',
  NonCompliantPdfAxxx = 'NON_COMPLIANT_PDF_AXXX',
  PartiallyApproved = 'PARTIALLY_APPROVED',
  PaymentReceived = 'PAYMENT_RECEIVED',
  PaymentSent = 'PAYMENT_SENT',
  Pending = 'PENDING',
  ReceivedByPlatform = 'RECEIVED_BY_PLATFORM',
  Refused = 'REFUSED',
  Rejected = 'REJECTED',
  RoutingError = 'ROUTING_ERROR',
  SentByPlatform = 'SENT_BY_PLATFORM',
  StandardDataExtractionFailed = 'STANDARD_DATA_EXTRACTION_FAILED',
  StandardFileInvalid = 'STANDARD_FILE_INVALID',
  Submited = 'SUBMITED',
  Suspended = 'SUSPENDED',
  TreatmentError = 'TREATMENT_ERROR',
  VirusDetected = 'VIRUS_DETECTED',
  XmlFormatError = 'XML_FORMAT_ERROR',
  XsdCheckError = 'XSD_CHECK_ERROR',
  XsdSchemaError = 'XSD_SCHEMA_ERROR',
  XPathExpressionError = 'X_PATH_EXPRESSION_ERROR'
}

export enum DocumentSubStatusFilterField {
  SubStatus = 'SUB_STATUS'
}

export type DocumentSubType = {
  __typename?: 'DocumentSubType';
  chorusAttachmentTypeCode: Scalars['String']['output'];
  chorusAttachmentTypeId: Scalars['String']['output'];
  code: Scalars['String']['output'];
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  creationUserLabel?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastModificationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationUserId?: Maybe<Scalars['String']['output']>;
  lastModificationUserLabel?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  natureCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DocumentSubTypeQueryParams = {
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<DocumentSubTypeSortField>;
  stringFilters?: InputMaybe<Array<InputMaybe<DocumentSubTypeStringFilter>>>;
};

export enum DocumentSubTypeSortField {
  ChorusAttachmentTypeCode = 'CHORUS_ATTACHMENT_TYPE_CODE',
  ChorusAttachmentTypeId = 'CHORUS_ATTACHMENT_TYPE_ID',
  Code = 'CODE',
  CreationDate = 'CREATION_DATE',
  Name = 'NAME'
}

export type DocumentSubTypeStringFilter = {
  field: DocumentSubTypeStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum DocumentSubTypeStringFilterField {
  ChorusAttachmentTypeCode = 'CHORUS_ATTACHMENT_TYPE_CODE',
  ChorusAttachmentTypeId = 'CHORUS_ATTACHMENT_TYPE_ID',
  Code = 'CODE',
  Name = 'NAME',
  NatureCodes = 'NATURE_CODES'
}

export type DocumentSubTypeTypeConnection = {
  __typename?: 'DocumentSubTypeTypeConnection';
  edges?: Maybe<Array<Maybe<DocumentSubType>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type DocumentTransitionStatusAttachmentInput = {
  base64: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type DocumentTransitionStatusParametersInput = {
  code: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DocumentTransmissionMode {
  EmailWithAttachment = 'EMAIL_WITH_ATTACHMENT',
  EmailWithLink = 'EMAIL_WITH_LINK',
  None = 'NONE',
  Peppol = 'PEPPOL',
  Sftp = 'SFTP'
}

export enum DocumentTransmissionTypeFilterField {
  JobMessageType = 'JOB_MESSAGE_TYPE'
}

export type DocumentType = {
  __typename?: 'DocumentType';
  code: Scalars['String']['output'];
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  creationUserLabel?: Maybe<Scalars['String']['output']>;
  domainId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastModificationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationUserId?: Maybe<Scalars['String']['output']>;
  lastModificationUserLabel?: Maybe<Scalars['String']['output']>;
  metadataConfigs?: Maybe<Array<Maybe<MetadataConfig>>>;
  metadataValidationRules?: Maybe<Array<Maybe<MetadataValidationRule>>>;
  name: Scalars['String']['output'];
  natureCode: Scalars['String']['output'];
  sign?: Maybe<DocumentTypeSignType>;
  structureId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
};

export type DocumentTypeConnection = {
  __typename?: 'DocumentTypeConnection';
  edges?: Maybe<Array<Maybe<Document>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type DocumentTypeCounts = {
  __typename?: 'DocumentTypeCounts';
  key?: Maybe<Scalars['String']['output']>;
  value: Scalars['Long']['output'];
};

export type DocumentTypeInput = {
  archiveConfiguration?: InputMaybe<ArchiveConfigurationInput>;
  code: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  metadataConfigs?: InputMaybe<Array<InputMaybe<MetadataConfigInput>>>;
  metadataValidationRules?: InputMaybe<Array<InputMaybe<MetadataValidationRuleInput>>>;
  name: Scalars['String']['input'];
  natureCode?: InputMaybe<Scalars['String']['input']>;
  sign?: InputMaybe<DocumentTypeSignType>;
  structureId?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentTypeQueryParams = {
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<DocumentTypeSortField>;
  stringFilters?: InputMaybe<Array<InputMaybe<DocumentTypeStringFilter>>>;
};

export enum DocumentTypeSignType {
  None = 'NONE',
  QualifiedEidasCertificate = 'QUALIFIED_EIDAS_CERTIFICATE'
}

export enum DocumentTypeSortField {
  Code = 'CODE',
  CreationDate = 'CREATION_DATE',
  Name = 'NAME',
  NatureCode = 'NATURE_CODE'
}

export type DocumentTypeStringFilter = {
  field: DocumentTypeStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum DocumentTypeStringFilterField {
  Code = 'CODE',
  Name = 'NAME',
  NatureCode = 'NATURE_CODE',
  StructureId = 'STRUCTURE_ID',
  TenantId = 'TENANT_ID'
}

export type DocumentTypeTypeConnection = {
  __typename?: 'DocumentTypeTypeConnection';
  edges?: Maybe<Array<Maybe<DocumentType>>>;
  pageInfo?: Maybe<PageInfo>;
};

/** The application rights. */
export enum DomainRightType {
  /** Create environments */
  AddEnvironment = 'ADD_ENVIRONMENT',
  /** Create tenants */
  AddTenant = 'ADD_TENANT',
  /** CancelJobMessage */
  CancelJobMessage = 'CANCEL_JOB_MESSAGE',
  /** Create, edit or delete activities */
  ChangeActivity = 'CHANGE_ACTIVITY',
  /** Create, edit or delete callback configurations */
  ChangeCallbackConfiguration = 'CHANGE_CALLBACK_CONFIGURATION',
  /** Create, edit or delete document links */
  ChangeClickedLinkDocument = 'CHANGE_CLICKED_LINK_DOCUMENT',
  /** Create or edit configurations */
  ChangeConfiguration = 'CHANGE_CONFIGURATION',
  /** Create, edit or delete contacts */
  ChangeContact = 'CHANGE_CONTACT',
  /** Create, edit or delete contact functions */
  ChangeContactFunction = 'CHANGE_CONTACT_FUNCTION',
  /** Create, edit or delete dashboards */
  ChangeDashboard = 'CHANGE_DASHBOARD',
  /** Create, edit or delete data file action */
  ChangeDataFileAction = 'CHANGE_DATA_FILE_ACTION',
  /** Create, edit or delete documents */
  ChangeDocument = 'CHANGE_DOCUMENT',
  /** Create documentJob */
  ChangeDocumentJob = 'CHANGE_DOCUMENT_JOB',
  /** Create, edit or delete document types */
  ChangeDocumentType = 'CHANGE_DOCUMENT_TYPE',
  /** Create or edit domains */
  ChangeDomain = 'CHANGE_DOMAIN',
  /** Create, edit or renew Domain Api users */
  ChangeDomainApiUser = 'CHANGE_DOMAIN_API_USER',
  /** Create or edit domain administrators */
  ChangeDomainUser = 'CHANGE_DOMAIN_USER',
  /** Create, edit or renew Environment Api users */
  ChangeEnvironmentApiUser = 'CHANGE_ENVIRONMENT_API_USER',
  /** Create or edit environment administrators */
  ChangeEnvironmentUser = 'CHANGE_ENVIRONMENT_USER',
  /** Create, edit or delete jobMessage */
  ChangeJobMessage = 'CHANGE_JOB_MESSAGE',
  /** Create, edit or delete legal entity */
  ChangeLegalEntity = 'CHANGE_LEGAL_ENTITY',
  /** Create, edit or delete list of values */
  ChangeListOfValues = 'CHANGE_LIST_OF_VALUES',
  /** Create, edit or delete metadatas */
  ChangeMetadata = 'CHANGE_METADATA',
  /** Create or edit notes */
  ChangeNote = 'CHANGE_NOTE',
  /** Create or edit OMS resources */
  ChangeOmsResources = 'CHANGE_OMS_RESOURCES',
  /** Create postalJob */
  ChangePostalJob = 'CHANGE_POSTAL_JOB',
  /** Create, edit or delete postal parameter configurations */
  ChangePostalParameterConfiguration = 'CHANGE_POSTAL_PARAMETER_CONFIGURATION',
  /** Create or edit PowerBi auth token */
  ChangePowerBiAuthToken = 'CHANGE_POWER_BI_AUTH_TOKEN',
  /** Create or edit products */
  ChangeProduct = 'CHANGE_PRODUCT',
  /** Create or edit product installs */
  ChangeProductInstall = 'CHANGE_PRODUCT_INSTALL',
  /** Create, edit or delete api routing configurations */
  ChangeRoutingConfiguration = 'CHANGE_ROUTING_CONFIGURATION',
  /** Create, edit or delete services */
  ChangeService = 'CHANGE_SERVICE',
  /** Create, edit or delete structure */
  ChangeStructure = 'CHANGE_STRUCTURE',
  /** Create, edit or delete template contents */
  ChangeTemplateContent = 'CHANGE_TEMPLATE_CONTENT',
  /** Create, edit or delete template structures */
  ChangeTemplateStructure = 'CHANGE_TEMPLATE_STRUCTURE',
  /** Create, edit or delete template contents */
  ChangeTemplateVariableConfiguration = 'CHANGE_TEMPLATE_VARIABLE_CONFIGURATION',
  /** Create, edit or renew Api users */
  ChangeTenantApiUser = 'CHANGE_TENANT_API_USER',
  /** Create or edit tenant internal info */
  ChangeTenantEdcOmsInfo = 'CHANGE_TENANT_EDC_OMS_INFO',
  /** Create or edit tenant users */
  ChangeTenantUser = 'CHANGE_TENANT_USER',
  /** Create, edit or delete third parties */
  ChangeThirdParty = 'CHANGE_THIRD_PARTY',
  /** Create, edit or delete third party types */
  ChangeThirdPartyType = 'CHANGE_THIRD_PARTY_TYPE',
  /** Complete document */
  CompleteDocument = 'COMPLETE_DOCUMENT',
  /** Edit environments */
  EditEnvironment = 'EDIT_ENVIRONMENT',
  /** Edit tenants */
  EditTenant = 'EDIT_TENANT',
  /** Edit Tenant postal config */
  EditTenantPostalConfig = 'EDIT_TENANT_POSTAL_CONFIG',
  /** Grant internal user rights */
  GrantInternalRight = 'GRANT_INTERNAL_RIGHT',
  /** Grant user rights */
  GrantRight = 'GRANT_RIGHT',
  /** Read clicked link document */
  MarkDocumentAsRead = 'MARK_DOCUMENT_AS_READ',
  /** Get or list activities */
  ReadActivity = 'READ_ACTIVITY',
  /** Get or list callback configurations */
  ReadCallbackConfiguration = 'READ_CALLBACK_CONFIGURATION',
  /** Mark document as read */
  ReadClickedLinkDocument = 'READ_CLICKED_LINK_DOCUMENT',
  /** Get or list configurations */
  ReadConfiguration = 'READ_CONFIGURATION',
  /** Get or list contacts */
  ReadContact = 'READ_CONTACT',
  /** Get or list contact functions */
  ReadContactFunction = 'READ_CONTACT_FUNCTION',
  /** Get or list dashboards */
  ReadDashboard = 'READ_DASHBOARD',
  /** Get or list data file action */
  ReadDataFileAction = 'READ_DATA_FILE_ACTION',
  /** Get or list documents sent to the user */
  ReadDocument = 'READ_DOCUMENT',
  /** Get or list documentJobs */
  ReadDocumentJob = 'READ_DOCUMENT_JOB',
  /** Get or list documents sent to the service of the user */
  ReadDocumentOnService = 'READ_DOCUMENT_ON_SERVICE',
  /** Get or list document types */
  ReadDocumentType = 'READ_DOCUMENT_TYPE',
  /** Get or list domains */
  ReadDomain = 'READ_DOMAIN',
  /** Get or list Domain Api users */
  ReadDomainApiUser = 'READ_DOMAIN_API_USER',
  /** Get or list domain administrators */
  ReadDomainUser = 'READ_DOMAIN_USER',
  /** Get or list environments */
  ReadEnvironment = 'READ_ENVIRONMENT',
  /** Get or list Environment Api users */
  ReadEnvironmentApiUser = 'READ_ENVIRONMENT_API_USER',
  /** Get or list environment administrators */
  ReadEnvironmentUser = 'READ_ENVIRONMENT_USER',
  /** Get or list jobMessages */
  ReadJobMessage = 'READ_JOB_MESSAGE',
  /** Get or list legal entity */
  ReadLegalEntity = 'READ_LEGAL_ENTITY',
  /** Get or list list of values */
  ReadListOfValues = 'READ_LIST_OF_VALUES',
  /** Get or list metadatas */
  ReadMetadata = 'READ_METADATA',
  /** Get or list notes */
  ReadNote = 'READ_NOTE',
  /** Get or list OMS resources */
  ReadOmsResources = 'READ_OMS_RESOURCES',
  /** Get or list postalJobs */
  ReadPostalJob = 'READ_POSTAL_JOB',
  /** Get or list postal parameter configurations */
  ReadPostalParameterConfiguration = 'READ_POSTAL_PARAMETER_CONFIGURATION',
  /** Get or list products */
  ReadProduct = 'READ_PRODUCT',
  /** Get or list product installs */
  ReadProductInstall = 'READ_PRODUCT_INSTALL',
  /** List user rights */
  ReadRight = 'READ_RIGHT',
  /** Get or list api routing configurations */
  ReadRoutingConfiguration = 'READ_ROUTING_CONFIGURATION',
  /** Get or list services */
  ReadService = 'READ_SERVICE',
  /** Get or list status actions */
  ReadStatusAction = 'READ_STATUS_ACTION',
  /** Get or list structure */
  ReadStructure = 'READ_STRUCTURE',
  /** Get or list template contents */
  ReadTemplateContent = 'READ_TEMPLATE_CONTENT',
  /** Get or list template structures */
  ReadTemplateStructure = 'READ_TEMPLATE_STRUCTURE',
  /** Get or list template variables configuration */
  ReadTemplateVariableConfiguration = 'READ_TEMPLATE_VARIABLE_CONFIGURATION',
  /** Get or list tenants */
  ReadTenant = 'READ_TENANT',
  /** Get or list Api users */
  ReadTenantApiUser = 'READ_TENANT_API_USER',
  /** Get or list tenants with internal info */
  ReadTenantEdcOmsInfo = 'READ_TENANT_EDC_OMS_INFO',
  /** Get or list tenant users */
  ReadTenantUser = 'READ_TENANT_USER',
  /** Get or list third parties */
  ReadThirdParty = 'READ_THIRD_PARTY',
  /** Get or list third party types */
  ReadThirdPartyType = 'READ_THIRD_PARTY_TYPE',
  /** RelaunchJobMessage */
  RelaunchJobMessage = 'RELAUNCH_JOB_MESSAGE',
  /** Resend document to chorusRight */
  ResendDocument = 'RESEND_DOCUMENT',
  /** Synchronize EDC resources */
  SynchronizeEdcResources = 'SYNCHRONIZE_EDC_RESOURCES',
  /** Validate invited user */
  ValidateUser = 'VALIDATE_USER'
}

export type DomainRightValue = {
  __typename?: 'DomainRightValue';
  right?: Maybe<DomainRightType>;
  value: Scalars['Boolean']['output'];
};

export type DomainRightValueInput = {
  right?: InputMaybe<DomainRightType>;
  value: Scalars['Boolean']['input'];
};

export type DomainRightValueTypeConnection = {
  __typename?: 'DomainRightValueTypeConnection';
  edges?: Maybe<Array<Maybe<DomainRightValue>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type DomainUser = {
  __typename?: 'DomainUser';
  civility: Scalars['String']['output'];
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  creationUserLabel?: Maybe<Scalars['String']['output']>;
  culture: Scalars['String']['output'];
  domainId: Scalars['String']['output'];
  domainName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  lastConnectionDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationUserId?: Maybe<Scalars['String']['output']>;
  lastModificationUserLabel?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  linkedOrganizations?: Maybe<Array<Maybe<LinkedOrganization>>>;
  phone: Scalars['String']['output'];
  profile?: Maybe<UserProfile>;
  timeZone: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type DomainUserBoolFilter = {
  field: DomainUserBoolFilterField;
  filterValue1: Scalars['Boolean']['input'];
  operator: BoolFilterOperator;
};

export enum DomainUserBoolFilterField {
  IsEnabled = 'IS_ENABLED'
}

export type DomainUserInput = {
  civility?: InputMaybe<Scalars['String']['input']>;
  culture?: InputMaybe<Scalars['String']['input']>;
  domainId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  linkedOrganizations?: InputMaybe<Array<InputMaybe<LinkedOrganizationInput>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<UserProfile>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type DomainUserQueryParams = {
  boolFilters?: InputMaybe<Array<InputMaybe<DomainUserBoolFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<DomainUserSortField>;
  stringFilters?: InputMaybe<Array<InputMaybe<DomainUserStringFilter>>>;
};

export enum DomainUserSortField {
  Civility = 'CIVILITY',
  Culture = 'CULTURE',
  DomainId = 'DOMAIN_ID',
  DomainName = 'DOMAIN_NAME',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  IsEnabled = 'IS_ENABLED',
  LastName = 'LAST_NAME',
  Phone = 'PHONE',
  TimeZone = 'TIME_ZONE',
  UserId = 'USER_ID'
}

export type DomainUserStringFilter = {
  field: DomainUserStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum DomainUserStringFilterField {
  DomainId = 'DOMAIN_ID',
  DomainName = 'DOMAIN_NAME',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  UserId = 'USER_ID'
}

export type DomainUserTypeConnection = {
  __typename?: 'DomainUserTypeConnection';
  edges?: Maybe<Array<Maybe<DomainUser>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type EmailAdhocRecipientInput = {
  documentTransmissionMode: DocumentTransmissionMode;
  email: Scalars['String']['input'];
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type EmailJob = {
  adhocRecipientFiles?: InputMaybe<Array<InputMaybe<FileIdOrNewInputType>>>;
  attachments?: InputMaybe<Array<InputMaybe<FileIdOrNewInputType>>>;
  deDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  emailAdhocRecipients?: InputMaybe<Array<InputMaybe<EmailJobRecipient>>>;
  emailAltBody?: InputMaybe<FileIdOrNewInputType>;
  emailBody?: InputMaybe<FileIdOrNewInputType>;
  jobType?: InputMaybe<JobBaseType>;
  parameter?: InputMaybe<EmailParameter>;
  scheduledStartTime?: InputMaybe<Scalars['DateTimeScalarType']['input']>;
  trackingId?: InputMaybe<Scalars['String']['input']>;
};

export type EmailJobRecipient = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  optionalFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EmailParameter = {
  activateAutoPull?: InputMaybe<Scalars['Boolean']['input']>;
  activateEmbeddedImageInHTML?: InputMaybe<Scalars['Boolean']['input']>;
  activateTracking?: InputMaybe<Scalars['Boolean']['input']>;
  envelopeSender?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  preHeader?: InputMaybe<Scalars['String']['input']>;
  priorityFlag?: InputMaybe<EmailPriorityFlagType>;
  replyTo?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trackingType?: InputMaybe<EmailTrackingType>;
};

export enum EmailPriorityFlagType {
  High = 'HIGH',
  Low = 'LOW',
  Standard = 'STANDARD'
}

export enum EmailTrackingType {
  All = 'ALL',
  ClickOnly = 'CLICK_ONLY',
  OpenOnly = 'OPEN_ONLY'
}

export enum EngineEventAction {
  AcceptEre = 'ACCEPT_ERE',
  AddAttachmentsDocument = 'ADD_ATTACHMENTS_DOCUMENT',
  AddDocumentRecipient = 'ADD_DOCUMENT_RECIPIENT',
  AntivirusScanDocument = 'ANTIVIRUS_SCAN_DOCUMENT',
  ArchiveDocument = 'ARCHIVE_DOCUMENT',
  CancelDocument = 'CANCEL_DOCUMENT',
  CancelJob = 'CANCEL_JOB',
  CancelJobMessage = 'CANCEL_JOB_MESSAGE',
  ChangeStatusChorusB_2G = 'CHANGE_STATUS_CHORUS_B_2_G',
  ChangeStatusDocument = 'CHANGE_STATUS_DOCUMENT',
  ChangeStatusPdp = 'CHANGE_STATUS_PDP',
  ChangeStatusPeppol = 'CHANGE_STATUS_PEPPOL',
  ChangeStatusPortal = 'CHANGE_STATUS_PORTAL',
  ChangeStatusPpf = 'CHANGE_STATUS_PPF',
  CompleteChorusB_2G = 'COMPLETE_CHORUS_B_2_G',
  CompleteJob = 'COMPLETE_JOB',
  ConvertDocument = 'CONVERT_DOCUMENT',
  CreateDocument = 'CREATE_DOCUMENT',
  CreateJob = 'CREATE_JOB',
  EditMetadataDocument = 'EDIT_METADATA_DOCUMENT',
  GenerateProof = 'GENERATE_PROOF',
  GenerateReadableDocument = 'GENERATE_READABLE_DOCUMENT',
  LaunchJob = 'LAUNCH_JOB',
  NotReadEre = 'NOT_READ_ERE',
  PreProcessJob = 'PRE_PROCESS_JOB',
  ProcessJob = 'PROCESS_JOB',
  ReadDocument = 'READ_DOCUMENT',
  ReadEreNotification = 'READ_ERE_NOTIFICATION',
  ReceivePdp = 'RECEIVE_PDP',
  ReceivePeppol = 'RECEIVE_PEPPOL',
  RefuseEre = 'REFUSE_ERE',
  RejectJob = 'REJECT_JOB',
  RelaunchEre = 'RELAUNCH_ERE',
  RelaunchJobMessage = 'RELAUNCH_JOB_MESSAGE',
  RemoveDocumentFromJob = 'REMOVE_DOCUMENT_FROM_JOB',
  ReLaunchJob = 'RE_LAUNCH_JOB',
  SendChorusB_2G = 'SEND_CHORUS_B_2_G',
  SendNotification = 'SEND_NOTIFICATION',
  SendPdp = 'SEND_PDP',
  SendPeppol = 'SEND_PEPPOL',
  SendPostal = 'SEND_POSTAL',
  SendPpf = 'SEND_PPF',
  SignDocument = 'SIGN_DOCUMENT',
  UndeliveredPostal = 'UNDELIVERED_POSTAL',
  UpdateDatabase = 'UPDATE_DATABASE',
  ValidateDocument = 'VALIDATE_DOCUMENT',
  WaitArchiveDocument = 'WAIT_ARCHIVE_DOCUMENT'
}

export enum EnvelopeType {
  C_4 = 'C_4',
  C_5 = 'C_5',
  Dl_2 = 'DL_2'
}

/** The application rights. */
export enum EnvironmentRightType {
  /** Create environments */
  AddEnvironment = 'ADD_ENVIRONMENT',
  /** Create tenants */
  AddTenant = 'ADD_TENANT',
  /** CancelJobMessage */
  CancelJobMessage = 'CANCEL_JOB_MESSAGE',
  /** Create, edit or delete activities */
  ChangeActivity = 'CHANGE_ACTIVITY',
  /** Create, edit or delete callback configurations */
  ChangeCallbackConfiguration = 'CHANGE_CALLBACK_CONFIGURATION',
  /** Create, edit or delete document links */
  ChangeClickedLinkDocument = 'CHANGE_CLICKED_LINK_DOCUMENT',
  /** Create or edit configurations */
  ChangeConfiguration = 'CHANGE_CONFIGURATION',
  /** Create, edit or delete contacts */
  ChangeContact = 'CHANGE_CONTACT',
  /** Create, edit or delete contact functions */
  ChangeContactFunction = 'CHANGE_CONTACT_FUNCTION',
  /** Create, edit or delete dashboards */
  ChangeDashboard = 'CHANGE_DASHBOARD',
  /** Create, edit or delete data file action */
  ChangeDataFileAction = 'CHANGE_DATA_FILE_ACTION',
  /** Create, edit or delete documents */
  ChangeDocument = 'CHANGE_DOCUMENT',
  /** Create documentJob */
  ChangeDocumentJob = 'CHANGE_DOCUMENT_JOB',
  /** Create, edit or delete document types */
  ChangeDocumentType = 'CHANGE_DOCUMENT_TYPE',
  /** Create or edit domains */
  ChangeDomain = 'CHANGE_DOMAIN',
  /** Create, edit or renew Domain Api users */
  ChangeDomainApiUser = 'CHANGE_DOMAIN_API_USER',
  /** Create or edit domain administrators */
  ChangeDomainUser = 'CHANGE_DOMAIN_USER',
  /** Create, edit or renew Environment Api users */
  ChangeEnvironmentApiUser = 'CHANGE_ENVIRONMENT_API_USER',
  /** Create or edit environment administrators */
  ChangeEnvironmentUser = 'CHANGE_ENVIRONMENT_USER',
  /** Create, edit or delete jobMessage */
  ChangeJobMessage = 'CHANGE_JOB_MESSAGE',
  /** Create, edit or delete legal entity */
  ChangeLegalEntity = 'CHANGE_LEGAL_ENTITY',
  /** Create, edit or delete list of values */
  ChangeListOfValues = 'CHANGE_LIST_OF_VALUES',
  /** Create, edit or delete metadatas */
  ChangeMetadata = 'CHANGE_METADATA',
  /** Create or edit notes */
  ChangeNote = 'CHANGE_NOTE',
  /** Create or edit OMS resources */
  ChangeOmsResources = 'CHANGE_OMS_RESOURCES',
  /** Create postalJob */
  ChangePostalJob = 'CHANGE_POSTAL_JOB',
  /** Create, edit or delete postal parameter configurations */
  ChangePostalParameterConfiguration = 'CHANGE_POSTAL_PARAMETER_CONFIGURATION',
  /** Create or edit PowerBi auth token */
  ChangePowerBiAuthToken = 'CHANGE_POWER_BI_AUTH_TOKEN',
  /** Create or edit products */
  ChangeProduct = 'CHANGE_PRODUCT',
  /** Create or edit product installs */
  ChangeProductInstall = 'CHANGE_PRODUCT_INSTALL',
  /** Create, edit or delete api routing configurations */
  ChangeRoutingConfiguration = 'CHANGE_ROUTING_CONFIGURATION',
  /** Create, edit or delete services */
  ChangeService = 'CHANGE_SERVICE',
  /** Create, edit or delete structure */
  ChangeStructure = 'CHANGE_STRUCTURE',
  /** Create, edit or delete template contents */
  ChangeTemplateContent = 'CHANGE_TEMPLATE_CONTENT',
  /** Create, edit or delete template structures */
  ChangeTemplateStructure = 'CHANGE_TEMPLATE_STRUCTURE',
  /** Create, edit or delete template contents */
  ChangeTemplateVariableConfiguration = 'CHANGE_TEMPLATE_VARIABLE_CONFIGURATION',
  /** Create, edit or renew Api users */
  ChangeTenantApiUser = 'CHANGE_TENANT_API_USER',
  /** Create or edit tenant internal info */
  ChangeTenantEdcOmsInfo = 'CHANGE_TENANT_EDC_OMS_INFO',
  /** Create or edit tenant users */
  ChangeTenantUser = 'CHANGE_TENANT_USER',
  /** Create, edit or delete third parties */
  ChangeThirdParty = 'CHANGE_THIRD_PARTY',
  /** Create, edit or delete third party types */
  ChangeThirdPartyType = 'CHANGE_THIRD_PARTY_TYPE',
  /** Complete document */
  CompleteDocument = 'COMPLETE_DOCUMENT',
  /** Edit environments */
  EditEnvironment = 'EDIT_ENVIRONMENT',
  /** Edit tenants */
  EditTenant = 'EDIT_TENANT',
  /** Edit Tenant postal config */
  EditTenantPostalConfig = 'EDIT_TENANT_POSTAL_CONFIG',
  /** Grant internal user rights */
  GrantInternalRight = 'GRANT_INTERNAL_RIGHT',
  /** Grant user rights */
  GrantRight = 'GRANT_RIGHT',
  /** Read clicked link document */
  MarkDocumentAsRead = 'MARK_DOCUMENT_AS_READ',
  /** Get or list activities */
  ReadActivity = 'READ_ACTIVITY',
  /** Get or list callback configurations */
  ReadCallbackConfiguration = 'READ_CALLBACK_CONFIGURATION',
  /** Mark document as read */
  ReadClickedLinkDocument = 'READ_CLICKED_LINK_DOCUMENT',
  /** Get or list configurations */
  ReadConfiguration = 'READ_CONFIGURATION',
  /** Get or list contacts */
  ReadContact = 'READ_CONTACT',
  /** Get or list contact functions */
  ReadContactFunction = 'READ_CONTACT_FUNCTION',
  /** Get or list dashboards */
  ReadDashboard = 'READ_DASHBOARD',
  /** Get or list data file action */
  ReadDataFileAction = 'READ_DATA_FILE_ACTION',
  /** Get or list documents sent to the user */
  ReadDocument = 'READ_DOCUMENT',
  /** Get or list documentJobs */
  ReadDocumentJob = 'READ_DOCUMENT_JOB',
  /** Get or list documents sent to the service of the user */
  ReadDocumentOnService = 'READ_DOCUMENT_ON_SERVICE',
  /** Get or list document types */
  ReadDocumentType = 'READ_DOCUMENT_TYPE',
  /** Get or list domains */
  ReadDomain = 'READ_DOMAIN',
  /** Get or list Domain Api users */
  ReadDomainApiUser = 'READ_DOMAIN_API_USER',
  /** Get or list domain administrators */
  ReadDomainUser = 'READ_DOMAIN_USER',
  /** Get or list environments */
  ReadEnvironment = 'READ_ENVIRONMENT',
  /** Get or list Environment Api users */
  ReadEnvironmentApiUser = 'READ_ENVIRONMENT_API_USER',
  /** Get or list environment administrators */
  ReadEnvironmentUser = 'READ_ENVIRONMENT_USER',
  /** Get or list jobMessages */
  ReadJobMessage = 'READ_JOB_MESSAGE',
  /** Get or list legal entity */
  ReadLegalEntity = 'READ_LEGAL_ENTITY',
  /** Get or list list of values */
  ReadListOfValues = 'READ_LIST_OF_VALUES',
  /** Get or list metadatas */
  ReadMetadata = 'READ_METADATA',
  /** Get or list notes */
  ReadNote = 'READ_NOTE',
  /** Get or list OMS resources */
  ReadOmsResources = 'READ_OMS_RESOURCES',
  /** Get or list postalJobs */
  ReadPostalJob = 'READ_POSTAL_JOB',
  /** Get or list postal parameter configurations */
  ReadPostalParameterConfiguration = 'READ_POSTAL_PARAMETER_CONFIGURATION',
  /** Get or list products */
  ReadProduct = 'READ_PRODUCT',
  /** Get or list product installs */
  ReadProductInstall = 'READ_PRODUCT_INSTALL',
  /** List user rights */
  ReadRight = 'READ_RIGHT',
  /** Get or list api routing configurations */
  ReadRoutingConfiguration = 'READ_ROUTING_CONFIGURATION',
  /** Get or list services */
  ReadService = 'READ_SERVICE',
  /** Get or list status actions */
  ReadStatusAction = 'READ_STATUS_ACTION',
  /** Get or list structure */
  ReadStructure = 'READ_STRUCTURE',
  /** Get or list template contents */
  ReadTemplateContent = 'READ_TEMPLATE_CONTENT',
  /** Get or list template structures */
  ReadTemplateStructure = 'READ_TEMPLATE_STRUCTURE',
  /** Get or list template variables configuration */
  ReadTemplateVariableConfiguration = 'READ_TEMPLATE_VARIABLE_CONFIGURATION',
  /** Get or list tenants */
  ReadTenant = 'READ_TENANT',
  /** Get or list Api users */
  ReadTenantApiUser = 'READ_TENANT_API_USER',
  /** Get or list tenants with internal info */
  ReadTenantEdcOmsInfo = 'READ_TENANT_EDC_OMS_INFO',
  /** Get or list tenant users */
  ReadTenantUser = 'READ_TENANT_USER',
  /** Get or list third parties */
  ReadThirdParty = 'READ_THIRD_PARTY',
  /** Get or list third party types */
  ReadThirdPartyType = 'READ_THIRD_PARTY_TYPE',
  /** RelaunchJobMessage */
  RelaunchJobMessage = 'RELAUNCH_JOB_MESSAGE',
  /** Resend document to chorusRight */
  ResendDocument = 'RESEND_DOCUMENT',
  /** Synchronize EDC resources */
  SynchronizeEdcResources = 'SYNCHRONIZE_EDC_RESOURCES',
  /** Validate invited user */
  ValidateUser = 'VALIDATE_USER'
}

export type EnvironmentRightValue = {
  __typename?: 'EnvironmentRightValue';
  right?: Maybe<EnvironmentRightType>;
  value: Scalars['Boolean']['output'];
};

export type EnvironmentRightValueInput = {
  right?: InputMaybe<EnvironmentRightType>;
  value: Scalars['Boolean']['input'];
};

export type EnvironmentRightValueTypeConnection = {
  __typename?: 'EnvironmentRightValueTypeConnection';
  edges?: Maybe<Array<Maybe<EnvironmentRightValue>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type EnvironmentUser = {
  __typename?: 'EnvironmentUser';
  civility: Scalars['String']['output'];
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  creationUserLabel?: Maybe<Scalars['String']['output']>;
  culture: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  lastConnectionDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationUserId?: Maybe<Scalars['String']['output']>;
  lastModificationUserLabel?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  linkedOrganizations?: Maybe<Array<Maybe<LinkedOrganization>>>;
  phone: Scalars['String']['output'];
  timeZone: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type EnvironmentUserBoolFilter = {
  field: EnvironmentUserBoolFilterField;
  filterValue1: Scalars['Boolean']['input'];
  operator: BoolFilterOperator;
};

export enum EnvironmentUserBoolFilterField {
  IsEnabled = 'IS_ENABLED'
}

export type EnvironmentUserInput = {
  civility?: InputMaybe<Scalars['String']['input']>;
  culture?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  linkedOrganizations?: InputMaybe<Array<InputMaybe<LinkedOrganizationInput>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type EnvironmentUserQueryParams = {
  boolFilters?: InputMaybe<Array<InputMaybe<EnvironmentUserBoolFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<EnvironmentUserSortField>;
  stringFilters?: InputMaybe<Array<InputMaybe<EnvironmentUserStringFilter>>>;
};

export enum EnvironmentUserSortField {
  Civility = 'CIVILITY',
  Culture = 'CULTURE',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  IsEnabled = 'IS_ENABLED',
  LastName = 'LAST_NAME',
  Phone = 'PHONE',
  TimeZone = 'TIME_ZONE',
  UserId = 'USER_ID'
}

export type EnvironmentUserStringFilter = {
  field: EnvironmentUserStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum EnvironmentUserStringFilterField {
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  UserId = 'USER_ID'
}

export type EnvironmentUserTypeConnection = {
  __typename?: 'EnvironmentUserTypeConnection';
  edges?: Maybe<Array<Maybe<EnvironmentUser>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type ErrorQueueMessage = {
  __typename?: 'ErrorQueueMessage';
  action: EngineEventAction;
  errorCode: Scalars['Int']['output'];
  errorFunctionName?: Maybe<Scalars['String']['output']>;
  errorMessage: Scalars['String']['output'];
  errorServiceName?: Maybe<Scalars['String']['output']>;
  errorStackTrace: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
  resourceId?: Maybe<Scalars['String']['output']>;
  resourceType?: Maybe<ErrorQueueMessageResourceType>;
  status: ErrorQueueMessageStatus;
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
};

export enum ErrorQueueMessageActionFilterField {
  Action = 'ACTION'
}

export type ErrorQueueMessageEngineEventActionEnumFilter = {
  field: ErrorQueueMessageActionFilterField;
  filterValue1: EngineEventAction;
  filterValue2?: InputMaybe<EngineEventAction>;
  operator: NumberFilterOperator;
};

export type ErrorQueueMessageErrorQueueMessageResourceTypeEnumFilter = {
  field: ErrorQueueMessageResourceTypeFilterField;
  filterValue1: ErrorQueueMessageResourceType;
  filterValue2?: InputMaybe<ErrorQueueMessageResourceType>;
  operator: NumberFilterOperator;
};

export type ErrorQueueMessageErrorQueueMessageStatusEnumFilter = {
  field: ErrorQueueMessageStatusFilterField;
  filterValue1: ErrorQueueMessageStatus;
  filterValue2?: InputMaybe<ErrorQueueMessageStatus>;
  operator: NumberFilterOperator;
};

export type ErrorQueueMessageInput = {
  action: EngineEventAction;
  errorCode: Scalars['Int']['input'];
  errorFunctionName: Scalars['String']['input'];
  errorMessage: Scalars['String']['input'];
  errorServiceName: Scalars['String']['input'];
  errorStackTrace: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
  resourceType: ErrorQueueMessageResourceType;
  status: ErrorQueueMessageStatus;
  tenantId: Scalars['String']['input'];
  tenantName: Scalars['String']['input'];
};

export type ErrorQueueMessageIntFilter = {
  field: ErrorQueueMessageIntFilterField;
  filterValue1: Scalars['Int']['input'];
  filterValue2?: InputMaybe<Scalars['Int']['input']>;
  operator: NumberFilterOperator;
};

export enum ErrorQueueMessageIntFilterField {
  ErrorCode = 'ERROR_CODE'
}

export type ErrorQueueMessageQueryParams = {
  actionFilters?: InputMaybe<Array<InputMaybe<ErrorQueueMessageEngineEventActionEnumFilter>>>;
  intFilters?: InputMaybe<Array<InputMaybe<ErrorQueueMessageIntFilter>>>;
  resourceTypeFilters?: InputMaybe<Array<InputMaybe<ErrorQueueMessageErrorQueueMessageResourceTypeEnumFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<ErrorQueueMessageSortField>;
  statusFilters?: InputMaybe<Array<InputMaybe<ErrorQueueMessageErrorQueueMessageStatusEnumFilter>>>;
  stringFilters?: InputMaybe<Array<InputMaybe<ErrorQueueMessageStringFilter>>>;
};

export enum ErrorQueueMessageResourceType {
  ArchiveBatch = 'ARCHIVE_BATCH',
  Document = 'DOCUMENT',
  Job = 'JOB',
  JobMessage = 'JOB_MESSAGE',
  None = 'NONE'
}

export enum ErrorQueueMessageResourceTypeFilterField {
  ResourceType = 'RESOURCE_TYPE'
}

export enum ErrorQueueMessageSortField {
  Action = 'ACTION',
  ErrorCode = 'ERROR_CODE',
  ErrorFunctionName = 'ERROR_FUNCTION_NAME',
  ErrorMessage = 'ERROR_MESSAGE',
  ErrorServiceName = 'ERROR_SERVICE_NAME',
  ErrorStackTrace = 'ERROR_STACK_TRACE',
  JobId = 'JOB_ID',
  ResourceId = 'RESOURCE_ID',
  ResourceType = 'RESOURCE_TYPE',
  Status = 'STATUS',
  TenantId = 'TENANT_ID',
  TenantName = 'TENANT_NAME'
}

export enum ErrorQueueMessageStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  ToProcess = 'TO_PROCESS'
}

export enum ErrorQueueMessageStatusFilterField {
  Status = 'STATUS'
}

export type ErrorQueueMessageStringFilter = {
  field: ErrorQueueMessageStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum ErrorQueueMessageStringFilterField {
  ErrorFunctionName = 'ERROR_FUNCTION_NAME',
  ErrorMessage = 'ERROR_MESSAGE',
  ErrorServiceName = 'ERROR_SERVICE_NAME',
  ErrorStackTrace = 'ERROR_STACK_TRACE',
  JobId = 'JOB_ID',
  ResourceId = 'RESOURCE_ID',
  TenantId = 'TENANT_ID',
  TenantName = 'TENANT_NAME'
}

export type ErrorQueueMessageTypeConnection = {
  __typename?: 'ErrorQueueMessageTypeConnection';
  edges?: Maybe<Array<Maybe<ErrorQueueMessage>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type FaxJob = {
  adhocRecipientFiles?: InputMaybe<Array<InputMaybe<FileIdOrNewInputType>>>;
  adhocRecipients?: InputMaybe<Array<InputMaybe<Recipient>>>;
  deDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  documents?: InputMaybe<Array<InputMaybe<FileIdOrNewInputType>>>;
  jobType?: InputMaybe<JobBaseType>;
  parameter?: InputMaybe<FaxParameter>;
  scheduledStartTime?: InputMaybe<Scalars['DateTimeScalarType']['input']>;
  trackingId?: InputMaybe<Scalars['String']['input']>;
};

export enum FaxMode {
  Fine = 'FINE',
  Standard = 'STANDARD'
}

export type FaxParameter = {
  coverSheetMemo?: InputMaybe<Scalars['String']['input']>;
  csid?: InputMaybe<Scalars['String']['input']>;
  resolution?: InputMaybe<FaxMode>;
  shouldFaxEmailBody?: InputMaybe<Scalars['Boolean']['input']>;
  shouldSuppressFaxConversion?: InputMaybe<Scalars['Boolean']['input']>;
  useBadNumberDns?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileContent = {
  __typename?: 'FileContent';
  content: Scalars['String']['output'];
  creationDateTime?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationDateTime?: Maybe<Scalars['DateTimeScalarType']['output']>;
  name: Scalars['String']['output'];
  size: Scalars['Long']['output'];
};

export type FileContentInput = {
  content: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type FileHeader = {
  __typename?: 'FileHeader';
  creationDateTime?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationDateTime?: Maybe<Scalars['DateTimeScalarType']['output']>;
  name: Scalars['String']['output'];
  size: Scalars['Long']['output'];
};

export type FileHeaderTypeConnection = {
  __typename?: 'FileHeaderTypeConnection';
  edges?: Maybe<Array<Maybe<FileHeader>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type FileIdOrBase64Input = {
  base64?: InputMaybe<Scalars['String']['input']>;
  tempFileId?: InputMaybe<Scalars['String']['input']>;
};

export type FileIdOrNewInputType = {
  existingFileId?: InputMaybe<Scalars['String']['input']>;
  newFile?: InputMaybe<FileInputType>;
};

export type FileInputType = {
  base64?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  tempFileId?: InputMaybe<Scalars['String']['input']>;
};

export type FileReferenceBase = {
  content?: InputMaybe<Scalars['String']['input']>;
  hosted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type GedField = {
  __typename?: 'GedField';
  dataType?: Maybe<GedFieldDataType>;
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum GedFieldDataType {
  Bool = 'BOOL',
  Date = 'DATE',
  Decimal = 'DECIMAL',
  Double = 'DOUBLE',
  Integer = 'INTEGER',
  Password = 'PASSWORD',
  Sensitive = 'SENSITIVE',
  String = 'STRING'
}

export type GedFieldInput = {
  dataType?: InputMaybe<GedFieldDataType>;
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GeneratedFlow = {
  __typename?: 'GeneratedFlow';
  canal: Scalars['String']['output'];
  flowId: Scalars['String']['output'];
};

export type I18nFieldInput = {
  /** English translation */
  en?: InputMaybe<Scalars['String']['input']>;
  /** French translation */
  fr?: InputMaybe<Scalars['String']['input']>;
  /** UKN translation */
  ukn?: InputMaybe<Scalars['String']['input']>;
};

export type IdName = {
  __typename?: 'IdName';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type IdNameInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type IdNameType = {
  __typename?: 'IdNameType';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ActivityActorType>;
};

export type IncomingEmailHistory = {
  __typename?: 'IncomingEmailHistory';
  attachmentNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  errorString?: Maybe<Scalars['String']['output']>;
  from: Scalars['String']['output'];
  headerValues?: Maybe<Array<Maybe<KeyValuePair>>>;
  id?: Maybe<Scalars['String']['output']>;
  incomingEmailPath: Scalars['String']['output'];
  lastModificationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  routingConfigurationId: Scalars['String']['output'];
  status: ProcessingStatus;
  subject: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  to: Scalars['String']['output'];
  typeOfProcess: ProcessingType;
};

export type IncomingEmailHistoryDateFilter = {
  field: IncomingEmailHistoryDateFilterField;
  filterValue1?: InputMaybe<Scalars['DateTime']['input']>;
  filterValue2?: InputMaybe<Scalars['DateTime']['input']>;
  operator: NumberFilterOperator;
};

export enum IncomingEmailHistoryDateFilterField {
  CreationDate = 'CREATION_DATE'
}

export type IncomingEmailHistoryInput = {
  attachmentNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorString?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['String']['input'];
  headerValues?: InputMaybe<Array<InputMaybe<KeyValuePairInput>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  incomingEmailPath: Scalars['String']['input'];
  routingConfigurationId: Scalars['String']['input'];
  status: ProcessingStatus;
  subject: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  to: Scalars['String']['input'];
  typeOfProcess: ProcessingType;
};

export type IncomingEmailHistoryProcessingStatusEnumFilter = {
  field: IncomingEmailHistoryStatusFilterField;
  filterValue1: ProcessingStatus;
  filterValue2?: InputMaybe<ProcessingStatus>;
  operator: NumberFilterOperator;
};

export type IncomingEmailHistoryProcessingTypeEnumFilter = {
  field: IncomingEmailHistoryTypeFilterField;
  filterValue1: ProcessingType;
  filterValue2?: InputMaybe<ProcessingType>;
  operator: NumberFilterOperator;
};

export type IncomingEmailHistoryQueryParams = {
  dateFilters?: InputMaybe<Array<InputMaybe<IncomingEmailHistoryDateFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<IncomingEmailHistorySortField>;
  statusFilters?: InputMaybe<Array<InputMaybe<IncomingEmailHistoryProcessingStatusEnumFilter>>>;
  stringFilters?: InputMaybe<Array<InputMaybe<IncomingEmailHistoryStringFilter>>>;
  typeFilters?: InputMaybe<Array<InputMaybe<IncomingEmailHistoryProcessingTypeEnumFilter>>>;
};

export enum IncomingEmailHistorySortField {
  CreationDate = 'CREATION_DATE',
  From = 'FROM',
  Id = 'ID',
  IncomingEmailPath = 'INCOMING_EMAIL_PATH',
  Status = 'STATUS',
  Subject = 'SUBJECT',
  TenantId = 'TENANT_ID',
  To = 'TO',
  Type = 'TYPE'
}

export enum IncomingEmailHistoryStatusFilterField {
  Status = 'STATUS'
}

export type IncomingEmailHistoryStringFilter = {
  field: IncomingEmailHistoryStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum IncomingEmailHistoryStringFilterField {
  From = 'FROM',
  Id = 'ID',
  IncomingEmailPath = 'INCOMING_EMAIL_PATH',
  RoutingConfigurationId = 'ROUTING_CONFIGURATION_ID',
  Subject = 'SUBJECT',
  TenantId = 'TENANT_ID',
  To = 'TO'
}

export type IncomingEmailHistoryTypeConnection = {
  __typename?: 'IncomingEmailHistoryTypeConnection';
  edges?: Maybe<Array<Maybe<IncomingEmailHistory>>>;
  pageInfo?: Maybe<PageInfo>;
};

export enum IncomingEmailHistoryTypeFilterField {
  Type = 'TYPE'
}

export enum InheritedConfigurationOwnerType {
  DocumentType = 'DOCUMENT_TYPE',
  Domain = 'DOMAIN',
  LegalEntity = 'LEGAL_ENTITY',
  Nature = 'NATURE',
  Service = 'SERVICE',
  Structure = 'STRUCTURE',
  System = 'SYSTEM',
  Tenant = 'TENANT'
}

export type Job = {
  __typename?: 'Job';
  completedDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  documentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  domainId?: Maybe<Scalars['String']['output']>;
  failedCount: Scalars['Int']['output'];
  id?: Maybe<Scalars['String']['output']>;
  jobType?: Maybe<JobBaseType>;
  note?: Maybe<Scalars['String']['output']>;
  recipientCount: Scalars['Int']['output'];
  sentCount: Scalars['Int']['output'];
  serviceId?: Maybe<Scalars['String']['output']>;
  status: JobBaseStatus;
  structureId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  trackingId: Scalars['String']['output'];
};

export type JobActionOptions = {
  action: JobActionType;
};

export enum JobActionType {
  None = 'NONE'
}

export type JobBaseDateFilter = {
  field: JobDateFilterField;
  filterValue1?: InputMaybe<Scalars['DateTime']['input']>;
  filterValue2?: InputMaybe<Scalars['DateTime']['input']>;
  operator: NumberFilterOperator;
};

export type JobBaseJobBaseStatusEnumFilter = {
  field: JobStatusFilterField;
  filterValue1: JobBaseStatus;
  filterValue2?: InputMaybe<JobBaseStatus>;
  operator: NumberFilterOperator;
};

export type JobBaseJobBaseTypeEnumFilter = {
  field: JobTypeFilterField;
  filterValue1: JobBaseType;
  filterValue2?: InputMaybe<JobBaseType>;
  operator: NumberFilterOperator;
};

export enum JobBaseStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Error = 'ERROR',
  Processing = 'PROCESSING'
}

export type JobBaseStringFilter = {
  field: JobStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum JobBaseType {
  Chorus = 'CHORUS',
  DataFile = 'DATA_FILE',
  Document = 'DOCUMENT',
  DocumentProbative = 'DOCUMENT_PROBATIVE',
  Email = 'EMAIL',
  Fax = 'FAX',
  None = 'NONE',
  Postal = 'POSTAL',
  Push = 'PUSH',
  Sms = 'SMS',
  Voice = 'VOICE'
}

export type JobCountStatistics = {
  __typename?: 'JobCountStatistics';
  count: Scalars['Int']['output'];
};

export type JobCreationResult = {
  __typename?: 'JobCreationResult';
  attachments?: Maybe<Array<Maybe<DocumentInfo>>>;
  documents?: Maybe<Array<Maybe<DocumentInfo>>>;
  id: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  trackingId: Scalars['String']['output'];
  validationResult?: Maybe<DataFileValidationResult>;
};

export enum JobDateFilterField {
  CompletedDate = 'COMPLETED_DATE',
  CreationDate = 'CREATION_DATE'
}

export type JobMessage = {
  __typename?: 'JobMessage';
  chorusActionType?: Maybe<JobMessageChorusActionType>;
  chorusAddedAttachmentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  chorusB2GAddress?: Maybe<ChorusB2GAddress>;
  chorusConfig?: Maybe<ChorusB2GConfig>;
  chorusStatus?: Maybe<JobMessageChorusStatus>;
  contactId?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  creationUserLabel?: Maybe<Scalars['String']['output']>;
  directoryLineIdentifier?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Maybe<JobMessageDocument>>>;
  domainId?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  flowCategory?: Maybe<DocumentFlowCategory>;
  flowId?: Maybe<Scalars['String']['output']>;
  flowStatus?: Maybe<DocumentFlowStatus>;
  id?: Maybe<Scalars['String']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  jobId: Scalars['String']['output'];
  language?: Maybe<Scalars['String']['output']>;
  lastModificationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationUserId?: Maybe<Scalars['String']['output']>;
  lastModificationUserLabel?: Maybe<Scalars['String']['output']>;
  messageType: JobMessageType;
  name?: Maybe<Scalars['String']['output']>;
  postalAddress?: Maybe<PostalAddress>;
  postalParameter?: Maybe<PostalParameter>;
  readDocumentDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  recipientName: Scalars['String']['output'];
  recordedDeliveryNumber?: Maybe<Scalars['String']['output']>;
  retryCount: Scalars['Int']['output'];
  sendingMode?: Maybe<ContactSendingMode>;
  status: JobMessageStatus;
  structureId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  thirdPartyId?: Maybe<Scalars['String']['output']>;
  trackingId?: Maybe<Scalars['String']['output']>;
  transmissionMode?: Maybe<DocumentTransmissionMode>;
  transmissionStatus: JobMessageTransmissionStatus;
  validationErrors?: Maybe<Array<Maybe<ChorusB2GValidationError>>>;
};

export type JobMessageActionOptions = {
  action: JobMessageActionType;
};

export enum JobMessageActionType {
  Cancel = 'CANCEL'
}

export type JobMessageBaseDateFilter = {
  field: JobMessageDateFilterField;
  filterValue1?: InputMaybe<Scalars['DateTime']['input']>;
  filterValue2?: InputMaybe<Scalars['DateTime']['input']>;
  operator: NumberFilterOperator;
};

export type JobMessageBaseJobMessageStatusEnumFilter = {
  field: JobMessageStatusFilterField;
  filterValue1: JobMessageStatus;
  filterValue2?: InputMaybe<JobMessageStatus>;
  operator: NumberFilterOperator;
};

export type JobMessageBaseJobMessageTransmissionStatusEnumFilter = {
  field: JobMessageTransmissionStatusFilterField;
  filterValue1: JobMessageTransmissionStatus;
  filterValue2?: InputMaybe<JobMessageTransmissionStatus>;
  operator: NumberFilterOperator;
};

export type JobMessageBaseStringFilter = {
  field: JobMessageStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum JobMessageChorusActionType {
  Complete = 'COMPLETE',
  Send = 'SEND'
}

export enum JobMessageChorusStatus {
  AwaitingDocumentDepot = 'AWAITING_DOCUMENT_DEPOT',
  AwaitingProcessing = 'AWAITING_PROCESSING',
  AwaitingReProcessing = 'AWAITING_RE_PROCESSING',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Error = 'ERROR',
  Incidented = 'INCIDENTED',
  Integrated = 'INTEGRATED',
  InProcessing = 'IN_PROCESSING',
  MadeAvailableToTheAccountingOfficer = 'MADE_AVAILABLE_TO_THE_ACCOUNTING_OFFICER',
  MadeAvailableToTheFirstValidator = 'MADE_AVAILABLE_TO_THE_FIRST_VALIDATOR',
  MadeAvailableToTheRecipient = 'MADE_AVAILABLE_TO_THE_RECIPIENT',
  MadeAvailableToTheSecondValidator = 'MADE_AVAILABLE_TO_THE_SECOND_VALIDATOR',
  Mandated = 'MANDATED',
  PartiallyIntegrated = 'PARTIALLY_INTEGRATED',
  PostedInTheAccounts = 'POSTED_IN_THE_ACCOUNTS',
  Received = 'RECEIVED',
  Rejected = 'REJECTED',
  RejectedByFirstValidator = 'REJECTED_BY_FIRST_VALIDATOR',
  RejectedBySecondValidator = 'REJECTED_BY_SECOND_VALIDATOR',
  ReleasedForPayment = 'RELEASED_FOR_PAYMENT',
  ServiceRendered = 'SERVICE_RENDERED',
  Submited = 'SUBMITED',
  Suspended = 'SUSPENDED',
  TakenIntoAccountByTheRecipient = 'TAKEN_INTO_ACCOUNT_BY_THE_RECIPIENT',
  TransmissionInProgress = 'TRANSMISSION_IN_PROGRESS',
  TreatedSeCpp = 'TREATED_SE_CPP',
  Unknown = 'UNKNOWN',
  ValidatedByFirstValidator = 'VALIDATED_BY_FIRST_VALIDATOR',
  ValidatedBySecondValidator = 'VALIDATED_BY_SECOND_VALIDATOR',
  Validation_1OverTheDeadline = 'VALIDATION_1_OVER_THE_DEADLINE',
  Validation_2OverTheDeadline = 'VALIDATION_2_OVER_THE_DEADLINE',
  WrongReceiverInformations = 'WRONG_RECEIVER_INFORMATIONS',
  WrongValidatorByCocontractor = 'WRONG_VALIDATOR_BY_COCONTRACTOR',
  WrongValidatorBySupplier = 'WRONG_VALIDATOR_BY_SUPPLIER'
}

export enum JobMessageDateFilterField {
  CreationDate = 'CREATION_DATE'
}

export type JobMessageDocument = {
  __typename?: 'JobMessageDocument';
  attachmentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  documentId: Scalars['String']['output'];
};

export type JobMessageQueryParams = {
  dateFilters?: InputMaybe<Array<InputMaybe<JobMessageBaseDateFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<JobMessageSortField>;
  statusFilters?: InputMaybe<Array<InputMaybe<JobMessageBaseJobMessageStatusEnumFilter>>>;
  stringFilters?: InputMaybe<Array<InputMaybe<JobMessageBaseStringFilter>>>;
  transmissionStatusFilters?: InputMaybe<Array<InputMaybe<JobMessageBaseJobMessageTransmissionStatusEnumFilter>>>;
};

export enum JobMessageSortField {
  Id = 'ID',
  Name = 'NAME',
  TrackingId = 'TRACKING_ID'
}

export enum JobMessageStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Error = 'ERROR',
  Processing = 'PROCESSING'
}

export type JobMessageStatusCount = {
  __typename?: 'JobMessageStatusCount';
  canceledCount: Scalars['Int']['output'];
  completedCount: Scalars['Int']['output'];
  errorCount: Scalars['Int']['output'];
  isPrimary: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
  type: JobMessageType;
};

export enum JobMessageStatusFilterField {
  Status = 'STATUS'
}

export enum JobMessageStringFilterField {
  DocumentId = 'DOCUMENT_ID',
  DomainId = 'DOMAIN_ID',
  ExternalId = 'EXTERNAL_ID',
  JobId = 'JOB_ID',
  StructureId = 'STRUCTURE_ID',
  TenantId = 'TENANT_ID',
  TrackingId = 'TRACKING_ID'
}

export enum JobMessageTransmissionStatus {
  ExpiredCredentials = 'EXPIRED_CREDENTIALS',
  InvalidDocument = 'INVALID_DOCUMENT',
  IrrecevablePdpTransmissionError = 'IRRECEVABLE_PDP_TRANSMISSION_ERROR',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  StatusDelayExpired = 'STATUS_DELAY_EXPIRED',
  Success = 'SUCCESS',
  UnknownChorusB_2GTransmissionError = 'UNKNOWN_CHORUS_B_2_G_TRANSMISSION_ERROR',
  UnknownEmailTransmissionError = 'UNKNOWN_EMAIL_TRANSMISSION_ERROR',
  UnknownPostalTransmissionError = 'UNKNOWN_POSTAL_TRANSMISSION_ERROR',
  UnknownWebNotificationTransmissionError = 'UNKNOWN_WEB_NOTIFICATION_TRANSMISSION_ERROR',
  ValidationError = 'VALIDATION_ERROR',
  WrongDeliveryAddress = 'WRONG_DELIVERY_ADDRESS'
}

export enum JobMessageTransmissionStatusFilterField {
  TransmissionStatus = 'TRANSMISSION_STATUS'
}

export enum JobMessageType {
  Chorus = 'CHORUS',
  Email = 'EMAIL',
  Pdp = 'PDP',
  Peppol = 'PEPPOL',
  Postal = 'POSTAL',
  Ppf = 'PPF',
  Sign = 'SIGN',
  WebNotification = 'WEB_NOTIFICATION'
}

export type JobMessageTypeConnection = {
  __typename?: 'JobMessageTypeConnection';
  edges?: Maybe<Array<Maybe<JobMessage>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type JobQueryParams = {
  dateFilters?: InputMaybe<Array<InputMaybe<JobBaseDateFilter>>>;
  jobTypeFilters?: InputMaybe<Array<InputMaybe<JobBaseJobBaseTypeEnumFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<JobSortField>;
  statusFilters?: InputMaybe<Array<InputMaybe<JobBaseJobBaseStatusEnumFilter>>>;
  stringFilters?: InputMaybe<Array<InputMaybe<JobBaseStringFilter>>>;
};

export type JobResult = {
  __typename?: 'JobResult';
  jobNumber: Scalars['Int']['output'];
};

export enum JobSortField {
  CompletedDate = 'COMPLETED_DATE',
  CreationDate = 'CREATION_DATE',
  Id = 'ID',
  JobType = 'JOB_TYPE',
  ServiceId = 'SERVICE_ID',
  Status = 'STATUS',
  TrackingId = 'TRACKING_ID'
}

export enum JobStatusFilterField {
  Status = 'STATUS'
}

export enum JobStringFilterField {
  ServiceId = 'SERVICE_ID',
  StructureId = 'STRUCTURE_ID',
  TenantId = 'TENANT_ID',
  TrackingId = 'TRACKING_ID'
}

export type JobTypeConnection = {
  __typename?: 'JobTypeConnection';
  edges?: Maybe<Array<Maybe<Job>>>;
  pageInfo?: Maybe<PageInfo>;
};

export enum JobTypeFilterField {
  JobType = 'JOB_TYPE'
}

export type JobUnionType = DataFileActionJob | DocumentJob | DocumentProbativeJob | Job | PostalJob;

export type KeyValue = {
  __typename?: 'KeyValue';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type KeyValuePair = {
  __typename?: 'KeyValuePair';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type KeyValuePairInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum Language {
  En = 'EN',
  Fr = 'FR',
  Ukn = 'UKN'
}

export type LinkedOrganization = {
  __typename?: 'LinkedOrganization';
  id?: Maybe<Scalars['String']['output']>;
  restrictions?: Maybe<Array<Maybe<Restriction>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type LinkedOrganizationInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  restrictions?: InputMaybe<Array<InputMaybe<RestrictionInput>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ListInvoiceReport = {
  __typename?: 'ListInvoiceReport';
  failedAssert?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isFatal: Scalars['Boolean']['output'];
  listDiagnostic?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  location?: Maybe<Scalars['String']['output']>;
};

export enum LreArManagementType {
  Electronic = 'ELECTRONIC',
  Manual = 'MANUAL'
}

export type MetadataConfig = {
  __typename?: 'MetadataConfig';
  dataType: GedFieldDataType;
  defaultValue?: Maybe<Scalars['String']['output']>;
  expectedFormat?: Maybe<Scalars['String']['output']>;
  isArchivable: Scalars['Boolean']['output'];
  isEditable: Scalars['Boolean']['output'];
  isFilterable: Scalars['Boolean']['output'];
  isInternal: Scalars['Boolean']['output'];
  isMandatory: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  metadataCode: Scalars['String']['output'];
};

export type MetadataConfigInput = {
  dataType: GedFieldDataType;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  expectedFormat?: InputMaybe<Scalars['String']['input']>;
  isArchivable: Scalars['Boolean']['input'];
  isEditable: Scalars['Boolean']['input'];
  isFilterable: Scalars['Boolean']['input'];
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatory: Scalars['Boolean']['input'];
  metadataCode: Scalars['String']['input'];
};

export type MetadataValidationRule = {
  __typename?: 'MetadataValidationRule';
  metadataCodes: Array<Scalars['String']['output']>;
  operator: ValidationOperator;
  scope: ValidationScope;
  targetValue?: Maybe<Scalars['String']['output']>;
};

export type MetadataValidationRuleInput = {
  metadataCodes: Array<Scalars['String']['input']>;
  operator: ValidationOperator;
  scope: ValidationScope;
  targetValue?: InputMaybe<Scalars['String']['input']>;
};

export type Nature = {
  __typename?: 'Nature';
  code: Scalars['String']['output'];
  cycle: NatureCycle;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  metadataConfigs?: Maybe<Array<Maybe<MetadataConfig>>>;
  metadataValidationRules?: Maybe<Array<Maybe<MetadataValidationRule>>>;
  natureType: NatureCategory;
};

export enum NatureCategory {
  Configuration = 'CONFIGURATION',
  DocumentModel = 'DOCUMENT_MODEL',
  TransmissionMode = 'TRANSMISSION_MODE'
}

export enum NatureCycle {
  Misc = 'MISC',
  O_2C = 'O_2_C',
  P_2P = 'P_2_P',
  Report = 'REPORT'
}

export type NatureQueryParams = {
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<NatureSortField>;
};

export enum NatureSortField {
  Code = 'CODE',
  Label = 'LABEL'
}

export type NatureTypeConnection = {
  __typename?: 'NatureTypeConnection';
  edges?: Maybe<Array<Maybe<Nature>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type Note = {
  __typename?: 'Note';
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  creationUserLabel?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastModificationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationUserId?: Maybe<Scalars['String']['output']>;
  lastModificationUserLabel?: Maybe<Scalars['String']['output']>;
  ownerId: Scalars['String']['output'];
  ownerType: NoteOwnerType;
  text: Scalars['String']['output'];
};

export type NoteInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  ownerId: Scalars['String']['input'];
  ownerType: NoteOwnerType;
  text: Scalars['String']['input'];
};

export type NoteNoteOwnerTypeEnumFilter = {
  field: NoteOwnerTypeFilterField;
  filterValue1: NoteOwnerType;
  filterValue2?: InputMaybe<NoteOwnerType>;
  operator: NumberFilterOperator;
};

export enum NoteOwnerType {
  Service = 'SERVICE',
  ThirdParty = 'THIRD_PARTY'
}

export enum NoteOwnerTypeFilterField {
  OwnerType = 'OWNER_TYPE'
}

export type NoteQueryParams = {
  ownerTypeFilters?: InputMaybe<Array<InputMaybe<NoteNoteOwnerTypeEnumFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<NoteSortField>;
  stringFilters?: InputMaybe<Array<InputMaybe<NoteStringFilter>>>;
};

export enum NoteSortField {
  CreationDate = 'CREATION_DATE',
  LastModificationDate = 'LAST_MODIFICATION_DATE'
}

export type NoteStringFilter = {
  field: NoteStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum NoteStringFilterField {
  OwnerId = 'OWNER_ID',
  TenantId = 'TENANT_ID'
}

export type NoteTypeConnection = {
  __typename?: 'NoteTypeConnection';
  edges?: Maybe<Array<Maybe<Note>>>;
  pageInfo?: Maybe<PageInfo>;
};

export enum NumberFilterOperator {
  Between = 'BETWEEN',
  Defined = 'DEFINED',
  Equal = 'EQUAL',
  EqualOrUndefined = 'EQUAL_OR_UNDEFINED',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  LowerThan = 'LOWER_THAN',
  LowerThanOrEqual = 'LOWER_THAN_OR_EQUAL',
  NotEqual = 'NOT_EQUAL',
  Undefined = 'UNDEFINED'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PostalAddress = {
  __typename?: 'PostalAddress';
  additionalGeographicInfo?: Maybe<Scalars['String']['output']>;
  additionalInfo?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postBox?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type PostalAddressInput = {
  additionalGeographicInfo?: InputMaybe<Scalars['String']['input']>;
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postBox?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type PostalAdhocRecipientInput = {
  address?: InputMaybe<PostalAddressInput>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type PostalJob = {
  __typename?: 'PostalJob';
  completedDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  documentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  failedCount: Scalars['Int']['output'];
  id?: Maybe<Scalars['String']['output']>;
  jobType?: Maybe<JobBaseType>;
  note?: Maybe<Scalars['String']['output']>;
  recipientCount: Scalars['Int']['output'];
  sentCount: Scalars['Int']['output'];
  serviceId?: Maybe<Scalars['String']['output']>;
  status: JobBaseStatus;
  tenantId: Scalars['String']['output'];
  trackingId: Scalars['String']['output'];
  undeliveredCount: Scalars['Int']['output'];
};

export type PostalJobDateFilter = {
  field: JobDateFilterField;
  filterValue1?: InputMaybe<Scalars['DateTime']['input']>;
  filterValue2?: InputMaybe<Scalars['DateTime']['input']>;
  operator: NumberFilterOperator;
};

export type PostalJobInput = {
  adhocRecipientsFiles?: InputMaybe<Array<InputMaybe<FileIdOrNewInputType>>>;
  documents?: InputMaybe<Array<InputMaybe<FileIdOrNewInputType>>>;
  note?: InputMaybe<Scalars['String']['input']>;
  parameter?: InputMaybe<PostalParameterInput>;
  postalAdhocRecipients?: InputMaybe<Array<InputMaybe<PostalAdhocRecipientInput>>>;
  serviceId?: InputMaybe<Scalars['String']['input']>;
  trackingId?: InputMaybe<Scalars['String']['input']>;
};

export type PostalJobJobBaseStatusEnumFilter = {
  field: JobStatusFilterField;
  filterValue1: JobBaseStatus;
  filterValue2?: InputMaybe<JobBaseStatus>;
  operator: NumberFilterOperator;
};

export type PostalJobQueryParams = {
  dateFilters?: InputMaybe<Array<InputMaybe<PostalJobDateFilter>>>;
  jobTypeFilters?: InputMaybe<Array<InputMaybe<JobBaseJobBaseTypeEnumFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<JobSortField>;
  statusFilters?: InputMaybe<Array<InputMaybe<PostalJobJobBaseStatusEnumFilter>>>;
  stringFilters?: InputMaybe<Array<InputMaybe<PostalJobStringFilter>>>;
};

export type PostalJobStringFilter = {
  field: JobStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export type PostalJobTypeConnection = {
  __typename?: 'PostalJobTypeConnection';
  edges?: Maybe<Array<Maybe<PostalJob>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PostalParameter = {
  __typename?: 'PostalParameter';
  envelope?: Maybe<EnvelopeType>;
  lreArManagement?: Maybe<LreArManagementType>;
  mergeDocuments?: Maybe<Scalars['Boolean']['output']>;
  printBothSide?: Maybe<Scalars['Boolean']['output']>;
  printColor?: Maybe<Scalars['Boolean']['output']>;
  sender?: Maybe<PostalAddress>;
  stamp?: Maybe<StampType>;
};

export type PostalParameterInput = {
  envelope?: InputMaybe<EnvelopeType>;
  lreArManagement?: InputMaybe<LreArManagementType>;
  mergeDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  printBothSide?: InputMaybe<Scalars['Boolean']['input']>;
  printColor?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<PostalAddressInput>;
  stamp?: InputMaybe<StampType>;
};

export type PowerBiAuthToken = {
  __typename?: 'PowerBiAuthToken';
  accessToken: Scalars['String']['output'];
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  creationUserLabel?: Maybe<Scalars['String']['output']>;
  embedUrl: Scalars['String']['output'];
  lastModificationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationUserId?: Maybe<Scalars['String']['output']>;
  lastModificationUserLabel?: Maybe<Scalars['String']['output']>;
};

export enum ProcessingStatus {
  Completed = 'COMPLETED',
  Error = 'ERROR'
}

export enum ProcessingType {
  RedirectEmail = 'REDIRECT_EMAIL'
}

export type PushJob = {
  adhocRecipientFiles?: InputMaybe<Array<InputMaybe<FileIdOrNewInputType>>>;
  adhocRecipients?: InputMaybe<Array<InputMaybe<Recipient>>>;
  deDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  jobType?: InputMaybe<JobBaseType>;
  parameter?: InputMaybe<PushParameter>;
  scheduledStartTime?: InputMaybe<Scalars['DateTimeScalarType']['input']>;
  text: Scalars['String']['input'];
  trackingId?: InputMaybe<Scalars['String']['input']>;
};

export type PushParameter = {
  activateTracking?: InputMaybe<Scalars['Boolean']['input']>;
  applicationId?: InputMaybe<Scalars['Int']['input']>;
  badgeCount?: InputMaybe<Scalars['Int']['input']>;
  expirationDuration?: InputMaybe<Scalars['Int']['input']>;
  isByToken?: InputMaybe<Scalars['Boolean']['input']>;
  isSilent?: InputMaybe<Scalars['Boolean']['input']>;
  soundFileName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum ReasonCodeEnum {
  AdrErr = 'ADR_ERR',
  ArtErr = 'ART_ERR',
  Autre = 'AUTRE',
  CalculErr = 'CALCUL_ERR',
  CmdErr = 'CMD_ERR',
  CodeRoutageErr = 'CODE_ROUTAGE_ERR',
  ContratTerm = 'CONTRAT_TERM',
  CoordBancErr = 'COORD_BANC_ERR',
  DestErr = 'DEST_ERR',
  DoubleFact = 'DOUBLE_FACT',
  Doublon = 'DOUBLON',
  EmmetInc = 'EMMET_INC',
  IrrAntivirus = 'IRR_ANTIVIRUS',
  IrrExtDoc = 'IRR_EXT_DOC',
  IrrNomPj = 'IRR_NOM_PJ',
  IrrSyntax = 'IRR_SYNTAX',
  IrrTailleF = 'IRR_TAILLE_F',
  IrrTaillePj = 'IRR_TAILLE_PJ',
  IrrTypeF = 'IRR_TYPE_F',
  IrrVideF = 'IRR_VIDE_F',
  IrrVidPj = 'IRR_VID_PJ',
  JustifAbs = 'JUSTIF_ABS',
  LivrIncomp = 'LIVR_INCOMP',
  ModpaiErr = 'MODPAI_ERR',
  MontanttotalErr = 'MONTANTTOTAL_ERR',
  NonConforme = 'NON_CONFORME',
  NonTransmise = 'NON_TRANSMISE',
  PuErr = 'PU_ERR',
  QteErr = 'QTE_ERR',
  QualiteErr = 'QUALITE_ERR',
  RefCtAbsent = 'REF_CT_ABSENT',
  RefErr = 'REF_ERR',
  RemErr = 'REM_ERR',
  SiretErr = 'SIRET_ERR',
  TransacInc = 'TRANSAC_INC',
  TxTvaErr = 'TX_TVA_ERR'
}

export type Recipient = {
  address: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  optionalFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RegisteredPostalOptions = {
  __typename?: 'RegisteredPostalOptions';
  anonymous: Scalars['Boolean']['output'];
};

export type RegisteredPostalOptionsInput = {
  anonymous: Scalars['Boolean']['input'];
};

export type RelaunchJobMessageOptionsInput = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  domainId?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  jobMessageId?: InputMaybe<Scalars['String']['input']>;
  messageType?: InputMaybe<JobMessageType>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  transmissionStatus?: InputMaybe<JobMessageTransmissionStatus>;
};

export type ResponseDetail = {
  __typename?: 'ResponseDetail';
  ellapseTime?: Maybe<Scalars['String']['output']>;
  errorOnWarningOnly: Scalars['Boolean']['output'];
  fatalCount: Scalars['Int']['output'];
  fileFormat?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  formatSetByAUTO: Scalars['Boolean']['output'];
  invoiceFormat?: Maybe<Scalars['String']['output']>;
  listInvoiceReport?: Maybe<Array<Maybe<ListInvoiceReport>>>;
  resultPDFFormat?: Maybe<Scalars['String']['output']>;
  runXSDCheck: Scalars['Boolean']['output'];
  warningCount: Scalars['Int']['output'];
  xsdPath?: Maybe<Scalars['String']['output']>;
};

export type Restriction = {
  __typename?: 'Restriction';
  id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RestrictionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** The application rights action type. */
export enum RightActionType {
  Change = 'CHANGE',
  Read = 'READ'
}

export type RightInitialValue = {
  __typename?: 'RightInitialValue';
  actionType?: Maybe<RightActionType>;
  category?: Maybe<Scalars['String']['output']>;
  initialValue: Scalars['Boolean']['output'];
  right: RightType;
  subCategory?: Maybe<Scalars['String']['output']>;
};

export type RightInitialValueBoolFilter = {
  field: RightInitialValueBoolFilterField;
  filterValue1: Scalars['Boolean']['input'];
  operator: BoolFilterOperator;
};

export enum RightInitialValueBoolFilterField {
  InitialValue = 'INITIAL_VALUE'
}

export type RightInitialValueQueryParams = {
  boolFilters?: InputMaybe<Array<InputMaybe<RightInitialValueBoolFilter>>>;
  rightTypeFilters?: InputMaybe<Array<InputMaybe<RightInitialValueRightTypeEnumFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<RightInitialValueSortField>;
};

export type RightInitialValueRightTypeEnumFilter = {
  field: RightInitialValueRightTypeFilterField;
  filterValue1: RightType;
  filterValue2?: InputMaybe<RightType>;
  operator: NumberFilterOperator;
};

export enum RightInitialValueRightTypeFilterField {
  Right = 'RIGHT'
}

export enum RightInitialValueSortField {
  InitialValue = 'INITIAL_VALUE',
  Right = 'RIGHT'
}

export type RightInitialValueTypeConnection = {
  __typename?: 'RightInitialValueTypeConnection';
  edges?: Maybe<Array<Maybe<RightInitialValue>>>;
  pageInfo?: Maybe<PageInfo>;
};

/** The application rights. */
export enum RightType {
  /** Create environments */
  AddEnvironment = 'ADD_ENVIRONMENT',
  /** Create tenants */
  AddTenant = 'ADD_TENANT',
  /** CancelJobMessage */
  CancelJobMessage = 'CANCEL_JOB_MESSAGE',
  /** Create, edit or delete activities */
  ChangeActivity = 'CHANGE_ACTIVITY',
  /** Create, edit or delete callback configurations */
  ChangeCallbackConfiguration = 'CHANGE_CALLBACK_CONFIGURATION',
  /** Create, edit or delete document links */
  ChangeClickedLinkDocument = 'CHANGE_CLICKED_LINK_DOCUMENT',
  /** Create or edit configurations */
  ChangeConfiguration = 'CHANGE_CONFIGURATION',
  /** Create, edit or delete contacts */
  ChangeContact = 'CHANGE_CONTACT',
  /** Create, edit or delete contact functions */
  ChangeContactFunction = 'CHANGE_CONTACT_FUNCTION',
  /** Create, edit or delete dashboards */
  ChangeDashboard = 'CHANGE_DASHBOARD',
  /** Create, edit or delete data file action */
  ChangeDataFileAction = 'CHANGE_DATA_FILE_ACTION',
  /** Create, edit or delete documents */
  ChangeDocument = 'CHANGE_DOCUMENT',
  /** Create documentJob */
  ChangeDocumentJob = 'CHANGE_DOCUMENT_JOB',
  /** Create, edit or delete document types */
  ChangeDocumentType = 'CHANGE_DOCUMENT_TYPE',
  /** Create or edit domains */
  ChangeDomain = 'CHANGE_DOMAIN',
  /** Create, edit or renew Domain Api users */
  ChangeDomainApiUser = 'CHANGE_DOMAIN_API_USER',
  /** Create or edit domain administrators */
  ChangeDomainUser = 'CHANGE_DOMAIN_USER',
  /** Create, edit or renew Environment Api users */
  ChangeEnvironmentApiUser = 'CHANGE_ENVIRONMENT_API_USER',
  /** Create or edit environment administrators */
  ChangeEnvironmentUser = 'CHANGE_ENVIRONMENT_USER',
  /** Create, edit or delete jobMessage */
  ChangeJobMessage = 'CHANGE_JOB_MESSAGE',
  /** Create, edit or delete legal entity */
  ChangeLegalEntity = 'CHANGE_LEGAL_ENTITY',
  /** Create, edit or delete list of values */
  ChangeListOfValues = 'CHANGE_LIST_OF_VALUES',
  /** Create, edit or delete metadatas */
  ChangeMetadata = 'CHANGE_METADATA',
  /** Create or edit notes */
  ChangeNote = 'CHANGE_NOTE',
  /** Create or edit OMS resources */
  ChangeOmsResources = 'CHANGE_OMS_RESOURCES',
  /** Create postalJob */
  ChangePostalJob = 'CHANGE_POSTAL_JOB',
  /** Create, edit or delete postal parameter configurations */
  ChangePostalParameterConfiguration = 'CHANGE_POSTAL_PARAMETER_CONFIGURATION',
  /** Create or edit PowerBi auth token */
  ChangePowerBiAuthToken = 'CHANGE_POWER_BI_AUTH_TOKEN',
  /** Create or edit products */
  ChangeProduct = 'CHANGE_PRODUCT',
  /** Create or edit product installs */
  ChangeProductInstall = 'CHANGE_PRODUCT_INSTALL',
  /** Create, edit or delete api routing configurations */
  ChangeRoutingConfiguration = 'CHANGE_ROUTING_CONFIGURATION',
  /** Create, edit or delete services */
  ChangeService = 'CHANGE_SERVICE',
  /** Create, edit or delete structure */
  ChangeStructure = 'CHANGE_STRUCTURE',
  /** Create, edit or delete template contents */
  ChangeTemplateContent = 'CHANGE_TEMPLATE_CONTENT',
  /** Create, edit or delete template structures */
  ChangeTemplateStructure = 'CHANGE_TEMPLATE_STRUCTURE',
  /** Create, edit or delete template contents */
  ChangeTemplateVariableConfiguration = 'CHANGE_TEMPLATE_VARIABLE_CONFIGURATION',
  /** Create, edit or renew Api users */
  ChangeTenantApiUser = 'CHANGE_TENANT_API_USER',
  /** Create or edit tenant internal info */
  ChangeTenantEdcOmsInfo = 'CHANGE_TENANT_EDC_OMS_INFO',
  /** Create or edit tenant users */
  ChangeTenantUser = 'CHANGE_TENANT_USER',
  /** Create, edit or delete third parties */
  ChangeThirdParty = 'CHANGE_THIRD_PARTY',
  /** Create, edit or delete third party types */
  ChangeThirdPartyType = 'CHANGE_THIRD_PARTY_TYPE',
  /** Complete document */
  CompleteDocument = 'COMPLETE_DOCUMENT',
  /** Edit environments */
  EditEnvironment = 'EDIT_ENVIRONMENT',
  /** Edit tenants */
  EditTenant = 'EDIT_TENANT',
  /** Edit Tenant postal config */
  EditTenantPostalConfig = 'EDIT_TENANT_POSTAL_CONFIG',
  /** Grant internal user rights */
  GrantInternalRight = 'GRANT_INTERNAL_RIGHT',
  /** Grant user rights */
  GrantRight = 'GRANT_RIGHT',
  /** Read clicked link document */
  MarkDocumentAsRead = 'MARK_DOCUMENT_AS_READ',
  /** Get or list activities */
  ReadActivity = 'READ_ACTIVITY',
  /** Get or list callback configurations */
  ReadCallbackConfiguration = 'READ_CALLBACK_CONFIGURATION',
  /** Mark document as read */
  ReadClickedLinkDocument = 'READ_CLICKED_LINK_DOCUMENT',
  /** Get or list configurations */
  ReadConfiguration = 'READ_CONFIGURATION',
  /** Get or list contacts */
  ReadContact = 'READ_CONTACT',
  /** Get or list contact functions */
  ReadContactFunction = 'READ_CONTACT_FUNCTION',
  /** Get or list dashboards */
  ReadDashboard = 'READ_DASHBOARD',
  /** Get or list data file action */
  ReadDataFileAction = 'READ_DATA_FILE_ACTION',
  /** Get or list documents sent to the user */
  ReadDocument = 'READ_DOCUMENT',
  /** Get or list documentJobs */
  ReadDocumentJob = 'READ_DOCUMENT_JOB',
  /** Get or list documents sent to the service of the user */
  ReadDocumentOnService = 'READ_DOCUMENT_ON_SERVICE',
  /** Get or list document types */
  ReadDocumentType = 'READ_DOCUMENT_TYPE',
  /** Get or list domains */
  ReadDomain = 'READ_DOMAIN',
  /** Get or list Domain Api users */
  ReadDomainApiUser = 'READ_DOMAIN_API_USER',
  /** Get or list domain administrators */
  ReadDomainUser = 'READ_DOMAIN_USER',
  /** Get or list environments */
  ReadEnvironment = 'READ_ENVIRONMENT',
  /** Get or list Environment Api users */
  ReadEnvironmentApiUser = 'READ_ENVIRONMENT_API_USER',
  /** Get or list environment administrators */
  ReadEnvironmentUser = 'READ_ENVIRONMENT_USER',
  /** Get or list jobMessages */
  ReadJobMessage = 'READ_JOB_MESSAGE',
  /** Get or list legal entity */
  ReadLegalEntity = 'READ_LEGAL_ENTITY',
  /** Get or list list of values */
  ReadListOfValues = 'READ_LIST_OF_VALUES',
  /** Get or list metadatas */
  ReadMetadata = 'READ_METADATA',
  /** Get or list notes */
  ReadNote = 'READ_NOTE',
  /** Get or list OMS resources */
  ReadOmsResources = 'READ_OMS_RESOURCES',
  /** Get or list postalJobs */
  ReadPostalJob = 'READ_POSTAL_JOB',
  /** Get or list postal parameter configurations */
  ReadPostalParameterConfiguration = 'READ_POSTAL_PARAMETER_CONFIGURATION',
  /** Get or list products */
  ReadProduct = 'READ_PRODUCT',
  /** Get or list product installs */
  ReadProductInstall = 'READ_PRODUCT_INSTALL',
  /** List user rights */
  ReadRight = 'READ_RIGHT',
  /** Get or list api routing configurations */
  ReadRoutingConfiguration = 'READ_ROUTING_CONFIGURATION',
  /** Get or list services */
  ReadService = 'READ_SERVICE',
  /** Get or list status actions */
  ReadStatusAction = 'READ_STATUS_ACTION',
  /** Get or list structure */
  ReadStructure = 'READ_STRUCTURE',
  /** Get or list template contents */
  ReadTemplateContent = 'READ_TEMPLATE_CONTENT',
  /** Get or list template structures */
  ReadTemplateStructure = 'READ_TEMPLATE_STRUCTURE',
  /** Get or list template variables configuration */
  ReadTemplateVariableConfiguration = 'READ_TEMPLATE_VARIABLE_CONFIGURATION',
  /** Get or list tenants */
  ReadTenant = 'READ_TENANT',
  /** Get or list Api users */
  ReadTenantApiUser = 'READ_TENANT_API_USER',
  /** Get or list tenants with internal info */
  ReadTenantEdcOmsInfo = 'READ_TENANT_EDC_OMS_INFO',
  /** Get or list tenant users */
  ReadTenantUser = 'READ_TENANT_USER',
  /** Get or list third parties */
  ReadThirdParty = 'READ_THIRD_PARTY',
  /** Get or list third party types */
  ReadThirdPartyType = 'READ_THIRD_PARTY_TYPE',
  /** RelaunchJobMessage */
  RelaunchJobMessage = 'RELAUNCH_JOB_MESSAGE',
  /** Resend document to chorusRight */
  ResendDocument = 'RESEND_DOCUMENT',
  /** Synchronize EDC resources */
  SynchronizeEdcResources = 'SYNCHRONIZE_EDC_RESOURCES',
  /** Validate invited user */
  ValidateUser = 'VALIDATE_USER'
}

export type RightValueBoolFilter = {
  field: RightValueBoolFilterField;
  filterValue1: Scalars['Boolean']['input'];
  operator: BoolFilterOperator;
};

export enum RightValueBoolFilterField {
  Value = 'VALUE'
}

export type RightValueQueryParams = {
  boolFilters?: InputMaybe<Array<InputMaybe<RightValueBoolFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<RightValueSortField>;
};

export enum RightValueSortField {
  Right = 'RIGHT',
  Value = 'VALUE'
}

export type RoutingConfiguration = {
  __typename?: 'RoutingConfiguration';
  apiRoutingConfig?: Maybe<ApiRoutingConfiguration>;
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  creationUserLabel?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  lastModificationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationUserId?: Maybe<Scalars['String']['output']>;
  lastModificationUserLabel?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  ownerType: InheritedConfigurationOwnerType;
  queueName?: Maybe<Scalars['String']['output']>;
  smtpRoutingConfig?: Maybe<SmtpRoutingConfiguration>;
};

export type RoutingConfigurationBoolFilter = {
  field: RoutingConfigurationBoolFilterField;
  filterValue1: Scalars['Boolean']['input'];
  operator: BoolFilterOperator;
};

export enum RoutingConfigurationBoolFilterField {
  IsEnabled = 'IS_ENABLED'
}

export type RoutingConfigurationInheritedConfigurationOwnerTypeEnumFilter = {
  field: RoutingConfigurationOwnerTypeFilterField;
  filterValue1: InheritedConfigurationOwnerType;
  filterValue2?: InputMaybe<InheritedConfigurationOwnerType>;
  operator: NumberFilterOperator;
};

export type RoutingConfigurationInput = {
  apiRoutingConfig?: InputMaybe<ApiRoutingConfigurationInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  ownerType: InheritedConfigurationOwnerType;
  queueName: Scalars['String']['input'];
  smtpRoutingConfig?: InputMaybe<SmtpRoutingConfigurationInput>;
};

export enum RoutingConfigurationOwnerTypeFilterField {
  OwnerType = 'OWNER_TYPE'
}

export type RoutingConfigurationQueryParams = {
  boolFilters?: InputMaybe<Array<InputMaybe<RoutingConfigurationBoolFilter>>>;
  ownerTypeFilters?: InputMaybe<Array<InputMaybe<RoutingConfigurationInheritedConfigurationOwnerTypeEnumFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<RoutingConfigurationSortField>;
  stringFilters?: InputMaybe<Array<InputMaybe<RoutingConfigurationStringFilter>>>;
};

export enum RoutingConfigurationSortField {
  Action = 'ACTION',
  CreationDate = 'CREATION_DATE',
  Format = 'FORMAT',
  LastModificationDate = 'LAST_MODIFICATION_DATE',
  OwnerId = 'OWNER_ID',
  OwnerType = 'OWNER_TYPE',
  QueueName = 'QUEUE_NAME'
}

export type RoutingConfigurationStringFilter = {
  field: RoutingConfigurationStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum RoutingConfigurationStringFilterField {
  Action = 'ACTION',
  Format = 'FORMAT',
  OwnerId = 'OWNER_ID',
  QueueName = 'QUEUE_NAME'
}

export type RoutingConfigurationTypeConnection = {
  __typename?: 'RoutingConfigurationTypeConnection';
  edges?: Maybe<Array<Maybe<RoutingConfiguration>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type Service = {
  __typename?: 'Service';
  code?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  creationUserLabel?: Maybe<Scalars['String']['output']>;
  customSmtpConfig?: Maybe<SmtpConfig>;
  hasCustomSmtpConfig: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  lastModificationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationUserId?: Maybe<Scalars['String']['output']>;
  lastModificationUserLabel?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  tenantUserCount: Scalars['Int']['output'];
};

export type ServiceBoolFilter = {
  field: ServiceBoolFilterField;
  filterValue1: Scalars['Boolean']['input'];
  operator: BoolFilterOperator;
};

export enum ServiceBoolFilterField {
  HasCustomSmtpConfig = 'HAS_CUSTOM_SMTP_CONFIG',
  IsEnabled = 'IS_ENABLED'
}

export type ServiceInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  customSmtpConfig?: InputMaybe<SmtpConfigInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type ServiceIntFilter = {
  field: ServiceIntFilterField;
  filterValue1: Scalars['Int']['input'];
  filterValue2?: InputMaybe<Scalars['Int']['input']>;
  operator: NumberFilterOperator;
};

export enum ServiceIntFilterField {
  TenantUserCount = 'TENANT_USER_COUNT'
}

export type ServiceQueryParams = {
  boolFilters?: InputMaybe<Array<InputMaybe<ServiceBoolFilter>>>;
  intFilters?: InputMaybe<Array<InputMaybe<ServiceIntFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<ServiceSortField>;
  stringFilters?: InputMaybe<Array<InputMaybe<ServiceStringFilter>>>;
};

export enum ServiceSortField {
  HasCustomSmtpConfig = 'HAS_CUSTOM_SMTP_CONFIG',
  IsEnabled = 'IS_ENABLED',
  Name = 'NAME',
  TenantUserCount = 'TENANT_USER_COUNT'
}

export type ServiceStringFilter = {
  field: ServiceStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum ServiceStringFilterField {
  Name = 'NAME',
  TenantId = 'TENANT_ID'
}

export type ServiceTypeConnection = {
  __typename?: 'ServiceTypeConnection';
  edges?: Maybe<Array<Maybe<Service>>>;
  pageInfo?: Maybe<PageInfo>;
};

export enum SmsContentType {
  Binary = 'BINARY',
  Text = 'TEXT',
  Unicode = 'UNICODE'
}

export type SmsJob = {
  adhocRecipientFiles?: InputMaybe<Array<InputMaybe<FileIdOrNewInputType>>>;
  adhocRecipients?: InputMaybe<Array<InputMaybe<Recipient>>>;
  deDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  jobType?: InputMaybe<JobBaseType>;
  parameter?: InputMaybe<SmsParameter>;
  scheduledStartTime?: InputMaybe<Scalars['DateTimeScalarType']['input']>;
  text: Scalars['String']['input'];
  trackingId?: InputMaybe<Scalars['String']['input']>;
};

export type SmsParameter = {
  allowMultiPartition?: InputMaybe<Scalars['Boolean']['input']>;
  contentType?: InputMaybe<SmsContentType>;
  formsManagement?: InputMaybe<Scalars['Boolean']['input']>;
  lifeSpan?: InputMaybe<Scalars['Int']['input']>;
  maxPartition?: InputMaybe<Scalars['Int']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  shortUrl?: InputMaybe<Scalars['Boolean']['input']>;
  shortUrlGeotagging?: InputMaybe<Scalars['Boolean']['input']>;
  shortUrlTracking?: InputMaybe<Scalars['Boolean']['input']>;
  smsFlash?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SmtpConfig = {
  __typename?: 'SmtpConfig';
  errorAddress?: Maybe<Scalars['String']['output']>;
  hasSmtpSsl?: Maybe<Scalars['Boolean']['output']>;
  replyAddress?: Maybe<Scalars['String']['output']>;
  senderAddress?: Maybe<Scalars['String']['output']>;
  senderName?: Maybe<Scalars['String']['output']>;
  smtpLogin?: Maybe<Scalars['String']['output']>;
  smtpPassword?: Maybe<Scalars['String']['output']>;
  smtpPort?: Maybe<Scalars['Int']['output']>;
  smtpServer?: Maybe<Scalars['String']['output']>;
};

export type SmtpConfigInput = {
  errorAddress?: InputMaybe<Scalars['String']['input']>;
  hasSmtpSsl?: InputMaybe<Scalars['Boolean']['input']>;
  replyAddress?: InputMaybe<Scalars['String']['input']>;
  senderAddress: Scalars['String']['input'];
  senderName: Scalars['String']['input'];
  smtpLogin?: InputMaybe<Scalars['String']['input']>;
  smtpPassword?: InputMaybe<Scalars['String']['input']>;
  smtpPort?: InputMaybe<Scalars['Int']['input']>;
  smtpServer?: InputMaybe<Scalars['String']['input']>;
};

export type SmtpRoutingConfiguration = {
  __typename?: 'SmtpRoutingConfiguration';
  attachmentName: Scalars['String']['output'];
  attachmentRequired?: Maybe<Scalars['Boolean']['output']>;
  documentTypeId?: Maybe<Scalars['String']['output']>;
  froms?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  gedFieldsList?: Maybe<Array<Maybe<GedField>>>;
  headers?: Maybe<Array<Maybe<KeyValuePair>>>;
  maxAttachmentSize?: Maybe<Scalars['Int']['output']>;
  maxRejectCount?: Maybe<Scalars['Int']['output']>;
  nativePdfRequired?: Maybe<Scalars['Boolean']['output']>;
  sendFailureEmailNotification?: Maybe<Scalars['Boolean']['output']>;
  subject: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type SmtpRoutingConfigurationInput = {
  attachmentName: Scalars['String']['input'];
  attachmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  documentTypeId?: InputMaybe<Scalars['String']['input']>;
  froms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headers?: InputMaybe<Array<InputMaybe<KeyValuePairInput>>>;
  maxAttachmentSize?: InputMaybe<Scalars['Int']['input']>;
  maxRejectCount?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Array<InputMaybe<GedFieldInput>>>;
  nativePdfRequired?: InputMaybe<Scalars['Boolean']['input']>;
  sendFailureEmailNotification?: InputMaybe<Scalars['Boolean']['input']>;
  subject: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export enum SortDirection {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export enum StampType {
  Industriel = 'INDUSTRIEL',
  IndustrielJplus_4 = 'INDUSTRIEL_JPLUS_4',
  LettreVerte = 'LETTRE_VERTE',
  Normal = 'NORMAL',
  Recommande = 'RECOMMANDE'
}

export type StatusAction = {
  __typename?: 'StatusAction';
  action: Scalars['String']['output'];
  category: Scalars['String']['output'];
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastModificationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  status: Scalars['String']['output'];
};

export type StatusActionQueryParams = {
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<StatusActionSortField>;
  stringFilters?: InputMaybe<Array<InputMaybe<StatusActionStringFilter>>>;
};

export enum StatusActionSortField {
  Action = 'ACTION',
  Category = 'CATEGORY',
  Id = 'ID',
  Status = 'STATUS'
}

export type StatusActionStringFilter = {
  field: StatusActionStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum StatusActionStringFilterField {
  Action = 'ACTION',
  Category = 'CATEGORY',
  Id = 'ID',
  Status = 'STATUS'
}

export type StatusActionTypeConnection = {
  __typename?: 'StatusActionTypeConnection';
  edges?: Maybe<Array<Maybe<StatusAction>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type StatusCounts = {
  __typename?: 'StatusCounts';
  key: DocumentStatus;
  value: Scalars['Long']['output'];
};

export enum StringFilterOperator {
  Contain = 'CONTAIN',
  Defined = 'DEFINED',
  EndWith = 'END_WITH',
  Equal = 'EQUAL',
  EqualOrUndefined = 'EQUAL_OR_UNDEFINED',
  InArray = 'IN_ARRAY',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  NotContain = 'NOT_CONTAIN',
  NotEndWith = 'NOT_END_WITH',
  NotEqual = 'NOT_EQUAL',
  NotStartWith = 'NOT_START_WITH',
  StartWith = 'START_WITH',
  Undefined = 'UNDEFINED'
}

export type SubStatusCounts = {
  __typename?: 'SubStatusCounts';
  key: DocumentSubStatus;
  value: Scalars['Long']['output'];
};

export type TemplateContent = {
  __typename?: 'TemplateContent';
  content?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  notificationType: TemplateContentNotificationType;
  ownerId?: Maybe<Scalars['String']['output']>;
  ownerType: InheritedConfigurationOwnerType;
  subject?: Maybe<Scalars['String']['output']>;
  transmissionType: TemplateContentTransmissionType;
};

export type TemplateContentBoolFilter = {
  field: TemplateContentBoolFilterField;
  filterValue1: Scalars['Boolean']['input'];
  operator: BoolFilterOperator;
};

export enum TemplateContentBoolFilterField {
  IsEnabled = 'IS_ENABLED'
}

export type TemplateContentDateFilter = {
  field: TemplateContentDateFilterField;
  filterValue1?: InputMaybe<Scalars['DateTime']['input']>;
  filterValue2?: InputMaybe<Scalars['DateTime']['input']>;
  operator: NumberFilterOperator;
};

export enum TemplateContentDateFilterField {
  CreationDate = 'CREATION_DATE'
}

export type TemplateContentInheritedConfigurationOwnerTypeEnumFilter = {
  field: TemplateContentOwnerTypeFilterField;
  filterValue1: InheritedConfigurationOwnerType;
  filterValue2?: InputMaybe<InheritedConfigurationOwnerType>;
  operator: NumberFilterOperator;
};

export type TemplateContentInput = {
  content?: InputMaybe<I18nFieldInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  notificationType: TemplateContentNotificationType;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  ownerType: InheritedConfigurationOwnerType;
  subject?: InputMaybe<I18nFieldInput>;
  transmissionType: TemplateContentTransmissionType;
};

export enum TemplateContentNotificationType {
  ActivityAddAttachmentsDocument = 'ACTIVITY_ADD_ATTACHMENTS_DOCUMENT',
  ActivityAddDataFileAction = 'ACTIVITY_ADD_DATA_FILE_ACTION',
  ActivityCancelJobMessage = 'ACTIVITY_CANCEL_JOB_MESSAGE',
  ActivityChangeStatusChorusB_2G = 'ACTIVITY_CHANGE_STATUS_CHORUS_B_2_G',
  ActivityChangeStatusPostal = 'ACTIVITY_CHANGE_STATUS_POSTAL',
  ActivityCompleteChorusB_2G = 'ACTIVITY_COMPLETE_CHORUS_B_2_G',
  ActivityDocumentArchived = 'ACTIVITY_DOCUMENT_ARCHIVED',
  ActivityDocumentCanceled = 'ACTIVITY_DOCUMENT_CANCELED',
  ActivityDocumentRead = 'ACTIVITY_DOCUMENT_READ',
  ActivityDocumentSigned = 'ACTIVITY_DOCUMENT_SIGNED',
  ActivityEditMetadataDocument = 'ACTIVITY_EDIT_METADATA_DOCUMENT',
  ActivityError = 'ACTIVITY_ERROR',
  ActivityExternalProcess = 'ACTIVITY_EXTERNAL_PROCESS',
  ActivityJobCreated = 'ACTIVITY_JOB_CREATED',
  ActivityJobLaunched = 'ACTIVITY_JOB_LAUNCHED',
  ActivityJobPreProcessed = 'ACTIVITY_JOB_PRE_PROCESSED',
  ActivityJobProcessing = 'ACTIVITY_JOB_PROCESSING',
  ActivityNotificationSent = 'ACTIVITY_NOTIFICATION_SENT',
  ActivityRelaunchedJobMessage = 'ACTIVITY_RELAUNCHED_JOB_MESSAGE',
  ActivitySendChorusB_2G = 'ACTIVITY_SEND_CHORUS_B_2_G',
  ActivitySentPostal = 'ACTIVITY_SENT_POSTAL',
  AddUserToTenant = 'ADD_USER_TO_TENANT',
  CallbackAddAttachmentsDocument = 'CALLBACK_ADD_ATTACHMENTS_DOCUMENT',
  CallbackCancelJobMessage = 'CALLBACK_CANCEL_JOB_MESSAGE',
  CallbackChangeStatusChorusB_2G = 'CALLBACK_CHANGE_STATUS_CHORUS_B_2_G',
  CallbackCompleteChorusB_2G = 'CALLBACK_COMPLETE_CHORUS_B_2_G',
  CallbackDocumentArchived = 'CALLBACK_DOCUMENT_ARCHIVED',
  CallbackDocumentCanceled = 'CALLBACK_DOCUMENT_CANCELED',
  CallbackDocumentRead = 'CALLBACK_DOCUMENT_READ',
  CallbackDocumentSigned = 'CALLBACK_DOCUMENT_SIGNED',
  CallbackEditMetadataDocument = 'CALLBACK_EDIT_METADATA_DOCUMENT',
  CallbackExternalProcess = 'CALLBACK_EXTERNAL_PROCESS',
  CallbackJobCreated = 'CALLBACK_JOB_CREATED',
  CallbackJobLaunched = 'CALLBACK_JOB_LAUNCHED',
  CallbackJobPreProcessed = 'CALLBACK_JOB_PRE_PROCESSED',
  CallbackJobProcessing = 'CALLBACK_JOB_PROCESSING',
  CallbackNotificationSent = 'CALLBACK_NOTIFICATION_SENT',
  CallbackSendChorusB_2G = 'CALLBACK_SEND_CHORUS_B_2_G',
  DocumentNotification = 'DOCUMENT_NOTIFICATION',
  DocumentNotificationLink = 'DOCUMENT_NOTIFICATION_LINK',
  DocumentNotificationWithLink = 'DOCUMENT_NOTIFICATION_WITH_LINK',
  Ere = 'ERE',
  EreAnonymous = 'ERE_ANONYMOUS',
  InternalNotArchivedFiles = 'INTERNAL_NOT_ARCHIVED_FILES',
  InviteUser = 'INVITE_USER',
  Lse = 'LSE',
  LseAnonymous = 'LSE_ANONYMOUS',
  LseEreEndOfJob = 'LSE_ERE_END_OF_JOB',
  NewUserLogin = 'NEW_USER_LOGIN',
  NewUserPassword = 'NEW_USER_PASSWORD',
  RedirectEmailAttachmentErrorResponse = 'REDIRECT_EMAIL_ATTACHMENT_ERROR_RESPONSE',
  RedirectEmailAttachmentSizeErrorResponse = 'REDIRECT_EMAIL_ATTACHMENT_SIZE_ERROR_RESPONSE',
  RedirectEmailNoMatchingRoutingResponse = 'REDIRECT_EMAIL_NO_MATCHING_ROUTING_RESPONSE',
  RedirectEmailPdfErrorResponse = 'REDIRECT_EMAIL_PDF_ERROR_RESPONSE',
  RedirectEmailSizeErrorResponse = 'REDIRECT_EMAIL_SIZE_ERROR_RESPONSE',
  RedirectEmailSucceed = 'REDIRECT_EMAIL_SUCCEED',
  RedirectEmailThirdPartyErrorResponse = 'REDIRECT_EMAIL_THIRD_PARTY_ERROR_RESPONSE',
  RoutingEmailSucceed = 'ROUTING_EMAIL_SUCCEED'
}

export enum TemplateContentNotificationTypeFilterField {
  NotificationType = 'NOTIFICATION_TYPE'
}

export enum TemplateContentOwnerTypeFilterField {
  OwnerType = 'OWNER_TYPE'
}

export type TemplateContentQueryParams = {
  boolFilters?: InputMaybe<Array<InputMaybe<TemplateContentBoolFilter>>>;
  dateFilters?: InputMaybe<Array<InputMaybe<TemplateContentDateFilter>>>;
  notificationTypeFilters?: InputMaybe<Array<InputMaybe<TemplateContentTemplateContentNotificationTypeEnumFilter>>>;
  ownerTypeFilters?: InputMaybe<Array<InputMaybe<TemplateContentInheritedConfigurationOwnerTypeEnumFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<TemplateContentSortField>;
  stringFilters?: InputMaybe<Array<InputMaybe<TemplateContentStringFilter>>>;
  transmissionTypeFilters?: InputMaybe<Array<InputMaybe<TemplateContentTemplateContentTransmissionTypeEnumFilter>>>;
};

export enum TemplateContentSortField {
  CreationDate = 'CREATION_DATE',
  IsEnabled = 'IS_ENABLED',
  NotificationType = 'NOTIFICATION_TYPE',
  OwnerId = 'OWNER_ID',
  OwnerType = 'OWNER_TYPE',
  Subject = 'SUBJECT',
  TransmissionType = 'TRANSMISSION_TYPE'
}

export type TemplateContentStringFilter = {
  field: TemplateContentStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum TemplateContentStringFilterField {
  Id = 'ID',
  OwnerId = 'OWNER_ID',
  Subject = 'SUBJECT'
}

export type TemplateContentTemplateContentNotificationTypeEnumFilter = {
  field: TemplateContentNotificationTypeFilterField;
  filterValue1: TemplateContentNotificationType;
  filterValue2?: InputMaybe<TemplateContentNotificationType>;
  operator: NumberFilterOperator;
};

export type TemplateContentTemplateContentTransmissionTypeEnumFilter = {
  field: TemplateContentTransmissionTypeFilterField;
  filterValue1: TemplateContentTransmissionType;
  filterValue2?: InputMaybe<TemplateContentTransmissionType>;
  operator: NumberFilterOperator;
};

export enum TemplateContentTransmissionType {
  Email = 'EMAIL',
  Json = 'JSON',
  None = 'NONE',
  Sms = 'SMS',
  WebNotification = 'WEB_NOTIFICATION'
}

export enum TemplateContentTransmissionTypeFilterField {
  TransmissionType = 'TRANSMISSION_TYPE'
}

export type TemplateContentTypeConnection = {
  __typename?: 'TemplateContentTypeConnection';
  edges?: Maybe<Array<Maybe<TemplateContent>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type TemplateStructure = {
  __typename?: 'TemplateStructure';
  contentBase64?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  ownerId?: Maybe<Scalars['String']['output']>;
  ownerType: InheritedConfigurationOwnerType;
};

export type TemplateStructureBoolFilter = {
  field: TemplateStructureBoolFilterField;
  filterValue1: Scalars['Boolean']['input'];
  operator: BoolFilterOperator;
};

export enum TemplateStructureBoolFilterField {
  IsEnabled = 'IS_ENABLED'
}

export type TemplateStructureDateFilter = {
  field: TemplateStructureDateFilterField;
  filterValue1?: InputMaybe<Scalars['DateTime']['input']>;
  filterValue2?: InputMaybe<Scalars['DateTime']['input']>;
  operator: NumberFilterOperator;
};

export enum TemplateStructureDateFilterField {
  CreationDate = 'CREATION_DATE'
}

export type TemplateStructureInheritedConfigurationOwnerTypeEnumFilter = {
  field: TemplateStructureOwnerTypeFilterField;
  filterValue1: InheritedConfigurationOwnerType;
  filterValue2?: InputMaybe<InheritedConfigurationOwnerType>;
  operator: NumberFilterOperator;
};

export type TemplateStructureInput = {
  contentBase64: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  ownerId?: InputMaybe<Scalars['String']['input']>;
  ownerType: InheritedConfigurationOwnerType;
};

export enum TemplateStructureOwnerTypeFilterField {
  OwnerType = 'OWNER_TYPE'
}

export type TemplateStructureQueryParams = {
  boolFilters?: InputMaybe<Array<InputMaybe<TemplateStructureBoolFilter>>>;
  dateFilters?: InputMaybe<Array<InputMaybe<TemplateStructureDateFilter>>>;
  ownerTypeFilters?: InputMaybe<Array<InputMaybe<TemplateStructureInheritedConfigurationOwnerTypeEnumFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<TemplateStructureSortField>;
  stringFilters?: InputMaybe<Array<InputMaybe<TemplateStructureStringFilter>>>;
};

export enum TemplateStructureSortField {
  CreationDate = 'CREATION_DATE',
  IsEnabled = 'IS_ENABLED',
  OwnerId = 'OWNER_ID',
  OwnerType = 'OWNER_TYPE'
}

export type TemplateStructureStringFilter = {
  field: TemplateStructureStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum TemplateStructureStringFilterField {
  Id = 'ID',
  OwnerId = 'OWNER_ID'
}

export type TemplateStructureTypeConnection = {
  __typename?: 'TemplateStructureTypeConnection';
  edges?: Maybe<Array<Maybe<TemplateStructure>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type TemplateVariable = {
  __typename?: 'TemplateVariable';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  replacementTag: Scalars['String']['output'];
};

export type TemporaryDocumentFileInput = {
  file?: InputMaybe<FileContentInput>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

/** The application rights. */
export enum TenantRightType {
  /** Create environments */
  AddEnvironment = 'ADD_ENVIRONMENT',
  /** Create tenants */
  AddTenant = 'ADD_TENANT',
  /** CancelJobMessage */
  CancelJobMessage = 'CANCEL_JOB_MESSAGE',
  /** Create, edit or delete activities */
  ChangeActivity = 'CHANGE_ACTIVITY',
  /** Create, edit or delete callback configurations */
  ChangeCallbackConfiguration = 'CHANGE_CALLBACK_CONFIGURATION',
  /** Create, edit or delete document links */
  ChangeClickedLinkDocument = 'CHANGE_CLICKED_LINK_DOCUMENT',
  /** Create or edit configurations */
  ChangeConfiguration = 'CHANGE_CONFIGURATION',
  /** Create, edit or delete contacts */
  ChangeContact = 'CHANGE_CONTACT',
  /** Create, edit or delete contact functions */
  ChangeContactFunction = 'CHANGE_CONTACT_FUNCTION',
  /** Create, edit or delete dashboards */
  ChangeDashboard = 'CHANGE_DASHBOARD',
  /** Create, edit or delete data file action */
  ChangeDataFileAction = 'CHANGE_DATA_FILE_ACTION',
  /** Create, edit or delete documents */
  ChangeDocument = 'CHANGE_DOCUMENT',
  /** Create documentJob */
  ChangeDocumentJob = 'CHANGE_DOCUMENT_JOB',
  /** Create, edit or delete document types */
  ChangeDocumentType = 'CHANGE_DOCUMENT_TYPE',
  /** Create or edit domains */
  ChangeDomain = 'CHANGE_DOMAIN',
  /** Create, edit or renew Domain Api users */
  ChangeDomainApiUser = 'CHANGE_DOMAIN_API_USER',
  /** Create or edit domain administrators */
  ChangeDomainUser = 'CHANGE_DOMAIN_USER',
  /** Create, edit or renew Environment Api users */
  ChangeEnvironmentApiUser = 'CHANGE_ENVIRONMENT_API_USER',
  /** Create or edit environment administrators */
  ChangeEnvironmentUser = 'CHANGE_ENVIRONMENT_USER',
  /** Create, edit or delete jobMessage */
  ChangeJobMessage = 'CHANGE_JOB_MESSAGE',
  /** Create, edit or delete legal entity */
  ChangeLegalEntity = 'CHANGE_LEGAL_ENTITY',
  /** Create, edit or delete list of values */
  ChangeListOfValues = 'CHANGE_LIST_OF_VALUES',
  /** Create, edit or delete metadatas */
  ChangeMetadata = 'CHANGE_METADATA',
  /** Create or edit notes */
  ChangeNote = 'CHANGE_NOTE',
  /** Create or edit OMS resources */
  ChangeOmsResources = 'CHANGE_OMS_RESOURCES',
  /** Create postalJob */
  ChangePostalJob = 'CHANGE_POSTAL_JOB',
  /** Create, edit or delete postal parameter configurations */
  ChangePostalParameterConfiguration = 'CHANGE_POSTAL_PARAMETER_CONFIGURATION',
  /** Create or edit PowerBi auth token */
  ChangePowerBiAuthToken = 'CHANGE_POWER_BI_AUTH_TOKEN',
  /** Create or edit products */
  ChangeProduct = 'CHANGE_PRODUCT',
  /** Create or edit product installs */
  ChangeProductInstall = 'CHANGE_PRODUCT_INSTALL',
  /** Create, edit or delete api routing configurations */
  ChangeRoutingConfiguration = 'CHANGE_ROUTING_CONFIGURATION',
  /** Create, edit or delete services */
  ChangeService = 'CHANGE_SERVICE',
  /** Create, edit or delete structure */
  ChangeStructure = 'CHANGE_STRUCTURE',
  /** Create, edit or delete template contents */
  ChangeTemplateContent = 'CHANGE_TEMPLATE_CONTENT',
  /** Create, edit or delete template structures */
  ChangeTemplateStructure = 'CHANGE_TEMPLATE_STRUCTURE',
  /** Create, edit or delete template contents */
  ChangeTemplateVariableConfiguration = 'CHANGE_TEMPLATE_VARIABLE_CONFIGURATION',
  /** Create, edit or renew Api users */
  ChangeTenantApiUser = 'CHANGE_TENANT_API_USER',
  /** Create or edit tenant internal info */
  ChangeTenantEdcOmsInfo = 'CHANGE_TENANT_EDC_OMS_INFO',
  /** Create or edit tenant users */
  ChangeTenantUser = 'CHANGE_TENANT_USER',
  /** Create, edit or delete third parties */
  ChangeThirdParty = 'CHANGE_THIRD_PARTY',
  /** Create, edit or delete third party types */
  ChangeThirdPartyType = 'CHANGE_THIRD_PARTY_TYPE',
  /** Complete document */
  CompleteDocument = 'COMPLETE_DOCUMENT',
  /** Edit environments */
  EditEnvironment = 'EDIT_ENVIRONMENT',
  /** Edit tenants */
  EditTenant = 'EDIT_TENANT',
  /** Edit Tenant postal config */
  EditTenantPostalConfig = 'EDIT_TENANT_POSTAL_CONFIG',
  /** Grant internal user rights */
  GrantInternalRight = 'GRANT_INTERNAL_RIGHT',
  /** Grant user rights */
  GrantRight = 'GRANT_RIGHT',
  /** Read clicked link document */
  MarkDocumentAsRead = 'MARK_DOCUMENT_AS_READ',
  /** Get or list activities */
  ReadActivity = 'READ_ACTIVITY',
  /** Get or list callback configurations */
  ReadCallbackConfiguration = 'READ_CALLBACK_CONFIGURATION',
  /** Mark document as read */
  ReadClickedLinkDocument = 'READ_CLICKED_LINK_DOCUMENT',
  /** Get or list configurations */
  ReadConfiguration = 'READ_CONFIGURATION',
  /** Get or list contacts */
  ReadContact = 'READ_CONTACT',
  /** Get or list contact functions */
  ReadContactFunction = 'READ_CONTACT_FUNCTION',
  /** Get or list dashboards */
  ReadDashboard = 'READ_DASHBOARD',
  /** Get or list data file action */
  ReadDataFileAction = 'READ_DATA_FILE_ACTION',
  /** Get or list documents sent to the user */
  ReadDocument = 'READ_DOCUMENT',
  /** Get or list documentJobs */
  ReadDocumentJob = 'READ_DOCUMENT_JOB',
  /** Get or list documents sent to the service of the user */
  ReadDocumentOnService = 'READ_DOCUMENT_ON_SERVICE',
  /** Get or list document types */
  ReadDocumentType = 'READ_DOCUMENT_TYPE',
  /** Get or list domains */
  ReadDomain = 'READ_DOMAIN',
  /** Get or list Domain Api users */
  ReadDomainApiUser = 'READ_DOMAIN_API_USER',
  /** Get or list domain administrators */
  ReadDomainUser = 'READ_DOMAIN_USER',
  /** Get or list environments */
  ReadEnvironment = 'READ_ENVIRONMENT',
  /** Get or list Environment Api users */
  ReadEnvironmentApiUser = 'READ_ENVIRONMENT_API_USER',
  /** Get or list environment administrators */
  ReadEnvironmentUser = 'READ_ENVIRONMENT_USER',
  /** Get or list jobMessages */
  ReadJobMessage = 'READ_JOB_MESSAGE',
  /** Get or list legal entity */
  ReadLegalEntity = 'READ_LEGAL_ENTITY',
  /** Get or list list of values */
  ReadListOfValues = 'READ_LIST_OF_VALUES',
  /** Get or list metadatas */
  ReadMetadata = 'READ_METADATA',
  /** Get or list notes */
  ReadNote = 'READ_NOTE',
  /** Get or list OMS resources */
  ReadOmsResources = 'READ_OMS_RESOURCES',
  /** Get or list postalJobs */
  ReadPostalJob = 'READ_POSTAL_JOB',
  /** Get or list postal parameter configurations */
  ReadPostalParameterConfiguration = 'READ_POSTAL_PARAMETER_CONFIGURATION',
  /** Get or list products */
  ReadProduct = 'READ_PRODUCT',
  /** Get or list product installs */
  ReadProductInstall = 'READ_PRODUCT_INSTALL',
  /** List user rights */
  ReadRight = 'READ_RIGHT',
  /** Get or list api routing configurations */
  ReadRoutingConfiguration = 'READ_ROUTING_CONFIGURATION',
  /** Get or list services */
  ReadService = 'READ_SERVICE',
  /** Get or list status actions */
  ReadStatusAction = 'READ_STATUS_ACTION',
  /** Get or list structure */
  ReadStructure = 'READ_STRUCTURE',
  /** Get or list template contents */
  ReadTemplateContent = 'READ_TEMPLATE_CONTENT',
  /** Get or list template structures */
  ReadTemplateStructure = 'READ_TEMPLATE_STRUCTURE',
  /** Get or list template variables configuration */
  ReadTemplateVariableConfiguration = 'READ_TEMPLATE_VARIABLE_CONFIGURATION',
  /** Get or list tenants */
  ReadTenant = 'READ_TENANT',
  /** Get or list Api users */
  ReadTenantApiUser = 'READ_TENANT_API_USER',
  /** Get or list tenants with internal info */
  ReadTenantEdcOmsInfo = 'READ_TENANT_EDC_OMS_INFO',
  /** Get or list tenant users */
  ReadTenantUser = 'READ_TENANT_USER',
  /** Get or list third parties */
  ReadThirdParty = 'READ_THIRD_PARTY',
  /** Get or list third party types */
  ReadThirdPartyType = 'READ_THIRD_PARTY_TYPE',
  /** RelaunchJobMessage */
  RelaunchJobMessage = 'RELAUNCH_JOB_MESSAGE',
  /** Resend document to chorusRight */
  ResendDocument = 'RESEND_DOCUMENT',
  /** Synchronize EDC resources */
  SynchronizeEdcResources = 'SYNCHRONIZE_EDC_RESOURCES',
  /** Validate invited user */
  ValidateUser = 'VALIDATE_USER'
}

export type TenantRightValue = {
  __typename?: 'TenantRightValue';
  right?: Maybe<TenantRightType>;
  value: Scalars['Boolean']['output'];
};

export type TenantRightValueInput = {
  right?: InputMaybe<TenantRightType>;
  value: Scalars['Boolean']['input'];
};

export type TenantRightValueTypeConnection = {
  __typename?: 'TenantRightValueTypeConnection';
  edges?: Maybe<Array<Maybe<TenantRightValue>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type TenantUser = {
  __typename?: 'TenantUser';
  civility: Scalars['String']['output'];
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  creationUserLabel?: Maybe<Scalars['String']['output']>;
  culture: Scalars['String']['output'];
  documentAccessType: TenantUserDocumentAccessType;
  domainId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  lastConnectionDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationUserId?: Maybe<Scalars['String']['output']>;
  lastModificationUserLabel?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  linkedOrganizations?: Maybe<Array<Maybe<LinkedOrganization>>>;
  phone: Scalars['String']['output'];
  profile?: Maybe<UserProfile>;
  services?: Maybe<Array<Maybe<IdName>>>;
  structureId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  timeZone: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  weeklyReport: Scalars['Boolean']['output'];
};

export type TenantUserBoolFilter = {
  field: TenantUserBoolFilterField;
  filterValue1: Scalars['Boolean']['input'];
  operator: BoolFilterOperator;
};

export enum TenantUserBoolFilterField {
  IsEnabled = 'IS_ENABLED'
}

export enum TenantUserDocumentAccessType {
  Full = 'FULL',
  Restricted = 'RESTRICTED'
}

export type TenantUserInput = {
  civility?: InputMaybe<Scalars['String']['input']>;
  culture?: InputMaybe<Scalars['String']['input']>;
  documentAccessType?: InputMaybe<TenantUserDocumentAccessType>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  linkedOrganizations?: InputMaybe<Array<InputMaybe<LinkedOrganizationInput>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<UserProfile>;
  services?: InputMaybe<Array<InputMaybe<IdNameInput>>>;
  structureId?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  weeklyReport?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TenantUserQueryParams = {
  boolFilters?: InputMaybe<Array<InputMaybe<TenantUserBoolFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<TenantUserSortField>;
  stringFilters?: InputMaybe<Array<InputMaybe<TenantUserStringFilter>>>;
};

export enum TenantUserSortField {
  Civility = 'CIVILITY',
  CreationDate = 'CREATION_DATE',
  Culture = 'CULTURE',
  DocumentAccessType = 'DOCUMENT_ACCESS_TYPE',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  IsEnabled = 'IS_ENABLED',
  LastName = 'LAST_NAME',
  Phone = 'PHONE',
  TimeZone = 'TIME_ZONE',
  UserId = 'USER_ID',
  WeeklyReport = 'WEEKLY_REPORT'
}

export type TenantUserStringFilter = {
  field: TenantUserStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum TenantUserStringFilterField {
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  ServiceId = 'SERVICE_ID',
  StructureId = 'STRUCTURE_ID',
  TenantId = 'TENANT_ID',
  UserId = 'USER_ID'
}

export type TenantUserTypeConnection = {
  __typename?: 'TenantUserTypeConnection';
  edges?: Maybe<Array<Maybe<TenantUser>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type ThirdParty = {
  __typename?: 'ThirdParty';
  address?: Maybe<PostalAddress>;
  code: Scalars['String']['output'];
  contactCount: Scalars['Int']['output'];
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  creationUserLabel?: Maybe<Scalars['String']['output']>;
  domainId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  lastModificationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationUserId?: Maybe<Scalars['String']['output']>;
  lastModificationUserLabel?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  personType: ThirdPartyPersonType;
  structureId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  thirdPartyTypeIds: Array<Scalars['String']['output']>;
};

export type ThirdPartyBoolFilter = {
  field: ThirdPartyBoolFilterField;
  filterValue1: Scalars['Boolean']['input'];
  operator: BoolFilterOperator;
};

export enum ThirdPartyBoolFilterField {
  IsEnabled = 'IS_ENABLED',
  IsMoralPerson = 'IS_MORAL_PERSON'
}

export enum ThirdPartyIdentifierType {
  FromGedFields = 'FROM_GED_FIELDS',
  ThirdpartyId = 'THIRDPARTY_ID'
}

export type ThirdPartyInput = {
  address?: InputMaybe<PostalAddressInput>;
  code: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  personType: ThirdPartyPersonType;
  structureId?: InputMaybe<Scalars['String']['input']>;
  thirdPartyTypeIds: Array<Scalars['String']['input']>;
};

export enum ThirdPartyPersonType {
  MoralPersonPrivate = 'MORAL_PERSON_PRIVATE',
  MoralPersonPublic = 'MORAL_PERSON_PUBLIC',
  PrivatePerson = 'PRIVATE_PERSON'
}

export type ThirdPartyQueryParams = {
  boolFilters?: InputMaybe<Array<InputMaybe<ThirdPartyBoolFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<ThirdPartySortField>;
  stringFilters?: InputMaybe<Array<InputMaybe<ThirdPartyStringFilter>>>;
};

export type ThirdPartyRecipientInput = {
  contactFunctionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thirdPartyIdentifier: Scalars['String']['input'];
  thirdPartyIdentifierType: ThirdPartyIdentifierType;
  updateOptions?: InputMaybe<ThirdPartyUpdateOptionsInput>;
};

export enum ThirdPartySortField {
  Code = 'CODE',
  IsEnabled = 'IS_ENABLED',
  IsMoralPerson = 'IS_MORAL_PERSON',
  Name = 'NAME'
}

export type ThirdPartyStringFilter = {
  field: ThirdPartyStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum ThirdPartyStringFilterField {
  Code = 'CODE',
  Name = 'NAME',
  StructureId = 'STRUCTURE_ID',
  TenantId = 'TENANT_ID'
}

export type ThirdPartyType = {
  __typename?: 'ThirdPartyType';
  creationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  creationUserLabel?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  lastModificationDate?: Maybe<Scalars['DateTimeScalarType']['output']>;
  lastModificationUserId?: Maybe<Scalars['String']['output']>;
  lastModificationUserLabel?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  ownerType: ThirdPartyTypeOwnerType;
};

export type ThirdPartyTypeBoolFilter = {
  field: ThirdPartyTypeBoolFilterField;
  filterValue1: Scalars['Boolean']['input'];
  operator: BoolFilterOperator;
};

export enum ThirdPartyTypeBoolFilterField {
  IsEnabled = 'IS_ENABLED'
}

export type ThirdPartyTypeConnection = {
  __typename?: 'ThirdPartyTypeConnection';
  edges?: Maybe<Array<Maybe<ThirdParty>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type ThirdPartyTypeInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<I18nFieldInput>;
};

export enum ThirdPartyTypeOwnerType {
  System = 'SYSTEM',
  Tenant = 'TENANT'
}

export type ThirdPartyTypeQueryParams = {
  boolFilters?: InputMaybe<Array<InputMaybe<ThirdPartyTypeBoolFilter>>>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<ThirdPartyTypeSortField>;
  stringFilters?: InputMaybe<Array<InputMaybe<ThirdPartyTypeStringFilter>>>;
};

export enum ThirdPartyTypeSortField {
  IsEnabled = 'IS_ENABLED',
  Name = 'NAME'
}

export type ThirdPartyTypeStringFilter = {
  field: ThirdPartyTypeStringFilterField;
  filterValue1?: InputMaybe<Scalars['String']['input']>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringFilterOperator;
};

export enum ThirdPartyTypeStringFilterField {
  Name = 'NAME',
  OwnerId = 'OWNER_ID'
}

export type ThirdPartyTypeTypeConnection = {
  __typename?: 'ThirdPartyTypeTypeConnection';
  edges?: Maybe<Array<Maybe<ThirdPartyType>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type ThirdPartyUpdateOptionsInput = {
  createThirdParty: Scalars['Boolean']['input'];
};

export type TransitionDocumentStatusInput = {
  attachments?: InputMaybe<Array<InputMaybe<DocumentTransitionStatusAttachmentInput>>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['String']['input'];
  freezeDate?: InputMaybe<Scalars['DateTime']['input']>;
  reasonCode?: InputMaybe<ReasonCodeEnum>;
  requestedAction?: InputMaybe<Scalars['String']['input']>;
  requestedActionCode?: InputMaybe<Scalars['String']['input']>;
  targetStatus: AuthorizedStatusTargetInput;
};

export type TransitionStatusResponse = {
  __typename?: 'TransitionStatusResponse';
  documentId: Scalars['String']['output'];
  emitter?: Maybe<Scalars['String']['output']>;
  generatedFlows?: Maybe<Array<Maybe<GeneratedFlow>>>;
  newStatus: Scalars['Int']['output'];
  previousStatus: Scalars['Int']['output'];
};

export enum UserProfile {
  Administrator = 'ADMINISTRATOR',
  DomainAdministrator = 'DOMAIN_ADMINISTRATOR',
  DomainOperator = 'DOMAIN_OPERATOR',
  EnvironmentAdministrator = 'ENVIRONMENT_ADMINISTRATOR',
  StandardAdministrator = 'STANDARD_ADMINISTRATOR',
  StandardUser = 'STANDARD_USER',
  TenantReceiver = 'TENANT_RECEIVER',
  WebsiteAdministrator = 'WEBSITE_ADMINISTRATOR'
}

export enum ValidationOperator {
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NotEqual = 'NOT_EQUAL',
  Present = 'PRESENT'
}

export enum ValidationScope {
  All = 'ALL',
  AtLeastOne = 'AT_LEAST_ONE',
  None = 'NONE'
}

export type VoiceJob = {
  adhocRecipientFiles?: InputMaybe<Array<InputMaybe<FileIdOrNewInputType>>>;
  adhocRecipients?: InputMaybe<Array<InputMaybe<Recipient>>>;
  deDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  documents?: InputMaybe<Array<InputMaybe<FileIdOrNewInputType>>>;
  jobType?: InputMaybe<JobBaseType>;
  parameter?: InputMaybe<VoiceParameter>;
  scheduledStartTime?: InputMaybe<Scalars['DateTimeScalarType']['input']>;
  trackingId?: InputMaybe<Scalars['String']['input']>;
};

export type VoiceParameter = {
  acknowledgeKey?: InputMaybe<Scalars['String']['input']>;
  actionMessage?: InputMaybe<FileReferenceBase>;
  repeatKey?: InputMaybe<Scalars['String']['input']>;
  scenarioId?: InputMaybe<Scalars['Int']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  textToSpeechVoiceId?: InputMaybe<Scalars['Int']['input']>;
  textToSpeechVoiceRate?: InputMaybe<Scalars['Int']['input']>;
  transferKey?: InputMaybe<Scalars['String']['input']>;
  transferNumber?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowParameter = {
  __typename?: 'WorkflowParameter';
  code: Scalars['String']['output'];
  maxLength?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  type?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};
